import { applyWildShapeUpdate } from '../../../shared/rules/druid.mjs';
import { actionProneLimit } from '../../../shared/rules/beastForm';
import { isCriticalAttackRoll } from '../../../shared/rules/champion.mjs';
import OpenHandSavePrompt from '../components/OpenHandSavePrompt';
import UnarmedOptionsControls from '../components/UnarmedOptionsControls';
import FallingDamageControls from '../components/FallingDamageControls';
import {defenderDamageModifiers} from '../utils/reactions';
import { multiattackRequest } from '../utils/enemyMultiattackService';
import CampaignRestControls from '../components/CampaignRestControls';
import HeroicInspirationControls from '../components/HeroicInspirationControls';
import RollRequestControls from '../components/RollRequestControls';
import { applyRestSnapshot } from '../utils/restUpdates';
import UnplacedUnits from '../components/UnplacedUnits';
import DispositionControl from '../components/DispositionControl';
import { dispositionOf, dispositionLabel, dispositionColor } from '../../../shared/creatureDisposition';
import { resolveMonsterAttackRange } from '../../../shared/rules/weaponRange.mjs';
import { effectSize } from '../../../shared/rules/speciesTraits.mjs';
import { applyEffectSizes } from '../utils/effectTokenSizes';
import { withTemporaryHitPoints } from '../utils/temporaryHitPoints';
import { buildEnemyTargetingPreview } from '../utils/enemyTargetingPreview';
import { minimumFootprintDistanceFeet } from '../utils/pushGeometryCore.mjs';
import { combatantLabel } from '../../../shared/combatantNames.mjs';
import { CombatantNamesProvider } from '../components/CombatantNamesContext';
import CombatOrderControls, {useCombatOrderDrag} from '../components/CombatOrderControls';
import { savingThrowRollProfile } from '../../../shared/rules/savingThrowRollMode.mjs';
import { mergeRage } from '../../../shared/rules/barbarianRage.mjs';
import ExperienceAwards from '../components/ExperienceAwards';
import DmNotes from '../components/DmNotes';
import ObjectivesModal from '../components/ObjectivesModal';
import LootModal from '../components/LootModal';
import { FaStar, FaTools } from 'react-icons/fa';
import TacticalMindControls from '../components/TacticalMindControls';
import { applyFighterResourceUpdate } from '../../../shared/rules/fighter.mjs';
import { applyLayOnHandsUpdate } from '../../../shared/rules/paladin.mjs';
import { applyChannelDivinityUpdate } from '../../../shared/rules/channelDivinity.mjs';
import FastHandsControls from '../components/FastHandsControls';
import { formatResistanceReduction } from '../../../shared/rules/effects/resistanceDamage.mjs';
import { getRollDiceModifiers, modifierDiceGroups, modifierDiceTotal, readModifierDice, modifierDiceBreakdown, modifierDiceRecords } from '../../../shared/rules/effects/rollDiceModifiers.mjs';
import BaneSaveControls from '../components/BaneSaveControls';
import CommandTurnReminder from '../components/CommandTurnReminder';
import { getBuffCheckAdvantageSources } from '../../../shared/rules/effects/buffModifiers.mjs';
import EnemySpellcastingControls from '../components/EnemySpellcastingControls';
import BuffStatusControls from '../components/BuffStatusControls';
import { effectiveDarkvision } from '../../../shared/rules/effects/buffSpellDefinitions.mjs';
import DmConditionsTool from '../components/DmConditionsTool';
import DmSpellWallsTool from '../components/DmSpellWallsTool';
import DmPartiesTool from '../components/DmPartiesTool';
import ActionSavePrompt from '../components/ActionSavePrompt';
import WardSavePrompt, { passTargetingBlock } from '../components/WardSavePrompt';
import { exhaustionLevel } from '../../../shared/rules/effects/exhaustion.mjs';
import { incapacitatingEffects } from '../../../shared/rules/effects/dmConditions.mjs';
import { benefitsFromInvisible } from '../../../shared/rules/effects/invisibility.mjs';
import useSpellDamageFeedback, { SPELL_DAMAGE_FEEDBACK_EVENT, spellFeedbackKey, spellFeedbackPending } from '../hooks/useSpellDamageFeedback';
import useAutoDismiss from '../hooks/useAutoDismiss';
import DmRollLog, { useDmRollLog } from '../components/DmRollLog';
import useCombatEventRollLog from '../hooks/useCombatEventRollLog';
import { ROLL_DISPLAY_MS } from '../../../utils/rollDisplay';
import SpellSaveResults from '../components/SpellSaveResults';
import { bindSpellRefreshEvents } from '../utils/spellRefreshEvents';
import ConcentrationSaveControls from '../components/ConcentrationSaveControls';
import WebSpellControls from '../components/WebSpellControls';
import { saveRollDiceCount, selectSaveD20 } from '../../../shared/rules/effects/saveRollEvidence.mjs';
import CunningStrikeSavePrompt from '../components/CunningStrikeSavePrompt';
import { notify } from '../../../utils/notification';
import { notifyTargetSaveDamage } from '../utils/saveDamageNotification';
import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import apiFetch from '../../../utils/apiFetch';
import { DEFAULT_MAP_TITLE, getMapDisplayTitle } from '../../../utils/mapTitle';
import { io } from "socket.io-client";
import { mergeTokenPayload } from "./utils/mergeTokenPayload";
import {
  Button,
  Col,
  Form,
  Row,
  Container,
  Card,
  Alert,
  Spinner,
  Badge,
} from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import MapMaker from '../components/MapMaker';
import MapLibraryModal from '../components/MapLibraryModal';
import { NEW_FOLDER_OPTION_VALUE } from '../utils/mapFolders';
import Dropdown from 'react-bootstrap/Dropdown';
import { useNavigate, useParams } from "react-router-dom";
import loginbg from "../../../images/loginbg.png";
import useUser from '../../../hooks/useUser';
import { STATS } from '../statSchema';
import { SKILLS } from '../skillSchema';
import { calculateCharacterInitiative, calculatePassivePerception } from '../utils/derivedStats';
import { resolveInitiativeRollMode } from '../utils/barbarian';
import { calculateCharacterHitPoints, calculateCharacterMovementSpeed, resolveCombatantArmorClass } from '../utils/characterMetrics';
import { requestServerEndTurn } from '../utils/endTurnService';
import { createCombatState as normalizeTimelineState, undoTurn, requestEndTurn, getCanonicalCombatantIdentity, getActiveConditionsForCombatant, getEffectiveMovement, getEffectiveSpeed, removeActiveEffect } from '../utils/combatTimeline';
import { getWalkSpeed } from '../utils/movementCore.mjs';
import CampaignMapBoard from '../components/CombatMovementBoard';
import DamageDiceCanvas from '../attributes/DamageDiceCanvas';
import { calculateDamage, createCriticalDamageFormula } from '../attributes/PlayerTurnActions';
import { INACTIVE_COMBAT_TARGETING, resolveAttack } from '../utils/attackResolution';
import { consumeSapAttackRoll } from '../utils/sapStateService';
import { cachedOpportunityRoll } from '../utils/opportunityRollCache';
import OpportunityAttackPrompt from '../components/OpportunityAttackPrompt';
import { commitTargetedCombatSave, createDefenderReactionOpportunity, decideDefenderReaction, standUp } from '../utils/combatSaveStateService';
import { decideFateWindow, openFateWindow, syncFateWindows } from '../utils/fateWindowService';
import { decideCastWindow, openCastWindow, syncCastWindows } from '../utils/castWindowService';
import { decideCuttingWords, openCuttingWords, syncCuttingWords } from '../utils/cuttingWordsService';
import { SPELL_REFRESH_EVENT } from '../utils/spellRefreshEvents';
import { createTargetedSaveRequest, getCombatantSaveModifier, resolveTargetedSave } from '../utils/combatSavingThrows';
import { getStandUpCost, isProne } from '../utils/conditions';
import { processRetaliationDamageEvent } from '../utils/retaliation';
import { rollSkillWithDiceBox } from '../attributes/Skills';
import { rollDiceWithBox, setDiceBoxThemeColor } from '../../../utils/diceBoxManager';
import { bindCriticalRollTransport } from '../../../utils/criticalRolls';
import D20RollerModal, { DEFAULT_DICE_COLOR } from '../common/D20RollerModal';
import ShopVisibilityManager from '../attributes/ShopVisibilityManager';
import {
  GiCharacter,
  GiStoneAxe,
  GiBowArrow,
  GiBroadsword,
  GiCrossbow,
  GiCrossedSwords,
  GiLeatherArmor,
  GiBreastplate,
  GiChainMail,
  GiShield,
  GiArmorVest,
  GiBackpack,
  GiAmmoBox,
  GiPotionBall,
  GiHammerNails,
  GiHorseHead,
  GiSaddle,
  GiChariot,
  GiSailboat,
  GiTreasureMap,
  GiBattleAxe,
  GiLyre,
  GiHolyGrail,
  GiOakLeaf,
  GiMeditation,
  GiAngelWings,
  GiPineTree,
  GiSpy,
  GiFireball,
  GiPentagramRose,
  GiSpellBook,
} from "react-icons/gi";
import { FiPlus } from "react-icons/fi";
import { groupMapsByFolder } from "../utils/mapGrouping";
import { resolveFigurineImageData } from '../utils/figurineAssets';
import CustomPlayerTokens from '../components/CustomPlayerTokens';
import TokenPickerModal from '../components/TokenPickerModal';
import ActiveEnemyQuickList from '../components/ActiveEnemyQuickList';
import { enemiesForPanel, enemyMapTag, isEnemyOnMap } from '../utils/enemyMaps';
import CombatSavePrompt from '../components/CombatSavePrompt';
import CustomMonsterEditor from '../components/CustomMonsterEditor';
import CustomMonsterManager from '../components/CustomMonsterManager';
import CombatTurnHeader from '../components/CombatTurnHeader';
import { DeathStateBadge } from '../death/DyingStatePanel';
import { buildEnemyTokenFilterScopeValues, catalogedEnemyTokenFolder } from '../utils/enemyTokenFilters';
import { sanitizeIdentifierForTestId } from '../utils/sanitizeIdentifierForTestId';
import { getMultiattackPlan, isMultiattackAction } from '../utils/multiattackSequence';
import EnemyMultiattackControls from '../components/EnemyMultiattackControls';
import { createEnemyAttackTargeting, executeTargetedActions } from '../utils/enemyAttackTargeting';
import { createEnemySaveActionTargeting, getSupportedMonsterSaveAction } from '../utils/monsterSaveActions';
import { sanitizeRollGroup } from '../../../utils/diceResults';

const STAT_LOOKUP = STATS.reduce((acc, { key, label }) => {
  acc[label.toLowerCase()] = key;
  acc[key.toLowerCase()] = key;
  return acc;
}, {});

const STAT_LABELS = STATS.reduce((acc, { key, label }) => {
  acc[key] = label;
  return acc;
}, {});

const STAT_KEYS_ORDER = ['str', 'dex', 'con', 'int', 'wis', 'cha'];

const SKILL_LOOKUP = SKILLS.reduce((acc, { key, label }) => {
  acc[label.toLowerCase()] = key;
  acc[key.toLowerCase()] = key;
  return acc;
}, {});

const SKILL_LABELS = SKILLS.reduce((acc, { key, label }) => {
  acc[key] = label;
  return acc;
}, {});

const toTitleCase = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  return value
    .replace(/[_-]+/g, ' ')
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

// 2024 stat blocks print the Initiative modifier (Dexterity plus any proficiency). Older enemy snapshots and
// custom monsters have none and use the Dexterity modifier.
export const enemyInitiativeModifier = (enemy) => {
  if (Number.isFinite(enemy?.initiativeModifier)) return enemy.initiativeModifier;
  const dexScore = Number(enemy?.abilityScores?.dex) || Number(enemy?.dexterity) || 0;
  const modifier = Math.floor((dexScore - 10) / 2);
  return Number.isFinite(modifier) ? modifier : 0;
};

export const rollInitiativeD20 =({ rollD20 = () => Math.floor(Math.random() * 20) + 1, mode = 'normal' } = {}) => {
  const first = rollD20();
  if (mode !== 'advantage' && mode !== 'disadvantage') {
    return { rolls: [first], kept: first, mode: 'normal' };
  }

  const second = rollD20();
  const kept = mode === 'advantage' ? Math.max(first, second) : Math.min(first, second);
  return { rolls: [first, second], kept, mode };
};

const formatSignedModifier = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return null;
  }

  return numeric >= 0 ? `+${numeric}` : `${numeric}`;
};

const getStatLabel = (rawKey) => {
  if (!rawKey) {
    return '';
  }

  const normalized = String(rawKey).toLowerCase();
  const statKey = STAT_LOOKUP[normalized];
  if (statKey && STAT_LABELS[statKey]) {
    return STAT_LABELS[statKey];
  }

  return toTitleCase(String(rawKey));
};

const getSkillLabel = (rawKey) => {
  if (!rawKey) {
    return '';
  }

  const normalized = String(rawKey).toLowerCase();
  const skillKey = SKILL_LOOKUP[normalized];
  if (skillKey && SKILL_LABELS[skillKey]) {
    return SKILL_LABELS[skillKey];
  }

  return toTitleCase(String(rawKey));
};

const formatSavingThrowsDisplay = (savingThrows) => {
  if (!savingThrows) {
    return '—';
  }

  const entries = [];

  const pushEntry = (rawKey, rawValue) => {
    if (!rawKey) {
      return;
    }

    const label = getStatLabel(rawKey);
    const modifier = formatSignedModifier(rawValue);
    if (label && modifier) {
      entries.push(`${label} ${modifier}`);
    } else if (label) {
      entries.push(label);
    }
  };

  if (Array.isArray(savingThrows)) {
    savingThrows.forEach((entry) => {
      if (!entry) {
        return;
      }

      if (typeof entry === 'string') {
        entries.push(entry);
        return;
      }

      if (typeof entry === 'object') {
        if (entry.name !== undefined) {
          pushEntry(entry.name, entry.value);
          return;
        }

        const [firstKey] = Object.keys(entry);
        if (firstKey) {
          pushEntry(firstKey, entry[firstKey]);
        }
      }
    });
  } else if (typeof savingThrows === 'object') {
    Object.entries(savingThrows).forEach(([key, value]) => pushEntry(key, value));
  }

  return entries.length > 0 ? entries.join(', ') : '—';
};

const formatSkillsDisplay = (skills) => {
  if (!skills) {
    return '—';
  }

  const entries = [];

  const appendEntry = (rawKey, rawValue) => {
    if (!rawKey) {
      return;
    }

    const label = getSkillLabel(rawKey);
    const modifier = formatSignedModifier(rawValue);
    if (label && modifier) {
      entries.push(`${label} ${modifier}`);
    } else if (label) {
      entries.push(label);
    }
  };

  if (Array.isArray(skills)) {
    skills.forEach((entry) => {
      if (!entry) {
        return;
      }

      if (typeof entry === 'string') {
        entries.push(entry);
        return;
      }

      if (typeof entry === 'object') {
        if (entry.name !== undefined) {
          appendEntry(entry.name, entry.value);
          return;
        }

        const [firstKey] = Object.keys(entry);
        if (firstKey) {
          appendEntry(firstKey, entry[firstKey]);
        }
      }
    });
  } else if (typeof skills === 'object') {
    Object.entries(skills).forEach(([key, value]) => appendEntry(key, value));
  }

  return entries.length > 0 ? entries.join(', ') : '—';
};

const formatSensesDisplay = (senses) => {
  if (!senses) {
    return '—';
  }

  if (typeof senses === 'string') {
    const trimmed = senses.trim();
    return trimmed || '—';
  }

  if (typeof senses !== 'object') {
    return '—';
  }

  const entries = [];

  if (typeof senses.summary === 'string' && senses.summary.trim()) {
    entries.push(senses.summary.trim());
  }

  Object.entries(senses).forEach(([key, value]) => {
    if (key === 'summary' || value === null || value === undefined || value === '') {
      return;
    }

    if (key === 'passive_perception') {
      entries.push(`Passive Perception ${value}`);
      return;
    }

    entries.push(`${toTitleCase(key)} ${value}`);
  });

  return entries.length > 0 ? entries.join(', ') : '—';
};


const hasMovementSpeedSource = (entity) => {
  if (!entity || typeof entity !== 'object') {
    return false;
  }

  return [
    entity.speed,
    entity?.race?.speed,
    entity?.movementSpeed,
    entity?.walkingSpeed,
  ].some((value) => value !== undefined && value !== null && value !== '');
};

const isEnemyRecord = (entity) => entity?.entityType === 'enemy' ||
  (typeof entity?.enemyId === 'string' && entity.enemyId.trim() !== '');

export const getEntityMovementSpeed = (entity) => {
  if (!entity || typeof entity !== 'object') {
    return null;
  }

  if (!isEnemyRecord(entity)) {
    if (!hasMovementSpeedSource(entity)) {
      return null;
    }

    const movementSpeed = calculateCharacterMovementSpeed(entity);
    return Number.isFinite(movementSpeed) ? movementSpeed : null;
  }

  const movement = entity.speed ?? entity.movementSpeed ?? entity.walkingSpeed;
  return movement === undefined || movement === null || movement === '' ? null : getWalkSpeed(movement);
};

export const getEntityMovementSpeedDisplay = (entity, combatState, combatantId = entity?.enemyId || entity?.characterId || entity?._id || entity?.id) => {
  if (!entity || typeof entity !== 'object') {
    return '—';
  }

  if (isEnemyRecord(entity)) {
    return formatMovementSpeed(getEffectiveMovement(entity.speed, combatState, combatantId));
  }

  const movementSpeed = getEntityMovementSpeed(entity);
  return movementSpeed !== null ? `${getEffectiveSpeed(movementSpeed, combatState, combatantId)} ft` : '—';
};

const getEntityPassivePerception = (entity) => {
  if (!entity || typeof entity !== 'object') {
    return null;
  }

  if (entity.entityType !== 'enemy') {
    const totalLevel = Array.isArray(entity.occupation)
      ? entity.occupation.reduce((total, role) => total + (Number(role?.Level) || 0), 0)
      : undefined;
    const passivePerception = calculatePassivePerception(entity, totalLevel);
    return Number.isFinite(passivePerception) ? passivePerception : null;
  }

  const directCandidates = [
    entity.passivePerception,
    entity.passive_perception,
    entity.passive_perception_value,
    entity.passivePerceptionValue,
    entity.senses?.passive_perception,
    entity.senses?.passivePerception,
  ];

  for (const candidate of directCandidates) {
    const value = toFiniteNumberOrNull(candidate);
    if (value !== null) {
      return value;
    }
  }

  const sensesText = typeof entity.senses === 'string'
    ? entity.senses
    : typeof entity.senses?.summary === 'string'
      ? entity.senses.summary
      : '';
  const match = sensesText.match(/passive\s+perception\s*(\d+)/i);
  if (match) {
    const value = toFiniteNumberOrNull(match[1]);
    if (value !== null) {
      return value;
    }
  }

  return null;
};

const formatDamageTraitsDisplay = (traits) => {
  if (!traits) {
    return '—';
  }

  if (Array.isArray(traits)) {
    const values = traits
      .map((value) => (typeof value === 'string' ? value.trim() : ''))
      .filter(Boolean);
    return values.length > 0 ? values.join(', ') : '—';
  }

  if (typeof traits === 'string') {
    const trimmed = traits.trim();
    return trimmed || '—';
  }

  return '—';
};

const formatXpDisplay = (xp) => {
  const numeric = Number(xp);
  if (!Number.isFinite(numeric)) {
    return '—';
  }

  return numeric.toLocaleString();
};

const createEmptyCombatState = () => ({ participants: [], activeTurn: null });


const trimTrailingPunctuation = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  return value.trim().replace(/[.\s]+$/g, '');
};

const formatSpeedValue = (value) => {
  if (value === undefined || value === null || value === '') {
    return null;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? `${value} ft` : null;
  }

  if (typeof value === 'string') {
    const trimmed = trimTrailingPunctuation(value);
    if (!trimmed) {
      return null;
    }

    const numeric = Number(trimmed);
    if (Number.isFinite(numeric)) {
      return `${numeric} ft`;
    }

    return trimmed.replace(/\bfeet\b/gi, 'ft');
  }

  return null;
};

export const formatMovementSpeed = (speedData) => {
  if (speedData === undefined || speedData === null || speedData === '') {
    return '—';
  }

  if (typeof speedData === 'number') {
    return Number.isFinite(speedData) ? `${speedData} ft` : '—';
  }

  if (typeof speedData === 'string') {
    const trimmed = trimTrailingPunctuation(speedData);
    if (!trimmed) {
      return '—';
    }

    const modeMatch = trimmed.match(/^([a-z][a-z\s_-]*):\s*(.+)$/i);
    if (modeMatch) {
      const value = formatSpeedValue(modeMatch[2]);
      return value ? `${toTitleCase(modeMatch[1])}: ${value}` : '—';
    }

    const value = formatSpeedValue(trimmed);
    return value || '—';
  }

  if (Array.isArray(speedData)) {
    const entries = speedData
      .map((entry) => {
        if (!entry || typeof entry !== 'object') {
          return null;
        }

        const mode = entry.type || entry.mode || entry.name;
        const value = formatSpeedValue(entry.value ?? entry.speed ?? entry.distance);
        return mode && value ? `${toTitleCase(String(mode))}: ${value}` : null;
      })
      .filter(Boolean);

    return entries.length > 0 ? entries.join(', ') : '—';
  }

  if (typeof speedData === 'object') {
    const entries = Object.entries(speedData)
      .map(([mode, value]) => {
        const formattedValue = formatSpeedValue(value);
        return formattedValue ? `${toTitleCase(mode)}: ${formattedValue}` : null;
      })
      .filter(Boolean);

    return entries.length > 0 ? entries.join(', ') : '—';
  }

  return '—';
};

const toFiniteNumberOrNull = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const CREATURE_SIZE_KEYS = ['gargantuan', 'huge', 'large', 'medium', 'small', 'tiny'];
const MAP_GRID_DIMENSION_OPTIONS = [24, 64, 120];
const DEFAULT_MAP_GRID_DIMENSION = MAP_GRID_DIMENSION_OPTIONS[0];
// Grid choices in the map details and upload forms: the Map Maker sizes plus the larger upload sizes.
const MAP_GRID_CHOICES = [16, 24, 32, 64, 120];

const normalizeGridSquareCount = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric <= 0) {
    return null;
  }

  const roundedToPrecision = Number(numeric.toFixed(4));
  return Number.isInteger(roundedToPrecision) ? Math.trunc(roundedToPrecision) : roundedToPrecision;
};

const resolveAspectMatchedGridRows = (columns, imageWidth, imageHeight) => {
  const safeColumns = normalizeGridSquareCount(columns);
  const safeWidth = Number(imageWidth);
  const safeHeight = Number(imageHeight);

  if (safeColumns === null || !Number.isFinite(safeWidth) || !Number.isFinite(safeHeight)) {
    return safeColumns;
  }

  if (safeWidth <= 0 || safeHeight <= 0) {
    return safeColumns;
  }

  return normalizeGridSquareCount((safeColumns * safeHeight) / safeWidth) ?? safeColumns;
};

const formatGridDimensionString = (columns, rows) => `${columns}x${rows}`;

const loadMapEditorImageDimensions = (src, timeoutMs = 250) =>
  new Promise((resolve) => {
    let settled = false;
    let timeoutId = null;
    const finish = (value) => {
      if (settled) {
        return;
      }
      settled = true;
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }
      resolve(value);
    };
    if (typeof window === 'undefined' || typeof window.Image !== 'function') {
      finish(null);
      return;
    }

    if (typeof src !== 'string' || src.trim() === '') {
      finish(null);
      return;
    }

    timeoutId = window.setTimeout(() => finish(null), timeoutMs);

    const image = new window.Image();
    image.onload = () => {
      const width = Number(image.naturalWidth || image.width);
      const height = Number(image.naturalHeight || image.height);
      if (Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0) {
        finish({ width, height });
        return;
      }
      finish(null);
    };
    image.onerror = () => finish(null);
    image.src = src;
  });

const normalizeCreatureSize = (value) => {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim().toLowerCase();
  if (!trimmed) {
    return null;
  }

  const directMatch = CREATURE_SIZE_KEYS.find((size) => trimmed === size);
  if (directMatch) {
    return directMatch;
  }

  const tokens = trimmed.split(/[^a-z]+/).filter(Boolean);
  const tokenMatch = CREATURE_SIZE_KEYS.find((size) => tokens.includes(size));
  if (tokenMatch) {
    return tokenMatch;
  }

  const prefixMatch = CREATURE_SIZE_KEYS.find((size) => trimmed.startsWith(size));
  if (prefixMatch) {
    return prefixMatch;
  }

  return null;
};

const normalizeMapId = (value) =>
  typeof value === 'string' && value.trim() !== '' ? value.trim() : null;

const parseMapGridDimensionCandidate = (value) => {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === 'number' && Number.isFinite(value)) {
    const rounded = Math.round(value);
    return MAP_GRID_DIMENSION_OPTIONS.includes(rounded) ? rounded : null;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) {
      return null;
    }

    const pairMatch = trimmed.match(/(\d+)\s*[x×]/i);
    if (pairMatch) {
      const parsed = Number.parseInt(pairMatch[1], 10);
      if (Number.isFinite(parsed) && MAP_GRID_DIMENSION_OPTIONS.includes(parsed)) {
        return parsed;
      }
    }

    const numeric = Number.parseInt(trimmed, 10);
    if (Number.isFinite(numeric) && MAP_GRID_DIMENSION_OPTIONS.includes(numeric)) {
      return numeric;
    }
  }

  return null;
};

const resolveMapGridSelection = (map) => {
  if (!map || typeof map !== 'object') {
    return `${DEFAULT_MAP_GRID_DIMENSION}`;
  }

  const candidateValues = [
    map.gridColumns,
    map.gridRows,
    map.gridSize,
    map.gridDimensions,
    map.dimensions,
    map.size,
    map.mapSize,
  ];

  const nestedCandidates = [map.grid, map.meta, map.metadata, map.settings, map.details];

  nestedCandidates.forEach((entry) => {
    if (entry && typeof entry === 'object') {
      candidateValues.push(
        entry.columns,
        entry.rows,
        entry.size,
        entry.dimensions,
        entry.gridSize,
        entry.gridDimensions
      );
    }
  });

  for (const candidate of candidateValues) {
    const parsed = parseMapGridDimensionCandidate(candidate);
    if (parsed !== null) {
      return `${parsed}`;
    }
  }

  return `${DEFAULT_MAP_GRID_DIMENSION}`;
};

function EnemyCard({
  enemy,
  inCombat,
  mapTag = null,
  onMoveToMap,
  challengeText,
  sizeDisplay,
  armorClassDisplay,
  maxHpValue,
  resolvedCurrentHp,
  healthSummary,
  languagesDisplay,
  alignmentDisplay,
  speedDisplay,
  activeEffects = [],
  savingThrowsDisplay,
  skillsDisplay,
  sensesDisplay,
  xpDisplay,
  damageVulnerabilitiesDisplay,
  damageResistancesDisplay,
  damageImmunitiesDisplay,
  conditionImmunitiesDisplay,
  abilityScoreBadges,
  damagingActions,
  actionsList,
  bonusActionsList,
  reactionsList,
  legendaryActionsList,
  latestEnemyRoll,
  onEnemyDamageRoll,
  onEnemyAttackRoll,
  onEnemyAdjustmentInputChange,
  onApplyEnemyHealthAdjustment,
  onResetEnemyHealth,
  enemyHealthAdjustments,
  enemyHealthSaving,
  onToggleParticipant,
  onOpenMapPlacement,
  onChangeDisposition,
  onRemoveEnemy,
  removingEnemyId,
  formatAttackBonus,
  getEnemyActionDamageString,
  onEnemyMultiattackRoll,
  onEnemySaveAction,
}) {
  const [showAttacks, setShowAttacks] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  if (!enemy) {
    return null;
  }

  const adjustmentValue = enemy.enemyId ? enemyHealthAdjustments[enemy.enemyId] ?? '' : '';
  const isSavingHealth = enemy.enemyId ? Boolean(enemyHealthSaving[enemy.enemyId]) : false;
  const hasActions = Array.isArray(damagingActions) && damagingActions.length > 0;

  const renderActionSection = (label, actions, keyPrefix) => (
    <div className="enemy-card__detail-line enemy-card__detail-line--wrap">
      <span className="enemy-card__summary-label">{label}</span>
      {Array.isArray(actions) && actions.length > 0 ? (
        <div className="flex-grow-1 d-flex flex-column gap-2" style={{ minWidth: 0 }}>
          {actions.map((action, index) => {
            const actionKey = `${enemy.enemyId || 'enemy'}-${keyPrefix}-${index}`;
            const actionName = action?.name || label.replace(/:$/, '');
            const actionDesc = action?.desc;

            return (
              <div key={actionKey} className="d-flex flex-column gap-1">
                <div className="fw-semibold small text-body">{actionName}</div>
                {actionDesc ? (
                  <div className="small text-muted" style={{ whiteSpace: 'pre-line' }}>
                    {actionDesc}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      ) : (
        <span className="flex-grow-1" aria-hidden="true">
          —
        </span>
      )}
    </div>
  );

  let healthPercent = null;
  if (
    maxHpValue !== null &&
    maxHpValue > 0 &&
    resolvedCurrentHp !== null &&
    Number.isFinite(resolvedCurrentHp)
  ) {
    healthPercent = Math.max(0, Math.min(100, Math.round((resolvedCurrentHp / maxHpValue) * 100)));
  }

  const healthText = healthSummary;

  return (
    <Card className="resource-card h-100 w-100 text-start enemy-card d-flex flex-column">
      <Card.Body className="d-flex flex-column gap-2">
        <div>
          <Card.Title className="mb-1">{combatantLabel(enemy, { dm: true, fallback: 'Unnamed Enemy' })}</Card.Title>
          <Card.Subtitle className="text-muted small mb-2">
            {[enemy.displayType, challengeText].filter(Boolean).join(' • ') || '—'}
          </Card.Subtitle>
          <div className="enemy-card__summary">
            <div className="enemy-card__summary-line">
              <span className="enemy-card__summary-label">SIZE:</span>
              <span aria-hidden="true">{sizeDisplay}</span>
            </div>
            <div className="enemy-card__summary-line">
              <span className="enemy-card__summary-label">AC:</span>
              <span aria-hidden="true">{armorClassDisplay}</span>
            </div>
            {activeEffects.map((effect) => (
              <div className="enemy-card__summary-line" key={effect.id || effect.stackKey}>
                <span className="enemy-card__summary-label">EFFECT:</span>
                <span>{effect.name}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="enemy-card__health">
          <div
            className="enemy-card__health-bar"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={maxHpValue ?? undefined}
            aria-valuenow={resolvedCurrentHp ?? undefined}
          >
            <div
              className="enemy-card__health-bar-fill"
              style={{ width: `${healthPercent !== null ? healthPercent : resolvedCurrentHp !== null ? 100 : 0}%` }}
            />
          </div>
          <div className="enemy-card__health-text">{healthText}</div>
        </div>
        <div className="enemy-card__health-controls" role="group" aria-label="Enemy health controls">
          <Button
            variant="outline-danger"
            size="sm"
            className="enemy-card__health-button"
            onClick={() => onApplyEnemyHealthAdjustment(enemy.enemyId, -1)}
            disabled={isSavingHealth}
          >
            Damage
          </Button>
          <Form.Control
            value={adjustmentValue}
            onChange={(e) => onEnemyAdjustmentInputChange(enemy.enemyId, e.target.value)}
            placeholder="Amount"
            type="number"
            min="0"
            aria-label={`Adjust ${combatantLabel(enemy, { dm: true, fallback: 'enemy' })} health amount`}
            disabled={isSavingHealth}
            size="sm"
            className="enemy-card__health-input"
          />
          <Button
            variant="outline-success"
            size="sm"
            className="enemy-card__health-button"
            onClick={() => onApplyEnemyHealthAdjustment(enemy.enemyId, 1)}
            disabled={isSavingHealth}
          >
            Heal
          </Button>
          <Button
            variant="outline-light"
            size="sm"
            className="enemy-card__health-button enemy-card__health-button--reset"
            onClick={() => onResetEnemyHealth(enemy.enemyId)}
            disabled={isSavingHealth || maxHpValue === null}
          >
            Reset
          </Button>
        </div>
        <div className="enemy-card__controls">
          {hasActions && (
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => setShowAttacks((prev) => !prev)}
            >
              {showAttacks ? 'Hide Attacks' : 'Attacks'}
            </Button>
          )}
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => setShowDetails((prev) => !prev)}
          >
            {showDetails ? 'Hide Info' : 'More Info'}
          </Button>
        </div>
        {hasActions && showAttacks && (
          <div className="enemy-card__section">
            <h6 className="enemy-card__section-title text-uppercase text-muted small fw-semibold mb-2">
              Attacks
            </h6>
            <div className="attack-card-grid enemy-card__attack-grid">
              {damagingActions.map((action, actionIndex) => {
                const actionLabel = action?.name || 'Action';
                const attackBonusDisplay = formatAttackBonus(action?.attack_bonus);
                const damageLine = getEnemyActionDamageString(action);
                const actionKey = `${enemy.enemyId || 'enemy'}-${actionLabel}-${actionIndex}`;
                const isLatestRoll =
                  latestEnemyRoll?.enemyId === enemy.enemyId &&
                  latestEnemyRoll?.actionName === actionLabel;
                const isMultiattack = isMultiattackAction(action);
                const multiattackPlan = isMultiattack ? getMultiattackPlan(enemy, action) : null;
                const saveAction = getSupportedMonsterSaveAction(enemy, action);

                return (
                  <div key={actionKey} className="attack-card enemy-card__attack-card">
                    <div className="attack-card__title">{actionLabel}</div>
                    <div className="attack-card__details">
                      {saveAction ? <div className="attack-card__row">
                        <span className="attack-card__value">{saveAction.saveLabel} • {saveAction.rechargeLabel}</span>
                      </div> : <div className="attack-card__row">
                        <span className="attack-card__label">Attack Bonus</span>
                        <span className="attack-card__value">{attackBonusDisplay ?? '—'}</span>
                      </div>}
                      <div className="attack-card__row">
                        <span className="attack-card__label">Damage</span>
                        <span className="attack-card__value">{damageLine || '—'}</span>
                      </div>
                    </div>
                    <div className="attack-card__actions">
                      {saveAction ? <Button className="combat-roll-button combat-roll-button--attack" onClick={() => onEnemySaveAction(enemy, action)}>Use Save Action</Button> : isMultiattack ? <Button className="combat-roll-button combat-roll-button--attack" disabled={!multiattackPlan.supported} title={multiattackPlan.reason} onClick={() => onEnemyMultiattackRoll(enemy, action)} aria-label="Multiattack">Multiattack</Button> : <>
                      <Button
                        className="combat-roll-button combat-roll-button--attack"
                        onClick={() => onEnemyAttackRoll(enemy, action)}
                        aria-label={`Roll attack for ${actionLabel}`}
                      >
                        🎲 Roll Attack
                      </Button>
                      <Button
                        className="combat-roll-button"
                        onClick={() => onEnemyDamageRoll(enemy, action)}
                        aria-label={`Roll damage for ${actionLabel}`}
                      >
                        💥 Roll Damage
                      </Button>
                      </>}
                    </div>
                    {isMultiattack && !multiattackPlan.supported && <small>{multiattackPlan.reason}</small>}
                    {isLatestRoll && latestEnemyRoll?.breakdown && (
                      <div className="mt-2 small fw-semibold text-primary" role="status">
                        <div>{`${latestEnemyRoll.rollType === 'attack' ? 'Attack' : 'Damage'}: ${latestEnemyRoll.total} (${latestEnemyRoll.breakdown})`}</div>
                        {latestEnemyRoll.targetName && <div>{`Target: ${latestEnemyRoll.targetName} • AC ${latestEnemyRoll.targetArmorClass}${latestEnemyRoll.cover ? ` (${latestEnemyRoll.cover.label} +${latestEnemyRoll.cover.bonus})` : ''} • ${latestEnemyRoll.outcome === 'critical-hit' ? 'Critical Hit' : latestEnemyRoll.outcome === 'hit' ? 'Hit' : 'Miss'}`}</div>}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {showDetails && (
          <div className="enemy-card__section">
            <div className="enemy-card__section-subtitle">Ability Scores</div>
            <div className="d-flex flex-wrap gap-2">
              {abilityScoreBadges.map(({ key, value }) => (
                <span key={`${enemy.enemyId}-${key}`} className="badge bg-secondary">
                  {value}
                </span>
              ))}
            </div>
            <div className="border-top border-secondary opacity-25 my-3" aria-hidden="true" />
            <div className="enemy-card__detail-grid">
              <div className="enemy-card__detail-line enemy-card__detail-line--wrap">
                <span className="enemy-card__summary-label">Speed:</span>
                <span aria-hidden="true">{speedDisplay}</span>
              </div>
              <div className="enemy-card__detail-line enemy-card__detail-line--wrap">
                <span className="enemy-card__summary-label">Saving Throws:</span>
                <span aria-hidden="true">{savingThrowsDisplay}</span>
              </div>
              <div className="enemy-card__detail-line enemy-card__detail-line--wrap">
                <span className="enemy-card__summary-label">Skills:</span>
                <span aria-hidden="true">{skillsDisplay}</span>
              </div>
              <div className="enemy-card__detail-line enemy-card__detail-line--wrap">
                <span className="enemy-card__summary-label">Senses:</span>
                <span aria-hidden="true">{sensesDisplay}</span>
              </div>
              <div className="enemy-card__detail-line enemy-card__detail-line--wrap">
                <span className="enemy-card__summary-label">Damage Vulnerabilities:</span>
                <span aria-hidden="true">{damageVulnerabilitiesDisplay}</span>
              </div>
              <div className="enemy-card__detail-line enemy-card__detail-line--wrap">
                <span className="enemy-card__summary-label">Damage Resistances:</span>
                <span aria-hidden="true">{damageResistancesDisplay}</span>
              </div>
              <div className="enemy-card__detail-line enemy-card__detail-line--wrap">
                <span className="enemy-card__summary-label">Damage Immunities:</span>
                <span aria-hidden="true">{damageImmunitiesDisplay}</span>
              </div>
              <div className="enemy-card__detail-line enemy-card__detail-line--wrap">
                <span className="enemy-card__summary-label">Condition Immunities:</span>
                <span aria-hidden="true">{conditionImmunitiesDisplay}</span>
              </div>
            </div>
            <div className="border-top border-secondary opacity-25 my-3" aria-hidden="true" />
            <div className="enemy-card__detail-grid">
              {renderActionSection('Actions:', actionsList, 'actions')}
              {renderActionSection('Bonus Actions:', bonusActionsList, 'bonus-actions')}
              {renderActionSection('Reactions:', reactionsList, 'reactions')}
              {renderActionSection('Legendary Actions:', legendaryActionsList, 'legendary-actions')}
            <div className="border-top border-secondary opacity-25 my-3" aria-hidden="true" />
              {renderActionSection('Special Abilities:', enemy.specialAbilities, 'special-abilities')}
            </div>
            <div className="border-top border-secondary opacity-25 my-3" aria-hidden="true" />
            <div className="enemy-card__detail-grid">
              <div className="enemy-card__detail-line enemy-card__detail-line--wrap">
                <span className="enemy-card__summary-label">Alignment:</span>
                <span aria-hidden="true">{alignmentDisplay}</span>
              </div>
              <div className="enemy-card__detail-line enemy-card__detail-line--wrap">
                <span className="enemy-card__summary-label">Languages:</span>
                <span aria-hidden="true">{languagesDisplay}</span>
              </div>
              <div className="enemy-card__detail-line">
                <span className="enemy-card__summary-label">Xp:</span>
                <span aria-hidden="true">{xpDisplay}</span>
              </div>
            </div>
          </div>
        )}
      </Card.Body>
      <Card.Footer className="resource-card-footer-safe-area d-flex flex-wrap gap-2 justify-content-end mt-auto">
        {mapTag && <span className="enemy-map-tag me-auto">{mapTag.label}</span>}
        {mapTag && <Button variant="outline-primary" size="sm" disabled={inCombat} title={inCombat ? 'Remove it from combat first.' : undefined} onClick={() => onMoveToMap?.(enemy.enemyId)}>Move to this map</Button>}
        <Button
          variant={inCombat ? 'success' : 'outline-primary'}
          size="sm"
          onClick={() => onToggleParticipant(enemy.enemyId)}
        >
          {inCombat ? 'Remove from Combat' : 'Add to Combat'}
        </Button>
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() =>
            onOpenMapPlacement(enemy.enemyId, combatantLabel(enemy, { dm: true, fallback: enemy.enemyId }))
          }
        >
          Place on Map
        </Button>
        <Button
          variant="danger"
          size="sm"
          onClick={() => onRemoveEnemy(enemy.enemyId)}
          disabled={removingEnemyId === enemy.enemyId}
        >
          {removingEnemyId === enemy.enemyId ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Removing…
            </>
          ) : (
            'Remove'
          )}
        </Button>
        <DispositionControl unit={enemy} onChange={onChangeDisposition} />
      </Card.Footer>
    </Card>
  );
}

const sortParticipantsDescending = (participantsWithMeta) =>
  participantsWithMeta
    .slice()
    .sort((a, b) => {
      if (b.participant.initiative !== a.participant.initiative) {
        return b.participant.initiative - a.participant.initiative;
      }

      return a.index - b.index;
    })
    .map(({ participant }) => participant);

export const normalizeCombatState = (state) => {
  if (!state || typeof state !== 'object') {
    return createEmptyCombatState();
  }

  const participants = Array.isArray(state.participants)
    ? state.participants
        .map((participant) => {
          if (
            !participant ||
            typeof participant.characterId !== 'string' ||
            participant.characterId.trim() === ''
          ) {
            return null;
          }

          const initiativeValue = Number(participant.initiative);
          const displayName =
            typeof participant.displayName === 'string' &&
            participant.displayName.trim() !== ''
              ? participant.displayName.trim()
              : null;

          const currentHpValue = toFiniteNumberOrNull(
            participant.currentHp ?? participant.hpCurrent
          );
          const maxHpValue = toFiniteNumberOrNull(
            participant.maxHp ?? participant.hpMax
          );

          return {
            characterId: participant.characterId.trim(),
            ...(participant.initiativeRoll ? {initiativeRoll:participant.initiativeRoll} : {}),
            initiative: Number.isFinite(initiativeValue) ? initiativeValue : 0,
            ...(displayName ? { displayName } : {}),
            ...(currentHpValue !== null ? { currentHp: currentHpValue } : {}),
            ...(maxHpValue !== null ? { maxHp: maxHpValue } : {}),
          };
        })
        .filter(Boolean)
    : [];

  const participantsWithMeta = participants.map((participant, index) => ({
    participant,
    index,
  }));

  const sortedParticipants = state.manualOrder ? participants : sortParticipantsDescending(participantsWithMeta);

  const activeTurnCandidate =
    state.activeTurn === null || state.activeTurn === undefined
      ? null
      : Number(state.activeTurn);

  let activeTurn = null;
  if (
    Number.isInteger(activeTurnCandidate) &&
    activeTurnCandidate >= 0 &&
    activeTurnCandidate < participants.length
  ) {
    const activeParticipant = participants[activeTurnCandidate];
    if (activeParticipant) {
      const sortedIndex = sortedParticipants.findIndex(
        (participant) => participant.characterId === activeParticipant.characterId
      );
      if (sortedIndex !== -1) {
        activeTurn = sortedIndex;
      }
    }
  }

  return normalizeTimelineState({ ...state, participants: sortedParticipants, activeTurn });
};

export const createActiveMapEnemySummaries = ({
  activeMapTokens,
  enemies,
  tokenMetaById = {},
  participantLookup,
  formatArmorClass,
  formatChallengeRatingValue,
  activeParticipantId,
  combatState,
}) => {
  if (
    !Array.isArray(enemies) ||
    enemies.length === 0 ||
    !activeMapTokens ||
    typeof activeMapTokens !== 'object'
  ) {
    return [];
  }

  const activeEnemyIds = new Set();
  Object.entries(activeMapTokens).forEach(([key, token]) => {
    const candidateId =
      (typeof key === 'string' && key.trim()) ||
      (typeof token?.characterId === 'string' && token.characterId.trim()) ||
      null;
    if (!candidateId) {
      return;
    }

    const meta = tokenMetaById?.[candidateId];
    if (meta?.entityType === 'enemy') {
      activeEnemyIds.add(candidateId);
    }
  });

  if (activeEnemyIds.size === 0) {
    return [];
  }

  const normalizedActiveParticipantId =
    typeof activeParticipantId === 'string' && activeParticipantId.trim() !== ''
      ? activeParticipantId.trim()
      : null;

  const summaries = enemies
    .filter((enemy) => {
      if (!enemy || typeof enemy.enemyId !== 'string') {
        return false;
      }
      const trimmedId = enemy.enemyId.trim();
      if (!trimmedId) {
        return false;
      }
      return activeEnemyIds.has(trimmedId);
    })
    .map((enemy) => {
      const resolvedChallengeValue =
        typeof formatChallengeRatingValue === 'function'
          ? formatChallengeRatingValue(enemy.challengeRating)
          : enemy.challengeRating;
      const challengeText =
        enemy.challengeRating !== null && enemy.challengeRating !== undefined
          ? `CR ${resolvedChallengeValue}`
          : null;
      const sizeDisplay = enemy.size || enemy.displayType || '—';
      const armorClassDisplay =
        typeof formatArmorClass === 'function'
          ? formatArmorClass(resolveCombatantArmorClass({ ...enemy, entityType: 'enemy' }, { combatState, targetCombatantId: enemy.enemyId || enemy._id }))
          : '—';
      const maxHpValue = toFiniteNumberOrNull(enemy.maxHp ?? enemy.hitPoints);
      const currentHpCandidate =
        enemy.currentHp !== undefined
          ? toFiniteNumberOrNull(enemy.currentHp)
          : null;
      const resolvedCurrentHp =
        currentHpCandidate !== null
          ? currentHpCandidate
          : maxHpValue !== null
            ? maxHpValue
            : null;
      const healthSummary =
        maxHpValue !== null
          ? `${resolvedCurrentHp !== null ? resolvedCurrentHp : '—'} / ${maxHpValue}`
          : resolvedCurrentHp !== null
            ? `${resolvedCurrentHp}`
            : '—';

      let inCombat = false;
      if (enemy.enemyId) {
        if (participantLookup && typeof participantLookup.get === 'function') {
          inCombat = Boolean(participantLookup.get(enemy.enemyId));
        } else if (
          participantLookup &&
          typeof participantLookup === 'object' &&
          enemy.enemyId in participantLookup
        ) {
          inCombat = Boolean(participantLookup[enemy.enemyId]);
        }
      }

      const normalizedEnemyId =
        typeof enemy.enemyId === 'string' && enemy.enemyId.trim() !== ''
          ? enemy.enemyId.trim()
          : null;
      const isActiveTurn =
        normalizedEnemyId &&
        normalizedActiveParticipantId &&
        normalizedEnemyId === normalizedActiveParticipantId;

      return {
        enemy,
        challengeText,
        sizeDisplay,
        armorClassDisplay,
        maxHpValue,
        resolvedCurrentHp,
        healthSummary,
        inCombat,
        ...(isActiveTurn ? { isActiveTurn: true } : {}),
      };
    });

  summaries.sort((a, b) => {
    const nameA = (a.enemy?.name || '').toLowerCase();
    const nameB = (b.enemy?.name || '').toLowerCase();
    if (nameA && nameB) {
      return nameA.localeCompare(nameB);
    }
    if (nameA) {
      return -1;
    }
    if (nameB) {
      return 1;
    }
    return 0;
  });

  return summaries;
};

const applyDerivedInitiativesToParticipants = (participants, initiativeMap) => {
  if (!Array.isArray(participants) || !initiativeMap || initiativeMap.size === 0) {
    return participants;
  }

  let changed = false;

  const updated = participants.map((participant) => {
    if (!participant || typeof participant !== 'object') {
      return participant;
    }

    const { characterId } = participant;
    if (typeof characterId !== 'string' || characterId.trim() === '') {
      return participant;
    }

    const numericInitiative = Number(participant.initiative);
    if (Number.isFinite(numericInitiative)) {
      return participant;
    }

    const derivedValue = initiativeMap.get(characterId);
    const numericDerived = Number(derivedValue);
    if (!Number.isFinite(numericDerived)) {
      return participant;
    }

    changed = true;
    return { ...participant, initiative: numericDerived };
  });

  return changed ? updated : participants;
};

const applyDerivedInitiativesToState = (state, initiativeMap) => {
  if (!state || typeof state !== 'object') {
    return state;
  }

  const participants = Array.isArray(state.participants)
    ? state.participants
    : [];
  const updatedParticipants = applyDerivedInitiativesToParticipants(
    participants,
    initiativeMap
  );

  if (updatedParticipants === participants) {
    return state;
  }

  return {
    ...state,
    participants: updatedParticipants,
  };
};

const clamp01 = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return null;
  }
  if (parsed < 0) {
    return 0;
  }
  if (parsed > 1) {
    return 1;
  }
  return parsed;
};

const normalizeRotation = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return null;
  }

  const normalized = parsed % 360;
  const resolved = normalized < 0 ? normalized + 360 : normalized;
  return Math.round(resolved * 1000) / 1000;
};

const sanitizeToken = (tokenValue, fallbackId) => {
  if (!tokenValue || typeof tokenValue !== 'object') {
    return null;
  }

  const candidate = { ...tokenValue };
  const candidateId =
    (typeof candidate.characterId === 'string' && candidate.characterId.trim()) ||
    (typeof fallbackId === 'string' && fallbackId.trim()) ||
    null;

  if (!candidateId) {
    return null;
  }

  const x = clamp01(candidate.x);
  const y = clamp01(candidate.y);

  if (x === null || y === null) {
    return null;
  }

  const sanitized = { ...candidate, characterId: candidateId, x, y };

  if (Object.prototype.hasOwnProperty.call(candidate, 'rotation')) {
    const normalizedRotation = normalizeRotation(candidate.rotation);
    if (normalizedRotation === null) {
      delete sanitized.rotation;
    } else {
      sanitized.rotation = normalizedRotation;
    }
  }

  const normalizedSize = normalizeCreatureSize(candidate.size);
  if (normalizedSize) {
    sanitized.size = normalizedSize;
  } else if (Object.prototype.hasOwnProperty.call(candidate, 'size')) {
    delete sanitized.size;
  }

  return sanitized;
};

const sanitizeTokenDictionary = (tokens) => {
  if (!tokens || typeof tokens !== 'object') {
    return {};
  }

  return Object.entries(tokens).reduce((acc, [key, value]) => {
    const token = sanitizeToken(value, key);
    if (token) {
      acc[token.characterId] = token;
    }
    return acc;
  }, {});
};

const sanitizeTokensByMapId = (tokensByMapId) => {
  if (!tokensByMapId || typeof tokensByMapId !== 'object') {
    return {};
  }

  return Object.entries(tokensByMapId).reduce((acc, [mapId, tokens]) => {
    if (typeof mapId !== 'string') {
      return acc;
    }

    const trimmed = mapId.trim();
    if (!trimmed) {
      return acc;
    }

    acc[trimmed] = sanitizeTokenDictionary(tokens);
    return acc;
  }, {});
};

const getNormalizedIdentifiers = (entity) => {
  if (!entity || typeof entity !== 'object') {
    return [];
  }

  const identifiers = [];
  if (typeof entity._id === 'string' && entity._id.trim() !== '') {
    identifiers.push(entity._id.trim());
  }
  if (typeof entity.characterId === 'string' && entity.characterId.trim() !== '') {
    identifiers.push(entity.characterId.trim());
  }
  return Array.from(new Set(identifiers));
};

export const matchesCharacterIdentifier = (record, normalizedCharacterId) => {
  if (!record || typeof record !== 'object' || !normalizedCharacterId) {
    return false;
  }

  const identifiers = getNormalizedIdentifiers(record);
  if (identifiers.includes(normalizedCharacterId)) {
    return true;
  }

  if (
    typeof record.token === 'string' &&
    record.token.trim() !== '' &&
    record.token.trim() === normalizedCharacterId
  ) {
    return true;
  }

  return false;
};

const normalizeHealthValue = (value) => {
  if (value === undefined || value === null) {
    return undefined;
  }

  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : value;
};

export const applyCharacterHealthUpdateToRecords = ({ records, update }) => {
  if (!Array.isArray(records) || records.length === 0) {
    return records;
  }

  if (!update || typeof update !== 'object') {
    return records;
  }

  const normalizedCharacterId =
    typeof update.characterId === 'string' && update.characterId.trim() !== ''
      ? update.characterId.trim()
      : null;
  const normalizedRecordId =
    typeof update._id === 'string' && update._id.trim() !== ''
      ? update._id.trim()
      : null;

  const updateIdentifiers = Array.from(
    new Set([
      ...getNormalizedIdentifiers(update),
      ...(normalizedCharacterId ? [normalizedCharacterId] : []),
      ...(normalizedRecordId ? [normalizedRecordId] : []),
    ])
  );

  if (updateIdentifiers.length === 0) {
    return records;
  }

  const nextTempHealthValue = normalizeHealthValue(update.tempHealth);
  const nextHealthValue = normalizeHealthValue(update.health);
  const nextDeathState = update.deathState && typeof update.deathState === 'object' ? update.deathState : undefined;

  let didUpdate = false;

  const nextRecords = records.map((record) => {
    if (
      !updateIdentifiers.some((identifier) =>
        matchesCharacterIdentifier(record, identifier)
      )
    ) {
      return record;
    }

    let recordUpdated = false;
    const updatedRecord = { ...record };

    if (
      normalizedRecordId &&
      (typeof updatedRecord._id !== 'string' ||
        updatedRecord._id.trim() !== normalizedRecordId)
    ) {
      updatedRecord._id = normalizedRecordId;
      recordUpdated = true;
    }

    if (
      normalizedCharacterId &&
      (typeof updatedRecord.characterId !== 'string' ||
        updatedRecord.characterId.trim() !== normalizedCharacterId)
    ) {
      updatedRecord.characterId = normalizedCharacterId;
      recordUpdated = true;
    }

    if (
      nextTempHealthValue !== undefined &&
      record?.tempHealth !== nextTempHealthValue
    ) {
      updatedRecord.tempHealth = nextTempHealthValue;
      recordUpdated = true;
    }

    if (nextHealthValue !== undefined && record?.health !== nextHealthValue) {
      updatedRecord.health = nextHealthValue;
      recordUpdated = true;
    }

    if (Number.isFinite(update.temporaryHitPoints) && record?.temporaryHitPoints !== update.temporaryHitPoints) {
      updatedRecord.temporaryHitPoints = update.temporaryHitPoints;
      recordUpdated = true;
    }

    if (nextDeathState !== undefined && record?.deathState !== nextDeathState) {
      updatedRecord.deathState = nextDeathState;
      recordUpdated = true;
    }

    if (recordUpdated) {
      didUpdate = true;
      return updatedRecord;
    }

    return record;
  });

  return didUpdate ? nextRecords : records;
};

export const getCharacterCardMeta = (character, itemIndex = 0) => {
  const identifiers = getNormalizedIdentifiers(character);
  const primaryIdentifier = identifiers[0] || `character-${itemIndex}`;
  const sanitizedIdentifier = sanitizeIdentifierForTestId(
    primaryIdentifier,
    `character-${itemIndex}`
  );
  const testId = `character-card-${sanitizedIdentifier}`;

  const { currentHp: derivedCurrentHp, maxHp: derivedMaxHp } =
    calculateCharacterHitPoints(character);
  const fallbackCurrentHp = toFiniteNumberOrNull(
    character?.currentHp ??
      character?.hpCurrent ??
      character?.tempHealth
  );
  const fallbackMaxHp = toFiniteNumberOrNull(
    character?.maxHp ?? character?.hpMax ?? character?.health
  );
  const normalizedCurrentHp = Number.isFinite(derivedCurrentHp)
    ? derivedCurrentHp
    : fallbackCurrentHp;
  const normalizedMaxHp = Number.isFinite(derivedMaxHp)
    ? derivedMaxHp
    : fallbackMaxHp;
  const normalizedTempHp = toFiniteNumberOrNull(character?.tempHealth);

  return {
    testId,
    dataAttributes: {
      ...(typeof primaryIdentifier === 'string'
        ? { 'data-character-id': primaryIdentifier }
        : {}),
      ...(normalizedCurrentHp !== null
        ? { 'data-current-hp': normalizedCurrentHp }
        : {}),
      ...(normalizedMaxHp !== null ? { 'data-max-hp': normalizedMaxHp } : {}),
      ...(normalizedTempHp !== null ? { 'data-temp-hp': normalizedTempHp } : {}),
    },
  };
};

export const getCombatRowMeta = ({
  character,
  rowId,
  participantInfo,
  recordIndex = 0,
}) => {
  const sanitizedRowId = sanitizeIdentifierForTestId(
    rowId,
    `participant-${recordIndex}`
  );
  const testId = `combat-row-${sanitizedRowId}`;

  const rowCurrentHp = toFiniteNumberOrNull(
    character?.currentHp ??
      character?.hpCurrent ??
      character?.tempHealth ??
      participantInfo?.currentHp ??
      participantInfo?.hpCurrent ??
      participantInfo?.health
  );
  const rowMaxHp = toFiniteNumberOrNull(
    character?.maxHp ??
      character?.hpMax ??
      participantInfo?.maxHp ??
      participantInfo?.hpMax ??
      character?.health ??
      participantInfo?.health
  );
  const rowTempHp = toFiniteNumberOrNull(
    character?.tempHealth ?? participantInfo?.tempHealth
  );

  return {
    testId,
    dataAttributes: {
      ...(rowCurrentHp !== null ? { 'data-current-hp': rowCurrentHp } : {}),
      ...(rowMaxHp !== null ? { 'data-max-hp': rowMaxHp } : {}),
      ...(rowTempHp !== null ? { 'data-temp-hp': rowTempHp } : {}),
    },
  };
};

const CLASS_ICON_MAP = {
  barbarian: { icon: GiBattleAxe, label: 'Barbarian' },
  bard: { icon: GiLyre, label: 'Bard' },
  cleric: { icon: GiHolyGrail, label: 'Cleric' },
  druid: { icon: GiOakLeaf, label: 'Druid' },
  fighter: { icon: GiBroadsword, label: 'Fighter' },
  monk: { icon: GiMeditation, label: 'Monk' },
  paladin: { icon: GiAngelWings, label: 'Paladin' },
  ranger: { icon: GiPineTree, label: 'Ranger' },
  rogue: { icon: GiSpy, label: 'Rogue' },
  sorcerer: { icon: GiFireball, label: 'Sorcerer' },
  warlock: { icon: GiPentagramRose, label: 'Warlock' },
  wizard: { icon: GiSpellBook, label: 'Wizard' },
  default: { icon: GiCrossedSwords, label: 'Adventurer' },
};

function ResourceGrid({
  items,
  renderItem,
  emptyMessage = 'No records available.',
  getKey,
  rowClassName = '',
  colClassName = '',
  dataTestId,
}) {
  if (!Array.isArray(items) || items.length === 0) {
    return <div className="text-center text-muted py-3">{emptyMessage}</div>;
  }

  const hasRowColsOverride =
    typeof rowClassName === 'string' && /\brow-cols[\w-]*/.test(rowClassName);

  const rowClasses = [
    'resource-grid',
    !hasRowColsOverride && 'row-cols-1',
    !hasRowColsOverride && 'row-cols-sm-2',
    !hasRowColsOverride && 'row-cols-xl-3',
    'g-3',
    rowClassName,
  ]
    .filter(Boolean)
    .join(' ');
  const columnClasses = ['d-flex', colClassName].filter(Boolean).join(' ');

  return (
    <Row className={rowClasses} data-testid={dataTestId}>
      {items.map((item, index) => (
        <Col key={(getKey && getKey(item, index)) || index} className={columnClasses}>
          {renderItem(item, index)}
        </Col>
      ))}
    </Row>
  );
}

export const removeCustomMonsterFromCatalog = (catalog, deletedIndex) =>
  (Array.isArray(catalog) ? catalog : []).filter((entry) => entry?.index !== deletedIndex);

export const shouldClearDeletedMonsterSelection = (selectedIndex, deletedIndex) =>
  Boolean(selectedIndex && selectedIndex === deletedIndex);

export default function ZombiesDM() {
    useEffect(() => {
      document.title = 'Realm Tracker - DM';
      return () => { document.title = 'Realm Tracker'; };
    }, []);

  const user = useUser();
  const [campaignDM, setCampaignDM] = useState({ players: [] });

    const navigate = useNavigate();
    const params = useParams();
    const [records, setRecords] = useState([]);
    const [enemies, setEnemies] = useState([]);
    const [monsterCatalog, setMonsterCatalog] = useState([]);
    const [monsterCatalogLoading, setMonsterCatalogLoading] = useState(false);
    const [monsterCatalogLoaded, setMonsterCatalogLoaded] = useState(false);
    const [monsterCatalogError, setMonsterCatalogError] = useState(null);
    const [monsterMinChallengeRating, setMonsterMinChallengeRating] = useState('');
    const [monsterMaxChallengeRating, setMonsterMaxChallengeRating] = useState('');
    const [monsterSearch, setMonsterSearch] = useState('');
    const [selectedMonsterIndex, setSelectedMonsterIndex] = useState('');
    const [selectedMonster, setSelectedMonster] = useState(null);
    const [monsterDetailLoading, setMonsterDetailLoading] = useState(false);
    const [showCustomMonsterEditor, setShowCustomMonsterEditor] = useState(false);
    const [showCustomMonsterManager, setShowCustomMonsterManager] = useState(false);
    const [customMonsterCopySource, setCustomMonsterCopySource] = useState(null);
    const [addingEnemy, setAddingEnemy] = useState(false);
    const [customEnemyName, setCustomEnemyName] = useState('');
    const [removingEnemyId, setRemovingEnemyId] = useState(null);
    const [enemyHealthAdjustments, setEnemyHealthAdjustments] = useState({});
    const [enemyHealthSaving, setEnemyHealthSaving] = useState({});
    const [latestEnemyRoll, setLatestEnemyRoll] = useState(null);
    const [pendingEnemyCriticalAttack, setPendingEnemyCriticalAttack] = useState(null);
    const [combatTargeting, setCombatTargeting] = useState(INACTIVE_COMBAT_TARGETING);
    const [enemySaveDamage, setEnemySaveDamage] = useState(null);
    const [pendingEnemyTargetSave, setPendingEnemyTargetSave] = useState(null);
    const [enemyTargetSaveError, setEnemyTargetSaveError] = useState('');
    const [resolvingEnemyTargetSave, setResolvingEnemyTargetSave] = useState(false);
    const locallyInitiatedEnemySaveRef = useRef(new Set());
    const targetingLockRef = useRef(false);
    const enemySpellsRef = useRef(null);
    const enemyMultiattackRef = useRef(null);
    const reactionWaitersRef = useRef(new Map());
    const [pendingDefenderReaction, setPendingDefenderReaction] = useState(null);
    const [showEnemyTokenPicker, setShowEnemyTokenPicker] = useState(false);
    const [enemyTokenSelection, setEnemyTokenSelection] = useState({
      figurineImageUrl: null,
      figurineImagePublicId: null,
    });
    const [status, setStatus] = useState(null);
    const [combatState, setCombatState] = useState(createEmptyCombatState());
    const combatStateRef = useRef(combatState);
    // Map and token positions for attack range and Disadvantage checks; set after the board tokens are built below.
    const attackSpatialContextRef = useRef({ map: null, tokens: {} });
    const turnTransitionLockRef = useRef(false);
    const [standUpPendingId, setStandUpPendingId] = useState(null);
    const [campaignMap, setCampaignMap] = useState(null);
    const [maps, setMaps] = useState([]);
    const [activeMapId, setActiveMapId] = useState(null);
    const [selectedMapId, setSelectedMapId] = useState(null);
    const [mapEditorState, setMapEditorState] = useState({
      show: false,
      mode: 'create',
      map: null,
      title: '',
      folder: '',
      folderSelection: '',
      imageUrl: '',
      imageBase64: '',
      imageType: '',
      imageWidth: null,
      imageHeight: null,
      altText: '',
      gridSelection: `${DEFAULT_MAP_GRID_DIMENSION}`,
      activateOnSave: true,
      fileInputKey: 0,
    });
    const [mapEditorErrors, setMapEditorErrors] = useState({});
    const [mapEditorSaving, setMapEditorSaving] = useState(false);
    const [lastMapFolder, setLastMapFolder] = useState('');
    const [mapActionLoadingId, setMapActionLoadingId] = useState(null);
    const [mapPrompt, setMapPrompt] = useState('');
    const [generatedMap, setGeneratedMap] = useState(null);
    const [mapLoading, setMapLoading] = useState(false);
    const [mapGenerating, setMapGenerating] = useState(false);
    const [showMapMaker, setShowMapMaker] = useState(false);
    // Day or night lighting for Generate Map.
    const [mapLighting, setMapLighting] = useState('day');
    const [mapSaving, setMapSaving] = useState(false);
    const [mapSaveMode, setMapSaveMode] = useState(null);
    const [mapTokens, setMapTokens] = useState({});
    const [activeMapTokens, setActiveMapTokens] = useState({});
    const [mapFolderExpansion, setMapFolderExpansion] = useState({});
    const [mapPlacementState, setMapPlacementState] = useState({
      show: false,
      enemyId: null,
      enemyName: null,
    });
    const [mapPlacementSaving, setMapPlacementSaving] = useState(false);
    const [mapPlacementError, setMapPlacementError] = useState(null);
    const [showDiceRoller, setShowDiceRoller] = useState(false);
    const [enemyRollPopup, setEnemyRollPopup] = useState(null);
    const [enemyDiceOverlayActive, setEnemyDiceOverlayActive] = useState(false);
    const [enemyRollDice, setEnemyRollDice] = useState([]);
    const enemyDiceClearTimeoutRef = useRef(null);
    const socketRef = useRef(null);
    const mapTokensRef = useRef(mapTokens);
    const activeMapTokensRef = useRef(activeMapTokens);
    const campaignMapRef = useRef(campaignMap);
    const activeMapIdRef = useRef(activeMapId);

    useEffect(() => {
      combatStateRef.current = combatState;
    }, [combatState]);

    const enemyTokenFilterScope = useMemo(
      () => buildEnemyTokenFilterScopeValues(selectedMonsterIndex, selectedMonster),
      [selectedMonsterIndex, selectedMonster]
    );
    const enemyTokenDirectFolder = useMemo(
      () => catalogedEnemyTokenFolder(selectedMonsterIndex, selectedMonster),
      [selectedMonsterIndex, selectedMonster]
    );

    const campaignId = params.campaign ?? '';
    const { feedback: spellFeedback, log: spellDamageLog, dismiss: dismissSpellFeedback } = useSpellDamageFeedback({ campaignId, combatantId: 'dm',
      targetName: id => combatantLabel(enemies.find(enemy => String(enemy.enemyId || enemy._id) === String(id)), { dm: true, fallback: records.find(character => String(character._id || character.characterId) === String(id))?.characterName || id }),
      acceptsSource: id => enemies.some(enemy => String(enemy.enemyId || enemy._id) === String(id)) });
    const [showSpellDamageLog, setShowSpellDamageLog] = useState(false);
    const { entries: dmRollLogEntries, add: addDmRollLog } = useDmRollLog({ campaignId });
    useCombatEventRollLog({ campaignId, eventLog: combatState?.eventLog });
    // The roll popup clears itself a few seconds after the latest roll (saves still pending keep it up).
    useAutoDismiss({
      showKey: enemyRollPopup || spellFeedback
        ? `${enemyRollPopup?.timestamp}:${enemyRollPopup?.value}:${enemyRollPopup?.label}|${spellFeedbackKey(spellFeedback)}` : '',
      enabled: !spellFeedbackPending(spellFeedback),
      onDismiss: () => { dismissSpellFeedback(); setEnemyRollPopup(null); },
    });
    const handleEnemySpellSummary = useCallback(summary => { if (summary.value !== null) setEnemyRollPopup(previous => previous?.timestamp === summary.timestamp && previous?.value === summary.value && previous?.label === summary.label ? previous : summary); }, []);

    const notifyEnemySaveDamage = useCallback((resolution) => {
      const target = enemies.find(enemy => String(enemy.enemyId || enemy._id) === String(resolution?.targetCombatantId));
      if (!target) return;
      notifyTargetSaveDamage({ resolution, controlledCombatantId: resolution.targetCombatantId,
        notify: (message, type) => notify(`${combatantLabel(target, { dm: true })}: ${message}`, type) });
    }, [enemies]);
    const notifyEnemySaveDamageRef = useRef(notifyEnemySaveDamage);
    notifyEnemySaveDamageRef.current = notifyEnemySaveDamage;

    const enemySaveRefreshSequenceRef = useRef(0);
    const enemySaveRevisionRef = useRef(combatState?.turnSequence);
    enemySaveRevisionRef.current = combatState?.turnSequence;
    const refreshEnemyTargetSave = useCallback(async () => {
      const sequence = ++enemySaveRefreshSequenceRef.current;
      const revision = enemySaveRevisionRef.current;
      if (!campaignId) { setPendingEnemyTargetSave(null); return; }
      try {
        const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/resolutions/pending-saves`, { cache: 'no-store' });
        if (!response.ok) return;
        const pending = await response.json();
        if (sequence !== enemySaveRefreshSequenceRef.current || revision !== enemySaveRevisionRef.current) return;
        setPendingEnemyTargetSave((Array.isArray(pending) ? pending : []).find((item) =>
          item.status === 'prepared' && item.targetSave?.status === 'awaiting-response' &&
          enemies.some((enemy) => String(enemy.enemyId || enemy._id) === String(item.targetCombatantId))) || null);
      } catch (_) { /* Reconcile on the next combat or socket update. */ }
    }, [campaignId, enemies]);
    const refreshEnemyTargetSaveRef = useRef(refreshEnemyTargetSave);
    refreshEnemyTargetSaveRef.current = refreshEnemyTargetSave;
    useEffect(() => { refreshEnemyTargetSave(); }, [refreshEnemyTargetSave, combatState?.turnSequence]);

    const encodedCampaign = useMemo(
      () => (campaignId ? encodeURIComponent(campaignId) : ''),
      [campaignId]
    );
    const handleEnemyStandUp = useCallback(async (enemy) => {
      const combatantId = enemy?.enemyId || enemy?._id;
      const baseSpeed = getEntityMovementSpeed(enemy);
      if (!encodedCampaign || !combatantId || standUpPendingId || baseSpeed === null) return;
      setStandUpPendingId(combatantId);
      try {
        const result = await standUp(campaignId, { combatantId, turnSequence: combatState.turnSequence });
        if (result.combat) setCombatState(normalizeCombatState(result.combat));
        setStatus({ type: 'success', message: `${combatantLabel(enemy, { dm: true })} stood up; ${result.movementCost} ft movement is tracked manually.` });
      } catch (error) {
        setStatus({ type: 'danger', message: error.message || 'Could not Stand Up.' });
      } finally {
        setStandUpPendingId(null);
      }
    }, [campaignId, combatState.turnSequence, encodedCampaign, standUpPendingId]);


    useEffect(() => {
      if (!user || !encodedCampaign) {
        return;
      }

      apiFetch(`/campaigns/${encodedCampaign}/access`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ role: "dm" }),
      }).catch(() => {});
    }, [encodedCampaign, user]);

    const waitForNextAnimationFrame = useCallback(
      () =>
        new Promise((resolve) => {
          if (
            typeof window === 'undefined' ||
            typeof window.requestAnimationFrame !== 'function'
          ) {
            resolve();
            return;
          }

          window.requestAnimationFrame(() => resolve());
        }),
      []
    );

    const showEnemyDiceOverlay = useCallback(async () => {
      clearTimeout(enemyDiceClearTimeoutRef.current);
      setEnemyDiceOverlayActive(true);
      setEnemyRollDice([]);
      await waitForNextAnimationFrame();
    }, [waitForNextAnimationFrame]);

    const displayEnemyDiceResults = useCallback((diceDetails = []) => {
      const timestamp = Date.now();
      const nextDice = Array.isArray(diceDetails)
        ? diceDetails.map((detail, index) => ({
            id: `${timestamp}-${index}`,
            value: typeof detail?.value === 'number' ? detail.value : Number(detail?.value) || 0,
            sides: Number.isFinite(detail?.sides) ? Math.max(2, Math.round(detail.sides)) : 20,
            type: detail?.type || '',
            category: detail?.category || 'base',
          }))
        : [];

      setEnemyRollDice(nextDice);
      clearTimeout(enemyDiceClearTimeoutRef.current);
      enemyDiceClearTimeoutRef.current = setTimeout(() => {
        setEnemyRollDice([]);
        setEnemyDiceOverlayActive(false);
      }, ROLL_DISPLAY_MS);
    }, []);

    useEffect(
      () => () => {
        clearTimeout(enemyDiceClearTimeoutRef.current);
      },
      []
    );

    const normalizedMaps = useMemo(
      () => (Array.isArray(maps) ? maps.filter((map) => map && typeof map === 'object') : []),
      [maps]
    );

    const groupedMaps = useMemo(
      () => groupMapsByFolder(normalizedMaps),
      [normalizedMaps]
    );

    const normalizedActiveMapId = useMemo(
      () => normalizeMapId(activeMapId),
      [activeMapId]
    );
    // The map the DM is looking at, which the enemy lists follow; set once that map is worked out below.
    const enemyMapRef = useRef(null);

    useEffect(() => {
      setMapFolderExpansion((previous) => {
        const next = {};

        groupedMaps.forEach((group) => {
          next[group.key] = Object.prototype.hasOwnProperty.call(previous, group.key)
            ? previous[group.key]
            : false;
        });

        return next;
      });
    }, [groupedMaps]);

    const handleToggleMapFolder = useCallback((folderKey) => {
      if (typeof folderKey !== 'string') {
        return;
      }

      setMapFolderExpansion((previous) => ({
        ...previous,
        [folderKey]: !previous[folderKey],
      }));
    }, []);

    const availableMapFolders = useMemo(() => {
      const folderSet = new Set();
      normalizedMaps.forEach((map) => {
        const folderValue = typeof map.folder === 'string' ? map.folder.trim() : '';
        if (folderValue) {
          folderSet.add(folderValue);
        }
      });

      return Array.from(folderSet).sort((a, b) => a.localeCompare(b));
    }, [normalizedMaps]);

    useEffect(() => {
      mapTokensRef.current = mapTokens;
    }, [mapTokens]);

    useEffect(() => {
      activeMapTokensRef.current = activeMapTokens;
    }, [activeMapTokens]);

    useEffect(() => {
      campaignMapRef.current = campaignMap;
    }, [campaignMap]);

    useEffect(() => {
      activeMapIdRef.current = activeMapId;
    }, [activeMapId]);

    useEffect(() => {
      if (!mapEditorErrors.title) {
        return;
      }

      const hasTitle =
        typeof mapEditorState.title === 'string' && mapEditorState.title.trim() !== '';

      if (hasTitle) {
        setMapEditorErrors((prev) => {
          if (!prev.title) {
            return prev;
          }

          const { title, ...rest } = prev;
          return Object.keys(rest).length ? rest : {};
        });
      }
    }, [mapEditorErrors.title, mapEditorState.title]);

    useEffect(() => {
      if (!mapEditorErrors.imageSource) {
        return;
      }

      const hasImageUrl =
        typeof mapEditorState.imageUrl === 'string' && mapEditorState.imageUrl.trim() !== '';
      const hasImageFile =
        typeof mapEditorState.imageBase64 === 'string' &&
        mapEditorState.imageBase64.trim() !== '';

      if (hasImageUrl || hasImageFile) {
        setMapEditorErrors((prev) => {
          if (!prev.imageSource) {
            return prev;
          }

          const { imageSource, ...rest } = prev;
          return Object.keys(rest).length ? rest : {};
        });
      }
    }, [mapEditorErrors.imageSource, mapEditorState.imageUrl, mapEditorState.imageBase64]);

    useEffect(() => {
      if (!mapEditorErrors.altText || mapEditorState.mode !== 'create') {
        return;
      }

      const hasAltText =
        typeof mapEditorState.altText === 'string' &&
        mapEditorState.altText.trim() !== '';

      if (hasAltText) {
        setMapEditorErrors((prev) => {
          if (!prev.altText) {
            return prev;
          }

          const { altText, ...rest } = prev;
          return Object.keys(rest).length ? rest : {};
        });
      }
    }, [mapEditorErrors.altText, mapEditorState.altText, mapEditorState.mode]);

    const imageSourceDescribedBy = useMemo(() => {
      const ids = ['map-editor-image-requirement'];
      if (mapEditorErrors.imageSource) {
        ids.push('map-editor-image-error');
      }
      return ids.join(' ');
    }, [mapEditorErrors.imageSource]);

    const applyMapPayload = useCallback(
      (payload, options = {}) => {
        const normalizedMaps = Array.isArray(payload?.maps)
          ? payload.maps.filter((map) => map && typeof map === 'object')
          : [];
        setMaps(normalizedMaps);

        const normalizedActiveId =
          typeof payload?.activeMapId === 'string' && payload.activeMapId.trim() !== ''
            ? payload.activeMapId.trim()
            : null;
        setActiveMapId(normalizedActiveId);

        const payloadMap =
          payload && typeof payload.map === 'object' && !Array.isArray(payload.map)
            ? payload.map
            : null;

        const resolvedActiveMap =
          payloadMap ||
          (normalizedActiveId
            ? normalizedMaps.find((map) => map?.mapId === normalizedActiveId)
            : null) ||
          null;

        const hasTokensByMapIdProp =
          payload && Object.prototype.hasOwnProperty.call(payload, 'tokensByMapId');
        const hasActiveTokensProp =
          payload && Object.prototype.hasOwnProperty.call(payload, 'activeMapTokens');

        const activeTokensFromPayload = hasActiveTokensProp
          ? sanitizeTokenDictionary(payload.activeMapTokens)
          : null;
        const mapTokensFromPayload = hasTokensByMapIdProp
          ? sanitizeTokensByMapId(payload.tokensByMapId)
          : null;

        const resolvedActiveTokens =
          activeTokensFromPayload ||
          (resolvedActiveMap && resolvedActiveMap.tokens
            ? sanitizeTokenDictionary(resolvedActiveMap.tokens)
            : {});

        if (hasTokensByMapIdProp) {
          setMapTokens(mapTokensFromPayload || {});
        } else if (resolvedActiveMap && resolvedActiveMap.mapId) {
          setMapTokens((prev) => ({
            ...(prev || {}),
            [resolvedActiveMap.mapId]: resolvedActiveTokens,
          }));
        } else {
          setMapTokens({});
        }

        setActiveMapTokens(resolvedActiveTokens);

        const nextCampaignMap = resolvedActiveMap
          ? { ...resolvedActiveMap, tokens: resolvedActiveTokens }
          : null;
        setCampaignMap(nextCampaignMap);

        setSelectedMapId((prevSelected) => {
          const preferredId =
            options.preferredSelectedId &&
            normalizedMaps.some((map) => map?.mapId === options.preferredSelectedId)
              ? options.preferredSelectedId
              : null;

          if (preferredId) {
            return preferredId;
          }

          if (prevSelected && normalizedMaps.some((map) => map?.mapId === prevSelected)) {
            return prevSelected;
          }

          if (
            normalizedActiveId &&
            normalizedMaps.some((map) => map?.mapId === normalizedActiveId)
          ) {
            return normalizedActiveId;
          }

          if (
            payloadMap &&
            payloadMap.mapId &&
            normalizedMaps.some((map) => map?.mapId === payloadMap.mapId)
          ) {
            return payloadMap.mapId;
          }

          const firstMap = normalizedMaps.find((map) => map && map.mapId);
          return firstMap ? firstMap.mapId : null;
        });
      },
      [setMaps, setActiveMapId, setCampaignMap, setSelectedMapId]
    );

    const parseErrorMessage = useCallback(async (response, fallbackMessage) => {
      let message = (response && response.statusText) || fallbackMessage;
      if (response && typeof response.json === 'function') {
        try {
          const errorBody = await response.json();
          if (errorBody && typeof errorBody === 'object' && errorBody.message) {
            message = errorBody.message;
          }
        } catch (error) {
          // ignore JSON parsing errors when reading error responses
        }
      }
      return message;
    }, []);

    const fetchRecords = useCallback(async () => {
      if (!campaignId || !encodedCampaign) {
        setRecords([]);
        setEnemies([]);
        setCombatState(createEmptyCombatState());
        setCampaignMap(null);
        setMaps([]);
        setActiveMapId(null);
        setSelectedMapId(null);
        setGeneratedMap(null);
        setMapTokens({});
        setActiveMapTokens({});
        setMapLoading(false);
        return;
      }

      setMapLoading(true);

      try {
        const [charactersResponse, combatResponse, enemiesResponse] = await Promise.all([
          apiFetch(`/campaigns/${encodedCampaign}/characters`),
          apiFetch(`/campaigns/${encodedCampaign}/combat`),
          apiFetch(`/campaigns/${encodedCampaign}/enemies`),
        ]);

        if (!charactersResponse.ok) {
          const message = `An error occurred: ${charactersResponse.statusText}`;
          setStatus({ type: 'danger', message });
          setRecords([]);
          setEnemies([]);
          return;
        }

        const characters = await charactersResponse.json();
        setRecords(characters);

        if (enemiesResponse.ok) {
          const enemiesData = await enemiesResponse.json();
          const normalizedEnemies = Array.isArray(enemiesData) ? enemiesData : [];
          setEnemies(normalizedEnemies);
        } else if (enemiesResponse.status === 404) {
          setEnemies([]);
        } else {
          setEnemies([]);
          const message = `An error occurred: ${enemiesResponse.statusText}`;
          setStatus({ type: 'danger', message });
        }

        if (combatResponse.ok) {
          const combatJson = await combatResponse.json();
          setCombatState(current=>(combatJson.orderRevision || 0)<(current.orderRevision || 0)?current:normalizeCombatState(combatJson));
        } else {
          setCombatState(createEmptyCombatState());
          if (combatResponse.status !== 404) {
            const message = `An error occurred: ${combatResponse.statusText}`;
            setStatus({ type: 'danger', message });
          }
        }

        let mapsPayload = null;
        let fallbackMap = null;

        try {
          const mapsResponse = await apiFetch(`/campaigns/${encodedCampaign}/maps`);
          if (mapsResponse.ok) {
            mapsPayload = await mapsResponse.json();
          } else if (mapsResponse.status === 404) {
            try {
              const legacyResponse = await apiFetch(`/campaigns/${encodedCampaign}/map`);
              if (legacyResponse.ok) {
                fallbackMap = await legacyResponse.json();
              } else if (legacyResponse.status !== 404) {
                const message = `An error occurred: ${legacyResponse.statusText}`;
                setStatus({ type: 'danger', message });
              }
            } catch (legacyError) {
              console.error(legacyError);
              setStatus({
                type: 'danger',
                message: legacyError.message || 'Failed to load legacy map.',
              });
            }
          } else {
            const message = `An error occurred: ${mapsResponse.statusText}`;
            setStatus({ type: 'danger', message });
          }
        } catch (mapError) {
          console.error(mapError);
          setStatus({
            type: 'danger',
            message: mapError.message || 'Failed to load maps.',
          });
        }

        if (mapsPayload) {
          applyMapPayload(mapsPayload);
          setGeneratedMap(null);
        } else if (fallbackMap) {
          const normalizedFallback =
            fallbackMap && typeof fallbackMap === 'object' ? fallbackMap : null;
          if (normalizedFallback && Object.keys(normalizedFallback).length > 0) {
            const fallbackActiveId =
              typeof normalizedFallback.mapId === 'string' &&
              normalizedFallback.mapId.trim() !== ''
                ? normalizedFallback.mapId.trim()
                : null;
            applyMapPayload({
              maps: fallbackActiveId ? [normalizedFallback] : [],
              activeMapId: fallbackActiveId,
              map: normalizedFallback,
            });
          } else {
            applyMapPayload({ maps: [], activeMapId: null, map: null });
          }
          setGeneratedMap(null);
        } else {
          applyMapPayload({ maps: [], activeMapId: null, map: null });
          setGeneratedMap(null);
        }
      } catch (error) {
        console.error(error);
        setStatus({ type: 'danger', message: error.message || 'Failed to fetch records.' });
        setEnemies([]);
        setCombatState(createEmptyCombatState());
        setCampaignMap(null);
        setMaps([]);
        setActiveMapId(null);
        setSelectedMapId(null);
        setGeneratedMap(null);
        setMapTokens({});
        setActiveMapTokens({});
      } finally {
        setMapLoading(false);
      }
    }, [campaignId, encodedCampaign, applyMapPayload]);

    const fetchMonsterCatalog = useCallback(async () => {
      if (monsterCatalogLoading) {
        return;
      }

      setMonsterCatalogLoading(true);
      try {
        setMonsterCatalogError(null);
        const response = await apiFetch('/monsters');
        if (!response.ok) {
          throw new Error(response.statusText || 'Failed to load monsters.');
        }
        const data = await response.json();
        const catalog = Array.isArray(data)
          ? data
              .slice()
              .sort((a, b) => (a?.name || '').localeCompare(b?.name || ''))
          : [];
        setMonsterCatalog(catalog);
      } catch (error) {
        console.error(error);
        setMonsterCatalog([]);
        setMonsterCatalogError(error.message || 'Failed to load monsters.');
        setStatus({ type: 'danger', message: error.message || 'Failed to load monsters.' });
      } finally {
        setMonsterCatalogLoaded(true);
        setMonsterCatalogLoading(false);
      }
    }, [monsterCatalogLoading]);

    const updateSelectedMonster = useCallback(
      async (index) => {
        const normalizedIndex = typeof index === 'string' ? index.trim() : '';
        setSelectedMonsterIndex(normalizedIndex);
        if (!normalizedIndex) {
          setSelectedMonster(null);
          return;
        }

        setMonsterDetailLoading(true);
        try {
          const response = await apiFetch(`/monsters/${normalizedIndex}`);
          if (!response.ok) {
            throw new Error(response.statusText || 'Failed to load monster.');
          }
          const detail = await response.json();
          setSelectedMonster(detail);
          setEnemyTokenSelection({
            figurineImageUrl: detail?.tokenImage?.secureUrl || null,
            figurineImagePublicId: detail?.tokenImage?.publicId || null,
          });
        } catch (error) {
          console.error(error);
          setSelectedMonster(null);
          setStatus({ type: 'danger', message: error.message || 'Failed to load monster.' });
        } finally {
          setMonsterDetailLoading(false);
        }
      },
      [setStatus]
    );

    const handleMonsterSelectChange = useCallback(
      (event) => {
        const { value } = event.target;
        setCustomEnemyName('');
        updateSelectedMonster(value);
      },
      [updateSelectedMonster]
    );

    const handleCustomMonsterSaved = useCallback(async (monster) => {
      setShowCustomMonsterEditor(false);
      setCustomMonsterCopySource(null);
      setMonsterCatalogLoaded(false);
      setMonsterCatalog((current) => {
        const next = current.filter((entry) => entry.index !== monster.index);
        next.push({ index: monster.index, name: monster.name, challengeRating: monster.challengeRating, source: 'custom', custom: true });
        return next.sort((a, b) => (a?.name || '').localeCompare(b?.name || ''));
      });
      setSelectedMonsterIndex(monster.index);
      setSelectedMonster(monster);
      setEnemyTokenSelection({
        figurineImageUrl: monster?.tokenImage?.secureUrl || null,
        figurineImagePublicId: monster?.tokenImage?.publicId || null,
      });
      setStatus({ type: 'success', message: `${monster.name} saved to your custom monster catalog.` });
    }, []);

    const handleCustomMonsterDeleted = useCallback((monster) => {
      setMonsterCatalog((current) => removeCustomMonsterFromCatalog(current, monster.index));
      if (shouldClearDeletedMonsterSelection(selectedMonsterIndex, monster.index)) {
        setSelectedMonsterIndex('');
        setSelectedMonster(null);
        setEnemyTokenSelection({ figurineImageUrl: null, figurineImagePublicId: null });
      }
      setStatus({ type: 'success', message: `${monster.name} deleted from your custom monsters.` });
    }, [selectedMonsterIndex]);

    const handleAddEnemy = useCallback(
      async (event, disposition = event.nativeEvent?.submitter?.value || 'enemy') => {
        event.preventDefault();
        if (!selectedMonsterIndex || !encodedCampaign) {
          return;
        }

        setAddingEnemy(true);
        try {
          // A new creature belongs to the map the DM is looking at.
          const payload = { index: selectedMonsterIndex, disposition, ...(enemyMapRef.current ? { mapId: enemyMapRef.current } : {}) };
          const trimmedName = customEnemyName.trim();
          if (trimmedName) {
            payload.name = trimmedName;
          }

          if (
            enemyTokenSelection?.figurineImageUrl &&
            enemyTokenSelection.figurineImageUrl.trim() !== ''
          ) {
            payload.figurineImageUrl = enemyTokenSelection.figurineImageUrl.trim();
          }

          if (
            enemyTokenSelection?.figurineImagePublicId &&
            enemyTokenSelection.figurineImagePublicId.trim() !== ''
          ) {
            payload.figurineImagePublicId = enemyTokenSelection.figurineImagePublicId.trim();
          }

          const response = await apiFetch(`/campaigns/${encodedCampaign}/enemies`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });

          if (!response.ok) {
            let message = response.statusText || 'Failed to add enemy.';
            try {
              const errorData = await response.json();
              message = errorData?.message || message;
            } catch (jsonError) {
              // Ignore JSON parsing errors
            }
            throw new Error(message);
          }

          const addedEnemy = await response.json();
          setStatus({ type: 'success', message: `${addedEnemy?.name || 'Enemy'} added to campaign.` });
          setCustomEnemyName('');
          setEnemyTokenSelection({ figurineImageUrl: null, figurineImagePublicId: null });
          await fetchRecords();
        } catch (error) {
          console.error(error);
          setStatus({ type: 'danger', message: error.message || 'Failed to add enemy.' });
        } finally {
          setAddingEnemy(false);
        }
      },
      [
        selectedMonsterIndex,
        encodedCampaign,
        customEnemyName,
        fetchRecords,
        enemyTokenSelection.figurineImagePublicId,
        enemyTokenSelection.figurineImageUrl,
      ]
    );

    const [npcDispositionFilter,setNpcDispositionFilter]=useState('all');
    const [showAllMapEnemies,setShowAllMapEnemies]=useState(false);
    const handleMoveEnemyToMap=useCallback(async(enemyId)=>{
      try {
        const response=await apiFetch(`/campaigns/${encodedCampaign}/enemies/${encodeURIComponent(enemyId)}/map`,{method:'PATCH',headers:{'Content-Type':'application/json'},body:JSON.stringify({mapId:enemyMapRef.current})});
        const result=await response.json();if(!response.ok)throw new Error(result.message || 'Unable to move this creature.');
        setEnemies(previous=>previous.map(enemy=>enemy.enemyId===enemyId?{...enemy,...result}:enemy));
        notify(`${result.name} moved to this map.`, 'success');
      }catch(error){notify(error.message,'danger');}
    },[encodedCampaign]);
    const handleChangeDisposition=useCallback(async(enemyId,disposition)=>{
      try {
        const response=await apiFetch(`/campaigns/${encodedCampaign}/enemies/${encodeURIComponent(enemyId)}/disposition`,{method:'PATCH',headers:{'Content-Type':'application/json'},body:JSON.stringify({disposition})});
        const result=await response.json();if(!response.ok)throw new Error(result.message || 'Unable to change disposition.');
        setEnemies(previous=>previous.map(enemy=>enemy.enemyId===enemyId?{...enemy,...result}:enemy));
        notify(`${result.name}: ${dispositionLabel(result)}.`, 'success');return true;
      }catch(error){notify(error.message,'danger');return false;}
    },[encodedCampaign]);

    const handleOpenEnemyTokenPicker = useCallback(() => {
      setShowEnemyTokenPicker(true);
    }, []);

    const handleCloseEnemyTokenPicker = useCallback(() => {
      setShowEnemyTokenPicker(false);
    }, []);

    const handleEnemyTokenSelected = useCallback((asset) => {
      if (!asset) {
        setEnemyTokenSelection({ figurineImageUrl: null, figurineImagePublicId: null });
        setShowEnemyTokenPicker(false);
        return;
      }

      const nextUrl =
        typeof asset.secureUrl === 'string' && asset.secureUrl.trim() !== ''
          ? asset.secureUrl.trim()
          : typeof asset.url === 'string' && asset.url.trim() !== ''
            ? asset.url.trim()
            : null;
      const nextPublicId =
        typeof asset.publicId === 'string' && asset.publicId.trim() !== ''
          ? asset.publicId.trim()
          : null;

      setEnemyTokenSelection({ figurineImageUrl: nextUrl, figurineImagePublicId: nextPublicId });
      setShowEnemyTokenPicker(false);
    }, []);

    const removeCharacterTokensFromMaps = useCallback(
      async (character) => {
        const normalizedCharacterId =
          typeof character === 'string'
            ? character.trim()
            : typeof character?.characterId === 'string' && character.characterId.trim() !== ''
            ? character.characterId.trim()
            : null;

        const normalizedMapHint =
          typeof character === 'object' &&
          typeof character?.mapId === 'string' &&
          character.mapId.trim() !== ''
            ? character.mapId.trim()
            : null;

        if (!normalizedCharacterId || !encodedCampaign) {
          return true;
        }

        const mapsWithToken = new Set();
        const currentTokensByMap = mapTokensRef.current || {};
        Object.entries(currentTokensByMap).forEach(([mapId, tokens]) => {
          if (
            typeof mapId === 'string' &&
            mapId.trim() !== '' &&
            tokens &&
            typeof tokens === 'object' &&
            Object.prototype.hasOwnProperty.call(tokens, normalizedCharacterId)
          ) {
            mapsWithToken.add(mapId);
          }
        });

        if (
          campaignMap &&
          typeof campaignMap === 'object' &&
          typeof campaignMap.mapId === 'string' &&
          campaignMap.mapId.trim() !== '' &&
          campaignMap.tokens &&
          Object.prototype.hasOwnProperty.call(
            campaignMap.tokens,
            normalizedCharacterId
          )
        ) {
          mapsWithToken.add(campaignMap.mapId);
        }

        if (
          typeof activeMapId === 'string' &&
          activeMapId.trim() !== '' &&
          activeMapTokensRef.current &&
          Object.prototype.hasOwnProperty.call(
            activeMapTokensRef.current,
            normalizedCharacterId
          )
        ) {
          mapsWithToken.add(activeMapId);
        }

        if (normalizedMapHint) {
          mapsWithToken.add(normalizedMapHint);
        }

        const shouldClosePlacement =
          mapPlacementState?.enemyId === normalizedCharacterId;

        if (mapsWithToken.size === 0 && !shouldClosePlacement) {
          return true;
        }

        const previousMapTokens = mapTokensRef.current || {};
        const previousActiveTokens = activeMapTokensRef.current || {};
        const previousCampaignMap = campaignMap;
        const previousMapPlacementState = mapPlacementState;

        if (mapsWithToken.size > 0) {
          setMapTokens((prev) => {
            const next = { ...(prev || {}) };
            mapsWithToken.forEach((mapId) => {
              if (typeof mapId !== 'string' || mapId.trim() === '') {
                return;
              }
              if (!next[mapId]) {
                return;
              }
              const updated = { ...next[mapId] };
              delete updated[normalizedCharacterId];
              if (Object.keys(updated).length === 0) {
                delete next[mapId];
              } else {
                next[mapId] = updated;
              }
            });
            return next;
          });

          setActiveMapTokens((prev) => {
            if (!prev || !prev[normalizedCharacterId]) {
              return prev;
            }
            const next = { ...prev };
            delete next[normalizedCharacterId];
            return next;
          });

          setCampaignMap((prev) => {
            if (!prev || !mapsWithToken.has(prev.mapId)) {
              return prev;
            }
            const nextTokens = { ...(prev.tokens || {}) };
            delete nextTokens[normalizedCharacterId];
            return { ...prev, tokens: nextTokens };
          });
        }

        if (shouldClosePlacement) {
          setMapPlacementState({ show: false, enemyId: null, enemyName: null });
        }

        const mapIds = Array.from(mapsWithToken).filter(
          (mapId) => typeof mapId === 'string' && mapId.trim() !== ''
        );

        if (mapIds.length === 0) {
          return true;
        }

        try {
          const encodedCharacterId = encodeURIComponent(normalizedCharacterId);
          for (const mapId of mapIds) {
            const encodedMapId = encodeURIComponent(mapId);
            const response = await apiFetch(
              `/campaigns/${encodedCampaign}/maps/${encodedMapId}/tokens/${encodedCharacterId}`,
              {
                method: 'DELETE',
              }
            );

            if (response && response.status === 404) {
              continue;
            }

            if (!response || !response.ok) {
              const message = await parseErrorMessage(
                response,
                'Failed to remove token from map.'
              );
              throw new Error(message);
            }
          }
        } catch (error) {
          console.error(error);
          setStatus({
            type: 'danger',
            message: error?.message || 'Failed to remove token from map.',
          });
          setMapTokens(previousMapTokens || {});
          setActiveMapTokens(previousActiveTokens || {});
          setCampaignMap(previousCampaignMap || null);
          setMapPlacementState(
            previousMapPlacementState || { show: false, enemyId: null, enemyName: null }
          );
          return false;
        }

        return true;
      },
      [
        activeMapId,
        campaignMap,
        encodedCampaign,
        mapPlacementState,
        parseErrorMessage,
        setStatus,
      ]
    );

    const handleMapTokenRemove = useCallback(
      async ({ characterId, mapId }) => {
        if (typeof characterId !== 'string' || characterId.trim() === '') {
          return false;
        }

        const payload = { characterId: characterId.trim() };
        if (typeof mapId === 'string' && mapId.trim() !== '') {
          payload.mapId = mapId.trim();
        }

        return removeCharacterTokensFromMaps(payload);
      },
      [removeCharacterTokensFromMaps]
    );

    const handleRemoveEnemy = useCallback(
      async (enemyId) => {
        if (!enemyId || !encodedCampaign) {
          return;
        }

        setRemovingEnemyId(enemyId);
        try {
          const response = await apiFetch(`/campaigns/${encodedCampaign}/enemies/${enemyId}`, {
            method: 'DELETE',
          });

          if (!response.ok) {
            let message = response.statusText || 'Failed to remove enemy.';
            try {
              const errorData = await response.json();
              message = errorData?.message || message;
            } catch (jsonError) {
              // Ignore JSON parsing errors
            }
            throw new Error(message);
          }

          const tokensRemoved = await removeCharacterTokensFromMaps(enemyId);
          await fetchRecords();
          if (tokensRemoved) {
            setStatus({ type: 'success', message: 'Enemy removed.' });
          }
        } catch (error) {
          console.error(error);
          setStatus({ type: 'danger', message: error.message || 'Failed to remove enemy.' });
        } finally {
          setRemovingEnemyId(null);
        }
      },
      [encodedCampaign, fetchRecords, removeCharacterTokensFromMaps]
    );

    const handleEnemyAdjustmentInputChange = useCallback((enemyId, value) => {
      if (!enemyId) {
        return;
      }

      setEnemyHealthAdjustments((prev) => ({ ...prev, [enemyId]: value }));
    }, []);

    const updateEnemyHealth = useCallback(
      async (enemyId, nextHp, options = {}) => {
        if (!enemyId || !encodedCampaign) {
          return;
        }

        const encodedEnemyId = encodeURIComponent(enemyId);
        setEnemyHealthSaving((prev) => ({ ...prev, [enemyId]: true }));

        try {
          const response = await apiFetch(
            `/campaigns/${encodedCampaign}/enemies/${encodedEnemyId}/health`,
            {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(options.delta !== undefined
                ? { delta: options.delta, eventId: options.eventId }
                : { currentHp: nextHp }),
            }
          );

          if (!response.ok) {
            throw new Error(response.statusText || 'Failed to update enemy health');
          }

          const result = await response.json();

          if (result?.enemy) {
            setEnemies((prev) => {
              if (!Array.isArray(prev)) {
                return prev;
              }

              const index = prev.findIndex((entry) => entry?.enemyId === enemyId);
              if (index === -1) {
                return prev;
              }

              const next = [...prev];
              next[index] = { ...next[index], ...result.enemy };
              return next;
            });
          }

          if (result?.combat) {
            setCombatState(normalizeCombatState(result.combat));
          }
        } catch (error) {
          console.error(error);
          setStatus({
            type: 'danger',
            message: error.message || 'Failed to update enemy health.',
          });
        } finally {
          setEnemyHealthSaving((prev) => {
            const next = { ...prev };
            delete next[enemyId];
            return next;
          });
        }
      },
      [encodedCampaign, normalizeCombatState, setCombatState, setEnemies, setStatus]
    );

    const handleApplyEnemyHealthAdjustment = useCallback(
      (enemyId, direction) => {
        if (!enemyId || !direction) {
          return;
        }

        const enemy = enemies.find((entry) => entry?.enemyId === enemyId);
        if (!enemy) {
          return;
        }

        const rawInput = enemyHealthAdjustments[enemyId];
        const parsedInput = Number(rawInput);
        const adjustment = Number.isFinite(parsedInput) && parsedInput !== 0
          ? Math.abs(parsedInput)
          : 1;

        const maxHp = toFiniteNumberOrNull(enemy.maxHp ?? enemy.hitPoints);
        const currentHpCandidate =
          enemy.currentHp !== undefined
            ? toFiniteNumberOrNull(enemy.currentHp)
            : null;
        const baseCurrent =
          currentHpCandidate !== null
            ? currentHpCandidate
            : maxHp !== null
              ? maxHp
              : 0;

        let nextValue = baseCurrent + direction * adjustment;
        if (Number.isFinite(nextValue)) {
          if (nextValue < 0) {
            nextValue = 0;
          }
          if (maxHp !== null && nextValue > maxHp) {
            nextValue = maxHp;
          }
        }

        updateEnemyHealth(enemyId, nextValue, { delta: direction * adjustment });
      },
      [enemyHealthAdjustments, enemies, updateEnemyHealth]
    );

    const handleResetEnemyHealth = useCallback(
      (enemyId) => {
        if (!enemyId) {
          return;
        }

        const enemy = enemies.find((entry) => entry?.enemyId === enemyId);
        if (!enemy) {
          return;
        }

        const maxHp = toFiniteNumberOrNull(enemy.maxHp ?? enemy.hitPoints);
        if (maxHp === null) {
          return;
        }

        updateEnemyHealth(enemyId, maxHp);
      },
      [enemies, updateEnemyHealth]
    );

    const formatAttackBonus = useCallback((bonus) => {
      if (bonus === null || bonus === undefined || bonus === '') {
        return null;
      }

      const parsed = Number(bonus);
      if (!Number.isFinite(parsed)) {
        return null;
      }

      return parsed >= 0 ? `+${parsed}` : `${parsed}`;
    }, []);

    const getEnemyActionDamageString = useCallback((action) => {
      if (!action) {
        return null;
      }

      if (Array.isArray(action.damage) && action.damage.length > 0) {
        const parts = action.damage
          .map((damageEntry) => {
            if (!damageEntry || !damageEntry.damage_dice) {
              return null;
            }

            const typeName = damageEntry.damage_type?.name
              ? String(damageEntry.damage_type.name).toLowerCase()
              : '';
            return [damageEntry.damage_dice, typeName].filter(Boolean).join(' ');
          })
          .filter(Boolean);

        if (parts.length > 0) {
          return parts.join(' + ');
        }
      }

      if (action.damage_dice) {
        const typeName = action.damage_type?.name
          ? String(action.damage_type.name).toLowerCase()
          : '';
        return [action.damage_dice, typeName].filter(Boolean).join(' ');
      }

      return null;
    }, []);

    const formatChallengeRatingValue = useCallback((value) => {
      if (value === null || value === undefined || value === '') {
        return '—';
      }

      const numeric = Number(value);
      if (!Number.isFinite(numeric)) {
        return String(value);
      }

      const fractionMap = {
        '0.125': '1/8',
        '0.25': '1/4',
        '0.5': '1/2',
      };

      const fractionKey = numeric.toString();
      if (Object.prototype.hasOwnProperty.call(fractionMap, fractionKey)) {
        return fractionMap[fractionKey];
      }

      if (Number.isInteger(numeric)) {
        return numeric.toString();
      }

      return numeric.toString();
    }, []);

    const handleEnemyAttackRoll = useCallback(
      async (enemy, action, rollModeResult = {}) => {
        if (!enemy || !action) {
          return;
        }

        const rawBonus = Number(action.attack_bonus);
        // A bonus from the target's state (Sundering Blow), added to the shown total and reported back.
        const situational = Number(rollModeResult.situationalBonus?.value) || 0;
        const bonus = (Number.isFinite(rawBonus) ? rawBonus : 0) + situational;
        await showEnemyDiceOverlay();
        const diceModifiers = getRollDiceModifiers(combatState, String(enemy.enemyId || enemy._id), 'attack', rollModeResult.targetCombatantId);
        const { result, d20, keptD20, rolledD20s, rollMode, modifierDice } = await rollSkillWithDiceBox(bonus, {
          diceColor: DEFAULT_DICE_COLOR,
          rollMode: rollModeResult.mode,
          diceModifiers,
        });
        const enemyName = enemy.name || enemy.displayType || enemy.enemyId || 'Enemy';
        const actionName = action.name || 'Action';
        const naturalRoll = keptD20 ?? d20;
        const isCriticalHit = isCriticalAttackRoll(enemy, { kind: 'monster' }, naturalRoll);
        const segments = [rollMode === 'advantage' || rollMode === 'disadvantage' ? `${naturalRoll} (d20) (Rolled ${(rolledD20s || [d20]).join(' and ')})` : `${naturalRoll} (d20)`];
        if (bonus - situational) {
          const sign = bonus - situational >= 0 ? '+' : '-';
          segments.push(`${sign} ${Math.abs(bonus - situational)} Attack Bonus`);
        }
        if (situational) segments.push(`+ ${situational} ${rollModeResult.situationalBonus.label}`);

        window.dispatchEvent(
          new CustomEvent('damage-roll', {
            detail: {
              value: result,
              breakdown: [segments.join(' '), modifierDiceBreakdown(diceModifiers, modifierDice)].filter(Boolean).join(' '),
              source: `${enemyName} ${actionName} Attack Roll`,
              critical: isCriticalHit,
              fumble: naturalRoll === 1,
              rollLabel: 'Attack Roll',
              ...(rollModeResult.targeted ? { log: false } : {}),
              rollMode: rollMode || rollModeResult.mode,
              advantageSources: rollModeResult.advantageSources,
              disadvantageSources: rollModeResult.disadvantageSources,
              diceRolls: [
                ...modifierDiceRecords(diceModifiers, modifierDice),
                {
                  sides: 20,
                  value: naturalRoll,
                  type: 'Attack Roll',
                  category: 'base',
                },
              ],
            },
          })
        );

        displayEnemyDiceResults([
          {
            sides: 20,
            value: naturalRoll,
            type: 'Attack Roll',
            category: 'base',
          },
        ]);
        setEnemyRollPopup({
          value: result,
          label: 'Attack Roll',
          timestamp: Date.now(),
        });
        setLatestEnemyRoll({
          enemyId: enemy.enemyId,
          enemyName: combatantLabel(enemy, { dm: true }),
          actionName,
          total: result,
          breakdown: segments.join(' '),
          rollType: 'attack',
          isCriticalHit,
          naturalRoll,
        });
        setPendingEnemyCriticalAttack({
          enemyId: enemy.enemyId,
          actionName,
          isCriticalHit,
          naturalRoll,
          total: result,
        });
        return { naturalRoll, total: result, ...(situational ? { situationalBonus: situational } : {}) };
      },
      [combatState, displayEnemyDiceResults, showEnemyDiceOverlay]
    );

    const handleEnemyDamageRoll = useCallback(
      async (enemy, action, criticalOverride, options = {}) => {
        if (!enemy || !action) {
          return;
        }

        const damageString = getEnemyActionDamageString(action);
        if (!damageString) {
          setStatus({
            type: 'warning',
            message: 'No damage dice available for this action.',
          });
          return;
        }

        const enemyName = enemy.name || enemy.displayType || enemy.enemyId || 'Enemy';
        const actionName = action.name || 'Action';
        const isCriticalDamage = typeof criticalOverride === 'boolean' ? criticalOverride : Boolean(
          pendingEnemyCriticalAttack?.isCriticalHit &&
          pendingEnemyCriticalAttack?.enemyId === enemy.enemyId &&
          pendingEnemyCriticalAttack?.actionName === actionName
        );
        const validation = calculateDamage(damageString, 0, isCriticalDamage);
        if (!validation) {
          setStatus({
            type: 'warning',
            message: 'Unable to roll damage for this action.',
          });
          return;
        }

        let result = validation;
        await showEnemyDiceOverlay();
        const diceRequests = Array.isArray(validation.diceRolls)
          ? validation.diceRolls.reduce((requests, die) => {
              const sides = Number(die?.sides);
              if (!Number.isFinite(sides) || sides < 2) {
                return requests;
              }
              const existing = requests.find((request) => request.sides === sides);
              if (existing) {
                existing.count += 1;
              } else {
                requests.push({ count: 1, sides });
              }
              return requests;
            }, [])
          : [];

        if (diceRequests.length > 0) {
          try {
            setDiceBoxThemeColor(DEFAULT_DICE_COLOR);
            const { rolls } = await rollDiceWithBox(diceRequests);
            const rolledValuesBySides = new Map();
            diceRequests.forEach((request, requestIndex) => {
              const rawGroup = Array.isArray(rolls) ? rolls[requestIndex] : undefined;
              const values = Array.isArray(rawGroup) ? rawGroup : [rawGroup];
              rolledValuesBySides.set(
                request.sides,
                values
                  .map((value) => Number(value))
                  .filter((value) => Number.isFinite(value))
              );
            });

            result = calculateDamage(damageString, 0, isCriticalDamage, (count, sides) => {
              const queue = rolledValuesBySides.get(sides) || [];
              return Array.from({ length: count }, () => {
                const nextValue = queue.shift();
                return Number.isFinite(nextValue)
                  ? nextValue
                  : Math.floor(Math.random() * sides) + 1;
              });
            });
          } catch (error) {
            console.error('Enemy damage roll using dice box failed', error);
          }
        }

        if (!result) {
          setStatus({
            type: 'warning',
            message: 'Unable to roll damage for this action.',
          });
          return;
        }

        window.dispatchEvent(
          new CustomEvent('damage-roll', {
            detail: {
              value: result.total,
              breakdown: result.breakdown,
              source: isCriticalDamage ? `${enemyName} ${actionName} Critical Damage` : `${enemyName} ${actionName}`,
              rollLabel: isCriticalDamage ? 'Critical Damage' : 'Damage',
              ...(options.detailed ? { log: false } : {}),
              diceRolls: result.diceRolls,
              sourceLabel: `${enemyName} ${actionName}`,
              actionLabel: isCriticalDamage ? 'Critical Damage' : 'Damage',
              expression: isCriticalDamage ? createCriticalDamageFormula(damageString) : damageString,
            },
          })
        );

        displayEnemyDiceResults(result.diceRolls);
        setEnemyRollPopup({
          value: result.total,
          label: 'Damage',
          timestamp: Date.now(),
        });

        setLatestEnemyRoll({
          enemyId: enemy.enemyId,
          enemyName: combatantLabel(enemy, { dm: true }),
          actionName,
          total: result.total,
          breakdown: result.breakdown,
          damageFormula: isCriticalDamage ? createCriticalDamageFormula(damageString) : damageString,
          rollType: 'damage',
          isCriticalDamage,
        });
        if (pendingEnemyCriticalAttack?.enemyId === enemy.enemyId && pendingEnemyCriticalAttack?.actionName === actionName) {
          setPendingEnemyCriticalAttack(null);
        }
        // A targeted attack also needs each damage type's part (resistance applies per type).
        return options.detailed ? { total: result.total, parts: result.parts } : result.total;
      },
      [displayEnemyDiceResults, getEnemyActionDamageString, pendingEnemyCriticalAttack, setStatus, showEnemyDiceOverlay]
    );

    const handleEnemyMultiattackRoll = useCallback(async (enemy, multiattackAction) => {
      if (targetingLockRef.current || combatTargeting.status !== 'inactive') return;
      try { await enemyMultiattackRef.current?.open(enemy, multiattackAction); }
      catch (error) { setStatus({ type: 'warning', message: error.message }); }
    }, [combatTargeting.status, setStatus]);

    const beginEnemyTargeting = useCallback((enemy, action) => {
      const attackerId = enemy?.enemyId || enemy?._id;
      if (!attackerId || !action || targetingLockRef.current || enemyMultiattackRef.current?.isActive()) return;
      setCombatTargeting((previous) => previous.status === 'inactive'
        ? createEnemyAttackTargeting(enemy, action)
        : previous);
    }, []);

    const beginEnemySaveTargeting = useCallback((enemy, action) => {
      if (targetingLockRef.current || enemyMultiattackRef.current?.isActive()) return;
      const pending = createEnemySaveActionTargeting(enemy, action);
      if (pending) setCombatTargeting((previous) => previous.status === 'inactive' ? pending : previous);
    }, []);

    const challengeRatingOptions = useMemo(() => {
      if (!Array.isArray(monsterCatalog) || monsterCatalog.length === 0) {
        return [];
      }

      const values = new Set();
      monsterCatalog.forEach((monster) => {
        const rating =
          monster?.challengeRating !== undefined && monster?.challengeRating !== null
            ? monster.challengeRating
            : monster?.challenge_rating !== undefined && monster?.challenge_rating !== null
            ? monster.challenge_rating
            : null;
        const numeric = Number(rating);
        if (Number.isFinite(numeric)) {
          values.add(numeric);
        }
      });

      return Array.from(values)
        .sort((a, b) => a - b)
        .map((value) => ({
          value: value.toString(),
          label: formatChallengeRatingValue(value),
        }));
    }, [monsterCatalog, formatChallengeRatingValue]);

    useEffect(() => {
      if (monsterMinChallengeRating) {
        const hasOption = challengeRatingOptions.some(
          (option) => option.value === monsterMinChallengeRating
        );
        if (!hasOption) {
          setMonsterMinChallengeRating('');
        }
      }

      if (monsterMaxChallengeRating) {
        const hasOption = challengeRatingOptions.some(
          (option) => option.value === monsterMaxChallengeRating
        );
        if (!hasOption) {
          setMonsterMaxChallengeRating('');
        }
      }
    }, [challengeRatingOptions, monsterMinChallengeRating, monsterMaxChallengeRating]);

    const filteredMonsterCatalog = useMemo(() => {
      if (!Array.isArray(monsterCatalog) || monsterCatalog.length === 0) {
        return [];
      }

      const query = monsterSearch.trim().toLowerCase();
      const minValue =
        monsterMinChallengeRating !== '' ? Number(monsterMinChallengeRating) : null;
      const maxValue =
        monsterMaxChallengeRating !== '' ? Number(monsterMaxChallengeRating) : null;

      let effectiveMin = minValue;
      let effectiveMax = maxValue;
      if (effectiveMin !== null && effectiveMax !== null && effectiveMin > effectiveMax) {
        [effectiveMin, effectiveMax] = [effectiveMax, effectiveMin];
      }

      return monsterCatalog.filter((monster) => {
        const nameMatches =
          !query || monster?.name?.toLowerCase().includes(query);
        if (!nameMatches) {
          return false;
        }

        const ratingRaw =
          monster?.challengeRating !== undefined && monster?.challengeRating !== null
            ? monster.challengeRating
            : monster?.challenge_rating !== undefined && monster?.challenge_rating !== null
            ? monster.challenge_rating
            : null;
        const ratingNumeric = Number(ratingRaw);
        const hasNumericRating = Number.isFinite(ratingNumeric);

        if (effectiveMin !== null || effectiveMax !== null) {
          if (!hasNumericRating) {
            return false;
          }
          if (effectiveMin !== null && ratingNumeric < effectiveMin) {
            return false;
          }
          if (effectiveMax !== null && ratingNumeric > effectiveMax) {
            return false;
          }
        }

        return true;
      });
    }, [
      monsterCatalog,
      monsterSearch,
      monsterMinChallengeRating,
      monsterMaxChallengeRating,
    ]);

    useEffect(() => {
      if (!selectedMonsterIndex) {
        return;
      }

      const existsInFiltered = filteredMonsterCatalog.some(
        (monster) => monster?.index === selectedMonsterIndex
      );

      if (!existsInFiltered) {
        setSelectedMonsterIndex('');
        setSelectedMonster(null);
      }
    }, [filteredMonsterCatalog, selectedMonsterIndex, setSelectedMonster]);


    useEffect(() => {
      fetchRecords();
      return;
    }, [fetchRecords]);

    useEffect(() => {
      if (!campaignId) {
        if (socketRef.current) {
          socketRef.current.disconnect();
          socketRef.current = null;
        }
        return undefined;
      }

      const socketUrl = process.env.REACT_APP_API_URL || undefined;
      const socket = io(socketUrl, { withCredentials: true });
      socketRef.current = socket;

      const handleCombatUpdate = (state) => {
        const normalized = normalizeCombatState(state);
        if((normalized.orderRevision || 0)<(combatStateRef.current.orderRevision || 0)||(normalized.initiativeRevision||0)<(combatStateRef.current.initiativeRevision||0))return;
        combatStateRef.current = normalized;
        setCombatState(normalized);
        reactionWaitersRef.current.forEach((waiter, opportunityId) => {
          const opportunity = (normalized.reactionOpportunities || []).find((item) => item.opportunityId === opportunityId);
          if (opportunity && opportunity.status !== 'pending') {
            reactionWaitersRef.current.delete(opportunityId);
            waiter.resolve(opportunity);
          }
        });
      };

      const handleCharacterHealthUpdate = (update) => {
        if (!update || typeof update !== 'object') {
          return;
        }

        const normalizedCharacterId =
          typeof update.characterId === 'string' && update.characterId.trim() !== ''
            ? update.characterId.trim()
            : null;
        const normalizedRecordId =
          typeof update._id === 'string' && update._id.trim() !== ''
            ? update._id.trim()
            : null;

        if (!normalizedCharacterId && !normalizedRecordId) {
          return;
        }

        const nextTempHealthValue =
          update.tempHealth !== undefined && update.tempHealth !== null
            ? (() => {
                const numeric = Number(update.tempHealth);
                return Number.isFinite(numeric) ? numeric : update.tempHealth;
              })()
            : undefined;

        const nextHealthValue =
          update.health !== undefined && update.health !== null
            ? (() => {
                const numeric = Number(update.health);
                return Number.isFinite(numeric) ? numeric : update.health;
              })()
            : undefined;

        setRecords((prev) =>
          applyCharacterHealthUpdateToRecords({
            records: prev,
            update: {
              ...(normalizedRecordId ? { _id: normalizedRecordId } : {}),
              ...(normalizedCharacterId ? { characterId: normalizedCharacterId } : {}),
              tempHealth: nextTempHealthValue,
              health: nextHealthValue,
              ...(update.deathState ? { deathState: update.deathState } : {}),
              ...(Number.isFinite(update.temporaryHitPoints) ? { temporaryHitPoints: update.temporaryHitPoints } : {}),
            },
          })
        );
      };

      const handleMapUpdate = (mapData) => {
        if (mapData && typeof mapData === 'object') {
          const hasTokensByMapIdProp = Object.prototype.hasOwnProperty.call(
            mapData,
            'tokensByMapId'
          );
          const hasActiveTokensProp = Object.prototype.hasOwnProperty.call(
            mapData,
            'activeMapTokens'
          );
          const hasActiveIdProp = Object.prototype.hasOwnProperty.call(
            mapData,
            'activeMapId'
          );

          const sanitizedTokens = hasTokensByMapIdProp
            ? sanitizeTokensByMapId(mapData.tokensByMapId)
            : {};
          const sanitizedActiveTokens = hasActiveTokensProp
            ? sanitizeTokenDictionary(mapData.activeMapTokens)
            : {};
          const normalizedIncomingActiveId =
            hasActiveIdProp &&
            typeof mapData.activeMapId === 'string' &&
            mapData.activeMapId.trim() !== ''
              ? mapData.activeMapId.trim()
              : null;

          const tokenKeys = ['tokensByMapId', 'activeMapTokens', 'activeMapId'];
          const payloadKeys = Object.keys(mapData);
          const tokenOnlyUpdate =
            payloadKeys.length > 0 &&
            payloadKeys.every((key) => tokenKeys.includes(key)) &&
            (hasTokensByMapIdProp || hasActiveTokensProp || hasActiveIdProp);

          if (tokenOnlyUpdate) {
            const merged = mergeTokenPayload({
              incomingTokensByMapId: sanitizedTokens,
              incomingActiveMapTokens: sanitizedActiveTokens,
              incomingActiveMapId: normalizedIncomingActiveId,
              previousActiveMapId: activeMapIdRef.current,
              previousCampaignMap: campaignMapRef.current,
              previousMapTokens: mapTokensRef.current || {},
            });

            setActiveMapId(merged.activeMapId);
            setMapTokens(merged.mapTokens);
            setActiveMapTokens(merged.activeMapTokens);
            setCampaignMap(merged.campaignMap);
            setGeneratedMap(null);
            return;
          }

          let workingPayload = mapData;

          if (hasTokensByMapIdProp) {
            const incomingKeys = Object.keys(mapData.tokensByMapId || {}).reduce(
              (acc, key) => {
                if (typeof key !== 'string') {
                  return acc;
                }
                const trimmed = key.trim();
                if (trimmed) {
                  acc.push(trimmed);
                }
                return acc;
              },
              []
            );

            if (incomingKeys.length === 0) {
              workingPayload = { ...workingPayload, tokensByMapId: sanitizedTokens };
            } else {
              const mergedTokens = { ...(mapTokensRef.current || {}) };
              incomingKeys.forEach((mapId) => {
                if (Object.prototype.hasOwnProperty.call(sanitizedTokens, mapId)) {
                  mergedTokens[mapId] = sanitizedTokens[mapId];
                } else {
                  delete mergedTokens[mapId];
                }
              });
              workingPayload = { ...workingPayload, tokensByMapId: mergedTokens };
            }
          }

          if (hasActiveTokensProp) {
            workingPayload = { ...workingPayload, activeMapTokens: sanitizedActiveTokens };
            if (workingPayload.map && typeof workingPayload.map === 'object') {
              workingPayload = {
                ...workingPayload,
                map: { ...workingPayload.map, tokens: sanitizedActiveTokens },
              };
            }
          }

          if (
            Array.isArray(workingPayload.maps) ||
            workingPayload.activeMapId !== undefined ||
            (workingPayload.map && typeof workingPayload.map === 'object')
          ) {
            applyMapPayload(workingPayload);
          } else {
            const normalizedMap = workingPayload;
            const normalizedMapId =
              typeof normalizedMap?.mapId === 'string' && normalizedMap.mapId.trim() !== ''
                ? normalizedMap.mapId.trim()
                : null;
            applyMapPayload({
              maps: normalizedMapId ? [normalizedMap] : [],
              activeMapId: normalizedMapId,
              map: normalizedMap,
            });
          }
        } else {
          applyMapPayload({ maps: [], activeMapId: null, map: null });
        }
        setGeneratedMap(null);
      };

      const handleEnemiesUpdate = (roster) => {
        if (!Array.isArray(roster)) {
          setEnemies([]);
          return;
        }

        const sanitized = roster.filter((entry) => entry && typeof entry === 'object');
        setEnemies(sanitized);
      };

      const handleCharacterMetadataUpdate = (update) => {
        if (!update || typeof update !== 'object') {
          return;
        }

        const normalizedCharacterId =
          typeof update.characterId === 'string' && update.characterId.trim() !== ''
            ? update.characterId.trim()
            : null;

        if (!normalizedCharacterId) {
          return;
        }

        if (update.rest) setRecords(previous => previous.map(record => [record._id, record.characterId].filter(Boolean).map(String).includes(normalizedCharacterId) ? applyRestSnapshot(record, update.rest) : record));

        if (update.disposition !== undefined) setRecords(previous => previous.map(record => [record._id, record.characterId].filter(Boolean).map(String).includes(normalizedCharacterId) ? { ...record, disposition: update.disposition } : record));

        if (update.inventoryChanged) { void fetchRecords(); return; }

        if (update.fighterResources) {
          setRecords(previous => previous.map(record => [record._id,record.characterId].filter(Boolean).map(String).includes(normalizedCharacterId)
            ? applyFighterResourceUpdate(record,update.fighterResources) : record));
        }

        if (update.layOnHands) {
          setRecords(previous => previous.map(record => [record._id, record.characterId].filter(Boolean).map(String).includes(normalizedCharacterId)
            ? applyLayOnHandsUpdate(record, update.layOnHands) : record));
        }

        if (update.aidHitPointBonus !== undefined) {
          setRecords(previous => previous.map(record => [record._id, record.characterId].filter(Boolean).map(String).includes(normalizedCharacterId)
            ? { ...record, aidHitPointBonus: update.aidHitPointBonus } : record));
        }

        if (update.channelDivinity?.classId) {
          const { classId: divinityClass, ...channelDivinity } = update.channelDivinity;
          setRecords(previous => previous.map(record => [record._id, record.characterId].filter(Boolean).map(String).includes(normalizedCharacterId)
            ? applyChannelDivinityUpdate(record, divinityClass, channelDivinity) : record));
        }

        if (update.rage) setRecords(previous => previous.map(record => [record._id, record.characterId].filter(Boolean).map(String).includes(normalizedCharacterId) ? mergeRage(record, update.rage) : record));

        if (update.fightingStyle) {
          setRecords(previous => previous.map(record => [record._id, record.characterId].filter(Boolean).map(String).includes(normalizedCharacterId)
            ? { ...record, classState: { ...record.classState, [update.fightingStyleClass || 'fighter']: { ...record.classState?.[update.fightingStyleClass || 'fighter'], fightingStyle: update.fightingStyle } } } : record));
        }

        if (update.wizardState) {
          setRecords(previous => previous.map(record => [record._id, record.characterId].filter(Boolean).map(String).includes(normalizedCharacterId)
            ? { ...record, classState: { ...record.classState, wizard: { ...record.classState?.wizard, ...update.wizardState } } } : record));
        }
        if (update.divineOrder || update.blessedStrikes) {
          setRecords(previous => previous.map(record => [record._id, record.characterId].filter(Boolean).map(String).includes(normalizedCharacterId)
            ? { ...record, ...(update.occupation ? { occupation: update.occupation } : {}), classState: { ...record.classState, cleric: { ...record.classState?.cleric,
              ...(update.divineOrder ? { divineOrder: update.divineOrder } : {}), ...(update.blessedStrikes ? { blessedStrikes: update.blessedStrikes } : {}) } } } : record));
        }
        if (update.primalOrder || update.elementalFury) {
          setRecords(previous => previous.map(record => [record._id, record.characterId].filter(Boolean).map(String).includes(normalizedCharacterId)
            ? { ...record, ...(update.occupation ? { occupation: update.occupation } : {}), classState: { ...record.classState, druid: { ...record.classState?.druid,
              ...(update.primalOrder ? { primalOrder: update.primalOrder } : {}), ...(update.elementalFury ? { elementalFury: update.elementalFury } : {}) } } } : record));
        }
        if (update.wildShape) {
          setRecords(previous => previous.map(record => ([record._id, record.characterId].filter(Boolean).map(String).includes(normalizedCharacterId)
            ? { ...applyWildShapeUpdate(record, update.wildShape), ...(update.temporarySize !== undefined ? { temporarySize: update.temporarySize } : {}) } : record)));
        }
        if (update.huntersPrey) {
          setRecords(previous => previous.map(record => [record._id, record.characterId].filter(Boolean).map(String).includes(normalizedCharacterId)
            ? { ...record, classState: { ...record.classState, ranger: { ...record.classState?.ranger, huntersPrey: update.huntersPrey } } } : record));
        }

        const normalizedDiceColor =
          typeof update.diceColor === 'string' && update.diceColor.trim() !== ''
            ? update.diceColor.trim()
            : null;

        if (!normalizedDiceColor) {
          return;
        }

        setRecords((prev) => {
          if (!Array.isArray(prev) || prev.length === 0) {
            return prev;
          }

          let didUpdate = false;
          const next = prev.map((record) => {
            if (!record || typeof record !== 'object') {
              return record;
            }

            const identifiers = [];
            if (typeof record._id === 'string' && record._id.trim() !== '') {
              identifiers.push(record._id.trim());
            }
            if (typeof record.characterId === 'string' && record.characterId.trim() !== '') {
              identifiers.push(record.characterId.trim());
            }

            if (!identifiers.includes(normalizedCharacterId)) {
              return record;
            }

            if (
              typeof record.diceColor === 'string' &&
              record.diceColor.trim() === normalizedDiceColor
            ) {
              return record;
            }

            didUpdate = true;
            return { ...record, diceColor: normalizedDiceColor };
          });

          return didUpdate ? next : prev;
        });
      };

      const handleSaveDamageUpdate = (resolution) => {
        window.dispatchEvent(new CustomEvent(SPELL_DAMAGE_FEEDBACK_EVENT, { detail: resolution }));
        notifyEnemySaveDamageRef.current(resolution);
        refreshEnemyTargetSaveRef.current();
        if (!resolution?.resolutionId || !locallyInitiatedEnemySaveRef.current.has(resolution.resolutionId)) return;
        if (resolution.status === 'cancelled') {
          locallyInitiatedEnemySaveRef.current.delete(resolution.resolutionId);
          setEnemySaveDamage(null);
        } else if (resolution.status === 'finalized') {
          locallyInitiatedEnemySaveRef.current.delete(resolution.resolutionId);
          setEnemySaveDamage({ resolutionId: resolution.resolutionId, targetCombatantId: resolution.targetCombatantId,
            result: resolution, status: 'complete' });
          const finalDamage = resolution.damageOutcome?.finalDamage;
          setLatestEnemyRoll({ enemyId: resolution.sourceCombatantId, actionName: resolution.sourceEffect?.displayName || 'Save Action',
            total: finalDamage, breakdown: `${finalDamage} ${resolution.rules?.damage?.components?.[0]?.type || 'damage'}`,
            rollType: 'save-damage', targetId: resolution.targetCombatantId });
        } else setEnemySaveDamage((current) => current?.resolutionId === resolution.resolutionId ? { ...current, result: resolution, status: 'waiting-save' } : current);
      };

      let rageReconnectLive = true;
      const handleRageReconnect = () => {
        socket.emit('campaign:join', campaignId);
        void enemyMultiattackRef.current?.recover();
        apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/characters`, { cache: 'no-store' }).then(r => r.ok ? r.json() : null).then(characters => {
          if (!rageReconnectLive || !Array.isArray(characters)) return;
          setRecords(previous => previous.map(record => {
            const fresh = characters.find(c => String(c._id) === String(record._id));
            return fresh?.classState?.barbarian?.rage ? mergeRage(record, fresh.classState.barbarian.rage) : record;
          }));
        }).catch(() => {});
      };
      socket.on('connect', handleRageReconnect);
      socket.on('combat:update', handleCombatUpdate);
      socket.on('character:health:update', handleCharacterHealthUpdate);
      socket.on('campaign:map:update', handleMapUpdate);
      socket.on('campaign:enemies:update', handleEnemiesUpdate);
      socket.on('campaign:characters:update', handleCharacterMetadataUpdate);
      socket.on('save-damage:update', handleSaveDamageUpdate);
      const unbindSpellRefresh = bindSpellRefreshEvents(socket, campaignId);
      socket.emit('campaign:join', campaignId);
      refreshEnemyTargetSaveRef.current();
      const unbindCriticalRollTransport = bindCriticalRollTransport(socket, campaignId);

      return () => {
        unbindSpellRefresh();
        rageReconnectLive = false;
        socket.off('connect', handleRageReconnect);
        socket.off('combat:update', handleCombatUpdate);
        socket.off('character:health:update', handleCharacterHealthUpdate);
        socket.off('campaign:map:update', handleMapUpdate);
        socket.off('campaign:enemies:update', handleEnemiesUpdate);
        socket.off('campaign:characters:update', handleCharacterMetadataUpdate);
        socket.off('save-damage:update', handleSaveDamageUpdate);
        unbindCriticalRollTransport();
        socket.emit('campaign:leave', campaignId);
        socket.disconnect();
        socketRef.current = null;
      };
    }, [campaignId, applyMapPayload]);

    const enemySaveEvidenceRef = useRef(new Map());
    // The Improve Fate window resolver, defined further down (the save waits on it like an attack does).
    const fateWindowResolverRef = useRef(null);
    const answerEnemyTargetSave = useCallback(async (choice) => {
      if (!pendingEnemyTargetSave || resolvingEnemyTargetSave) return;
      setResolvingEnemyTargetSave(true); setEnemyTargetSaveError('');
      try {
        const captured = enemySaveEvidenceRef.current.get(pendingEnemyTargetSave.resolutionId);
        if (captured && captured.choice !== choice) throw new Error('Retry the original save choice.');
        let naturalD20 = captured?.naturalD20; let saveDice = captured?.saveDice; let modifierDice = captured?.modifierDice;
        if (choice === 'roll' && !captured) {
          await showEnemyDiceOverlay();
          setDiceBoxThemeColor(DEFAULT_DICE_COLOR);
          const roll = await rollDiceWithBox([{ count: saveRollDiceCount(pendingEnemyTargetSave), sides: 20 }, ...modifierDiceGroups(pendingEnemyTargetSave.targetSave?.diceModifiers)]);
          saveDice = roll?.rolls?.[0];
          modifierDice = readModifierDice(roll, pendingEnemyTargetSave.targetSave?.diceModifiers);
          naturalD20 = selectSaveD20(saveDice, pendingEnemyTargetSave.targetSave?.rollMode);
          if (!Number.isInteger(naturalD20)) throw new Error('Save dice evidence was unavailable.');
          displayEnemyDiceResults(saveDice.map((value) => ({ sides: 20, value, type: 'Saving Throw' })));
        }
        const rolled = captured || (choice === 'roll' ? { choice, naturalD20, ...(modifierDice?.length ? { modifierDice } : {}), ...(saveRollDiceCount(pendingEnemyTargetSave) > 1 ? { saveDice } : {}) } : { choice });
        enemySaveEvidenceRef.current.set(pendingEnemyTargetSave.resolutionId, rolled);
        // Improve Fate against the creature (another character's Boon of Fate): a save that looks successful can lose 2d4
        // before it is sent; the server checks the window and recalculates. The window replays by save, so a retry
        // keeps the dice above and the same answer.
        let fateWindowId = rolled.fateWindowId;
        const targetSave = pendingEnemyTargetSave.targetSave || {};
        if (choice === 'roll' && !fateWindowId && targetSave.ability && Number.isFinite(targetSave.dc)) {
          const saverId = pendingEnemyTargetSave.targetCombatantId;
          const saver = characterLookupRef.current?.get(saverId);
          const estimate = naturalD20 + getCombatantSaveModifier(saver || {}, targetSave.ability) + modifierDiceTotal(targetSave.diceModifiers, modifierDice || []);
          if (estimate >= targetSave.dc) {
            const used = await fateWindowResolverRef.current?.({ kind: 'save', resolutionId: `save:${pendingEnemyTargetSave.resolutionId}`, saverId,
              saveTotal: estimate, dc: targetSave.dc, ability: targetSave.ability,
              ...(pendingEnemyTargetSave.sourceEffect?.displayName ? { spellName: pendingEnemyTargetSave.sourceEffect.displayName } : {}) });
            if (used?.windowId) fateWindowId = used.windowId;
          }
        }
        const savePayload = fateWindowId ? { ...rolled, fateWindowId } : rolled;
        enemySaveEvidenceRef.current.set(pendingEnemyTargetSave.resolutionId, savePayload);
        const response = await apiFetch(`/campaigns/${encodedCampaign}/resolutions/${encodeURIComponent(pendingEnemyTargetSave.resolutionId)}/save-response`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(savePayload),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result?.message || 'The saving throw could not be submitted.');
        enemySaveEvidenceRef.current.delete(pendingEnemyTargetSave.resolutionId);
        notifyEnemySaveDamage(result);
        setPendingEnemyTargetSave(null);
        await refreshEnemyTargetSaveRef.current();
      } catch (error) { setEnemyTargetSaveError(`${error.message} Please try again.`); }
      finally { setResolvingEnemyTargetSave(false); }
    }, [encodedCampaign, pendingEnemyTargetSave, resolvingEnemyTargetSave, showEnemyDiceOverlay, displayEnemyDiceResults, notifyEnemySaveDamage]);

    const persistTokenPosition = useCallback(
      async ({ mapId, characterId, x, y, rotation }) => {
        const normalizedMapId =
          typeof mapId === 'string' && mapId.trim() !== '' ? mapId.trim() : null;
        const normalizedCharacterId =
          typeof characterId === 'string' && characterId.trim() !== ''
            ? characterId.trim()
            : null;

        const clampedX = clamp01(x);
        const clampedY = clamp01(y);
        const normalizedRotation = normalizeRotation(rotation);

        if (!normalizedMapId || !normalizedCharacterId || clampedX === null || clampedY === null) {
          return;
        }

        if (!encodedCampaign) {
          return;
        }

        const previousTokens = mapTokensRef.current || {};
        const previousActiveTokens = activeMapTokensRef.current || {};
        const previousCampaignMap = campaignMap;

        const optimisticToken = {
          ...(previousTokens?.[normalizedMapId]?.[normalizedCharacterId] || {}),
          characterId: normalizedCharacterId,
          x: clampedX,
          y: clampedY,
          updatedAt: new Date().toISOString(),
          ...(normalizedRotation !== null ? { rotation: normalizedRotation } : {}),
        };

        setMapTokens((prev) => {
          const next = { ...(prev || {}) };
          const existing = { ...(next[normalizedMapId] || {}) };
          existing[normalizedCharacterId] = optimisticToken;
          next[normalizedMapId] = existing;
          return next;
        });

        if (normalizedMapId === activeMapId) {
          setActiveMapTokens((prev) => ({
            ...(prev || {}),
            [normalizedCharacterId]: optimisticToken,
          }));
        }

        setCampaignMap((prev) => {
          if (!prev || prev.mapId !== normalizedMapId) {
            return prev;
          }
          return {
            ...prev,
            tokens: {
              ...(prev.tokens || {}),
              [normalizedCharacterId]: optimisticToken,
            },
          };
        });

        try {
          const encodedMapId = encodeURIComponent(normalizedMapId);
          const encodedCharacterId = encodeURIComponent(normalizedCharacterId);
          const response = await apiFetch(
            `/campaigns/${encodedCampaign}/maps/${encodedMapId}/tokens/${encodedCharacterId}`,
            {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(
                normalizedRotation !== null
                  ? { x: clampedX, y: clampedY, rotation: normalizedRotation }
                  : { x: clampedX, y: clampedY }
              ),
            }
          );

          if (!response.ok) {
            const message = await parseErrorMessage(
              response,
              'Failed to update token position.'
            );
            throw new Error(message);
          }
          return true;
        } catch (error) {
          console.error(error);
          setStatus({
            type: 'danger',
            message: error.message || 'Failed to update token position.',
          });
          setMapTokens(previousTokens || {});
          setActiveMapTokens(previousActiveTokens || {});
          setCampaignMap(previousCampaignMap || null);
          return false;
        }
      },
      [activeMapId, campaignMap, encodedCampaign, parseErrorMessage, setStatus]
    );

    const persistCombatState = useCallback(
      async (nextState) => {
        if (!campaignId || !encodedCampaign) {
          return;
        }

        const normalizedState = normalizeCombatState(nextState);
        // The turn this edit was made from (callers save right after deriving the change); the server refuses a
        // save from an older turn.
        const expectedTurnSequence = combatStateRef.current?.turnSequence ?? 0;

        try {
          const response = await apiFetch(`/campaigns/${encodedCampaign}/combat`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...normalizedState, expectedTurnSequence }),
          });

          if (!response.ok) {
            const failure = await response.json().catch(() => ({}));
            throw new Error(failure.message || failure.reason || failure.errors?.[0]?.msg || response.statusText || 'Failed to update combat state');
          }

          const updatedState = await response.json();
          const normalizedUpdatedState = normalizeCombatState(updatedState);
          if((normalizedUpdatedState.orderRevision || 0)<(combatStateRef.current.orderRevision || 0))return combatStateRef.current;
          combatStateRef.current = normalizedUpdatedState;
          setCombatState(normalizedUpdatedState);
          return normalizedUpdatedState;
        } catch (error) {
          console.error(error);
          setStatus({
            type: 'danger',
            message: error.message || 'Failed to update combat state.',
          });
          await fetchRecords();
          return null;
        }
      },
      [campaignId, encodedCampaign, fetchRecords]
    );

    const handleReorderCombat = useCallback(async orderedIds=>{
      const current=combatState;
      try {
        const response=await apiFetch(`/campaigns/${encodedCampaign}/combat/order`,{
          method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({orderedIds,expectedOrder:current.participants.map(p=>p.characterId),expectedRevision:current.orderRevision || 0}),
        });
        const result=await response.json();
        if(!response.ok)throw new Error(result.message || 'Unable to reorder initiative.');
        const latest=normalizeCombatState(result);
        if((combatStateRef.current.orderRevision || 0)<=(latest.orderRevision || 0) && (combatStateRef.current.turnSequence || 0)<=latest.turnSequence){combatStateRef.current=latest;setCombatState(latest);}
        return true;
      }catch(error){notify(error.message);await fetchRecords();return false;}
    },[combatState,encodedCampaign,fetchRecords]);
    const combatOrderDrag=useCombatOrderDrag({ids:combatState.participants.map(p=>p.characterId),enabled:campaignDM.dm===user?.username,onReorder:handleReorderCombat});

    const getEntityId = useCallback((entity) => {
      if (!entity || typeof entity !== 'object') {
        return null;
      }
      if (entity.entityType === 'enemy' && typeof entity.enemyId === 'string') {
        return entity.enemyId;
      }
      if (typeof entity._id === 'string' && entity._id) {
        return entity._id;
      }
      if (typeof entity.characterId === 'string' && entity.characterId) {
        return entity.characterId;
      }
      if (typeof entity.token === 'string' && entity.token) {
        return entity.token;
      }
      return null;
    }, []);

    const normalizedEnemies = useMemo(() => {
      if (!Array.isArray(enemies)) {
        return [];
      }

      return enemies.map((enemy) => {
        const typeLabel = [enemy?.size, enemy?.type].filter(Boolean).join(' ');
        const maxHp = toFiniteNumberOrNull(enemy.hitPoints);
        const currentHpCandidate =
          enemy.currentHp !== undefined
            ? toFiniteNumberOrNull(enemy.currentHp)
            : null;
        const currentHp =
          currentHpCandidate !== null
            ? currentHpCandidate
            : maxHp !== null
              ? maxHp
              : null;
        return {
          ...enemy,
          entityType: 'enemy',
          _id: enemy.enemyId,
          characterName: enemy.name,
          token: typeLabel || 'Enemy',
          displayType: typeLabel,
          ...(currentHp !== null ? { currentHp } : {}),
          ...(maxHp !== null ? { maxHp } : {}),
        };
      });
    }, [enemies]);

    const combinedRecords = useMemo(() => {
      const characterRecords = Array.isArray(records)
        ? records.map((character) => ({ ...character, entityType: 'character' }))
        : [];
      return [...characterRecords, ...normalizedEnemies];
    }, [records, normalizedEnemies]);


    const characterLookup = useMemo(() => {
      const map = new Map();
      if (Array.isArray(combinedRecords)) {
        combinedRecords.forEach((entity) => {
          const id = getEntityId(entity);
          if (!id) {
            return;
          }
          map.set(id, entity);
        });
      }
      return map;
    }, [combinedRecords, getEntityId]);
    const characterLookupRef = useRef(characterLookup);
    characterLookupRef.current = characterLookup;

    const finishReactionWaiter = useCallback((opportunity) => {
      const waiter = reactionWaitersRef.current.get(opportunity?.opportunityId);
      if (!waiter || opportunity?.status === 'pending') return;
      reactionWaitersRef.current.delete(opportunity.opportunityId);
      waiter.resolve(opportunity);
    }, []);

    const waitForDefenderReaction = useCallback((opportunityId) => new Promise((resolve, reject) => {
      const existing = (combatStateRef.current.reactionOpportunities || [])
        .find((item) => item.opportunityId === opportunityId);
      if (existing && existing.status !== 'pending') {
        resolve(existing);
        return;
      }
      reactionWaitersRef.current.set(opportunityId, { resolve, reject });
      // Close the response/socket race: the decision may have arrived between the
      // POST response and waiter registration.
      const reconciled = (combatStateRef.current.reactionOpportunities || [])
        .find((item) => item.opportunityId === opportunityId);
      if (reconciled && reconciled.status !== 'pending') finishReactionWaiter(reconciled);
    }), [finishReactionWaiter]);

    const resolveEnemyDefenderReaction = useCallback(async (payload) => {
      const created = await createDefenderReactionOpportunity(campaignId, payload);
      if (created.combat) {
        const normalized = normalizeCombatState(created.combat);
        combatStateRef.current = normalized;
        setCombatState(normalized);
      }
      if (created.status === 'no-candidates') return { incomingDamageModifiers: [] };
      if (created.status === 'resolved') return { opportunity: created.opportunity, incomingDamageModifiers: [] };
      const opportunity = created.opportunity;
      if (!opportunity?.opportunityId) throw new Error('The defender reaction handshake was not established.');
      const targetName = combatantLabel(characterLookupRef.current.get(payload.targetCombatantId), { dm: true, fallback: 'the defender' });
      setPendingDefenderReaction({ ...opportunity, targetName });
      try {
        const resolved = opportunity.status === 'pending'
          ? await waitForDefenderReaction(opportunity.opportunityId)
          : opportunity;
        if (!['used', 'skipped'].includes(resolved?.status)) {
          throw new Error('The defender reaction handshake closed unexpectedly.');
        }
        return {
          opportunity: resolved,
          incomingDamageModifiers: defenderDamageModifiers(resolved),
        };
      } finally {
        setPendingDefenderReaction((current) => current?.opportunityId === opportunity.opportunityId ? null : current);
      }
    }, [campaignId, waitForDefenderReaction]);

    // Improve Fate (Boon of Fate) against a monster's hit: a holder within 60 feet may subtract 2d4 before damage. The
    // attack waits for the window to close (used, every holder declined, or the DM skipped it).
    const [pendingFateWindow, setPendingFateWindow] = useState(null);
    const waitForFateWindow = useCallback((windowId, sync = syncFateWindows) => new Promise(resolve => {
      let finished = false;
      const check = async () => {
        if (finished) return;
        try {
          const current = (await sync(campaignId, { windowId })).windows?.[0];
          if (!current || current.status !== 'pending') { finished = true; cleanup(); resolve(current || { status: 'skipped' }); }
        } catch { /* The next event or tick retries. */ }
      };
      const onEvent = event => { if (event.detail?.campaignId === campaignId && event.detail?.fateWindows) check(); };
      const timer = setInterval(check, 2000);
      const cleanup = () => { clearInterval(timer); window.removeEventListener(SPELL_REFRESH_EVENT, onEvent); };
      window.addEventListener(SPELL_REFRESH_EVENT, onEvent);
      check();
    }), [campaignId]);
    const resolveEnemyFateWindow = useCallback(async (attack) => {
      const opened = await openFateWindow(campaignId, attack);
      let fateWindow = opened.window;
      if (!fateWindow) return null;
      if (fateWindow.status === 'pending') {
        setPendingFateWindow(fateWindow);
        try { fateWindow = await waitForFateWindow(fateWindow.windowId); }
        finally { setPendingFateWindow(current => (current?.windowId === opened.window.windowId ? null : current)); }
      }
      return fateWindow.status === 'used' ? { windowId: fateWindow.windowId, penalty: fateWindow.penalty, rolls: fateWindow.rolls, by: fateWindow.usedBy?.name || 'an ally' } : null;
    }, [campaignId, waitForFateWindow]);
    fateWindowResolverRef.current = resolveEnemyFateWindow;
    // Cutting Words waits the same way, and shares the status line (`cuttingWords` tells them apart).
    const resolveEnemyCuttingWords = useCallback(async (request) => {
      const opened = await openCuttingWords(campaignId, request);
      let cut = opened.window;
      if (!cut) return null;
      if (cut.status === 'pending') {
        setPendingFateWindow({ ...cut, cuttingWords: true });
        try { cut = await waitForFateWindow(cut.windowId, syncCuttingWords); }
        finally { setPendingFateWindow(current => (current?.windowId === opened.window.windowId ? null : current)); }
      }
      return cut.status === 'used' ? { penalty: cut.penalty, rolls: cut.rolls, sides: cut.sides, by: cut.usedBy?.name || 'an ally' } : null;
    }, [campaignId, waitForFateWindow]);
    // An enemy casting waits for anyone who can react: Counterspell, or Shield against Magic Missile. The DM can skip.
    const [pendingCastWindow, setPendingCastWindow] = useState(null);
    const resolveEnemyCastWindow = useCallback(async (cast) => {
      const opened = await openCastWindow(campaignId, cast);
      if (!opened.window) return null;
      if (opened.window.status !== 'pending') return opened.window;
      setPendingCastWindow(opened.window);
      try { return await waitForFateWindow(opened.window.windowId, syncCastWindows); }
      finally { setPendingCastWindow(current => (current?.windowId === opened.window.windowId ? null : current)); }
    }, [campaignId, waitForFateWindow]);
    const skipPendingCastWindow = useCallback(async () => {
      if (!pendingCastWindow?.windowId) return;
      try { await decideCastWindow(campaignId, pendingCastWindow.windowId, { decision: 'skip' }); }
      catch (error) { setStatus({ type: 'danger', message: error?.message || 'The Reaction could not be skipped.' }); }
    }, [campaignId, pendingCastWindow]);
    const skipPendingFateWindow = useCallback(async () => {
      if (!pendingFateWindow?.windowId) return;
      try { await (pendingFateWindow.cuttingWords ? decideCuttingWords : decideFateWindow)(campaignId, pendingFateWindow.windowId, { decision: 'skip' }); }
      catch (error) { setStatus({ type: 'danger', message: error?.message || 'Improve Fate could not be skipped.' }); }
    }, [campaignId, pendingFateWindow]);

    const skipPendingDefenderReaction = useCallback(async () => {
      if (!pendingDefenderReaction?.opportunityId) return;
      try {
        const response = await decideDefenderReaction(campaignId, pendingDefenderReaction.opportunityId, 'skip');
        if (response.combat) {
          const normalized = normalizeCombatState(response.combat);
          combatStateRef.current = normalized;
          setCombatState(normalized);
        }
        finishReactionWaiter(response.opportunity);
      } catch (error) {
        setStatus({ type: 'danger', message: error?.message || 'The Reaction could not be skipped.' });
      }
    }, [campaignId, finishReactionWaiter, pendingDefenderReaction]);

    const handleEnemyTargetClick = useCallback(async (targetId, reactionRequest = null) => {
      const targeting = reactionRequest || combatTargeting;
      if (targeting.status !== 'selecting-target' || targetingLockRef.current) { if(reactionRequest)throw new Error('Another attack is being resolved.');return; }
      if (!targetId || (targetId === targeting.sourceCombatantId && !targeting.allowSelfTarget)) return;
      if (!characterLookup.has(targeting.sourceCombatantId)) {
        setCombatTargeting(INACTIVE_COMBAT_TARGETING);
        return;
      }
      const target = characterLookup.get(targetId);
      if (!target) {
        setStatus({ type: 'warning', message: 'That map object is not a valid combat target.' });
        return;
      }
      if (targeting.enemySpell) {
        targetingLockRef.current=true;
        try { await enemySpellsRef.current?.chooseTarget({ ...targeting,targetId,target:{...target,armorClass:resolveCombatantArmorClass(target,{combatState,targetCombatantId:targetId}),currentHp:Number(target.currentHp ?? target.tempHealth ?? target.health ?? target.hitPoints)} }); }
        catch(error) { setStatus({type:'danger',message:error.message}); }
        finally { targetingLockRef.current=false; }
        return;
      }
      if (targeting.lockedTargetCombatantId && targeting.lockedTargetCombatantId !== targetId) return;
      const currentHp = toFiniteNumberOrNull(target?.currentHp ?? target?.tempHealth ?? target?.health ?? target?.maxHp ?? target?.hitPoints);
      if (currentHp === null || (currentHp <= 0 && !targeting.allowResolvedTarget)) return;
      if (targeting.actionType === 'save-damage') {
        targetingLockRef.current = true;
        const uuid = typeof crypto !== 'undefined' ? crypto.randomUUID?.() : null;
        const resolutionId = uuid || `enemy-save:${targeting.sourceCombatantId}:${Date.now()}`;
        setCombatTargeting((previous) => ({ ...previous, status: 'resolving', targetCombatantId: targetId }));
        try {
          const response = await apiFetch(`/campaigns/${encodedCampaign}/resolutions/enemies/${encodeURIComponent(targeting.sourceCombatantId)}/actions/${encodeURIComponent(targeting.sourceActionId)}/prepare`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ resolutionId, targetCombatantId: targetId }),
          });
          const prepared = await response.json();
          if (!response.ok) throw new Error(prepared?.message || prepared?.errors?.[0]?.msg || 'The save action could not be prepared.');
          locallyInitiatedEnemySaveRef.current.add(resolutionId);
          if (prepared.actionLedger) {
            const normalized = normalizeCombatState({ ...combatStateRef.current, turnActionLedger: prepared.actionLedger });
            combatStateRef.current = normalized; setCombatState(normalized);
          }
          setEnemySaveDamage({ resolutionId, targetCombatantId: targetId, prepared, status: 'rolling-damage' });
          const formula = prepared.rules?.damage?.components?.[0]?.formula;
          if (formula !== '4d6') throw new Error('The server returned an unsupported monster damage formula.');
          // Mount the shared DiceBox surface before starting the roll. Unlike a
          // normal enemy attack, save actions have no preceding d20 roll to do
          // this for them, so rolling immediately would leave DiceBox targeting
          // an unmounted container and only the (invisible) fallback result.
          await showEnemyDiceOverlay();
          setDiceBoxThemeColor(DEFAULT_DICE_COLOR);
          const roll = await rollDiceWithBox([{ count: 4, sides: 6 }]);
          const dice = sanitizeRollGroup(roll?.rolls?.[0], 4, 6);
          if (!dice) throw new Error('Damage dice evidence was unavailable. Retry this resolution without rerolling.');
          displayEnemyDiceResults(dice.map((value) => ({
            sides: 6, value, type: 'Acid Damage', category: 'base',
          })));
          setEnemySaveDamage((current) => ({ ...current, damageDice: dice, status: 'recording-damage' }));
          const evidenceResponse = await apiFetch(`/campaigns/${encodedCampaign}/resolutions/${encodeURIComponent(resolutionId)}/damage-evidence`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ damageDice: [dice] }),
          });
          const result = await evidenceResponse.json();
          if (!evidenceResponse.ok) throw new Error(result?.message || 'Damage evidence could not be recorded; retry this roll.');
          setEnemySaveDamage({ resolutionId, targetCombatantId: targetId, prepared, damageDice: dice, result,
            status: result.status === 'finalized' ? 'complete' : 'waiting-save' });
        } catch (error) {
          setStatus({ type: 'danger', message: error?.message || 'The save action could not be resolved.' });
          setEnemySaveDamage((current) => current ? { ...current, status: 'failed', error: error.message } : null);
        } finally {
          targetingLockRef.current = false;
          setCombatTargeting(INACTIVE_COMBAT_TARGETING);
        }
        return;
      }
      const armorClass = resolveCombatantArmorClass(target, { combatState, targetCombatantId: target.characterId || target.enemyId || target._id });
      if (armorClass === null) {
        setStatus({ type: 'warning', message: 'That target does not have an armor class.' });
        return;
      }

      targetingLockRef.current = true;
      setCombatTargeting((previous) => ({ ...previous, status: 'resolving', targetCombatantId: targetId }));
      try {
        const { attacker, attackId } = targeting;
        const actions = Array.isArray(targeting.actions) && targeting.actions.length
          ? targeting.actions
          : [targeting.action];
        const pendingStep = targeting.multiattackStepId
          ? await enemyMultiattackRef.current.bindTarget(targeting.multiattackStepId, targetId, { ...target, currentHp, armorClass }) : null;
        let targetForAttack = pendingStep?.target || { ...target, currentHp, armorClass };

        const targetedResults = await executeTargetedActions({
          pending: { ...targeting, actions },
          targetId,
          attackerExists: (id) => characterLookupRef.current.has(id),
          targetExists: (id) => characterLookupRef.current.has(id),
          resolveAction: async (action, _selectedTargetId, actionIndex) => {
          const attack = {
            id: `${attackId}:${actionIndex}`,
            name: action?.name || 'Action',
            damageType: action?.damage_type?.name || action?.damage_type || action?.damage?.[0]?.damage_type?.name || action?.damage?.[0]?.damage_type || '',
            damageTypes: (Array.isArray(action?.damage)?action.damage:[]).map(d=>d.damage_type?.name||d.damage_type||'').filter(Boolean),
            isMeleeAttack: /melee/i.test(action?.attack_type||action?.desc||'') && !/^ranged/i.test(action?.attack_type||action?.desc||''),
          };
          // 2024 reach and range from the stat block: refused before any dice; a ranged attack beyond normal range or
          // next to an enemy has Disadvantage (shared weaponRange and adjacency rules). Opportunity Attacks are in reach.
          const spatial = attackSpatialContextRef.current;
          const fromToken = spatial.tokens?.[targeting.sourceCombatantId], toToken = spatial.tokens?.[targetId];
          const distanceFeet = fromToken && toToken ? minimumFootprintDistanceFeet({ sourceToken: fromToken, targetToken: toToken,
            sourceSize: effectSize(combatStateRef.current, targeting.sourceCombatantId) || attacker?.size || fromToken.size,
            targetSize: effectSize(combatStateRef.current, targetId) || target?.size || toToken.size, map: spatial.map }) : null;
          const range = resolveMonsterAttackRange({ action, distanceFeet });
          if (!range.allowed && !reactionRequest) throw new Error(range.reason);
          attack.attackMode = range.mode;
          attack.longRange = !reactionRequest && range.longRange;
          attack.isMeleeAttack = range.mode === 'melee';
          await passTargetingBlock({ campaignId, combatState: combatStateRef.current, attackerId: targeting.sourceCombatantId, targetId, targetName: target?.name, onCombatChange: state => { combatStateRef.current = normalizeCombatState(state); setCombatState(combatStateRef.current); } });
          const result = await resolveAttack({
          attackerId: targeting.sourceCombatantId,
          attackerEntity: attacker,
          sourceType: attacker?.entityType === 'character' ? 'character' : 'monster',
          targetId,
          attack,
          target: targetForAttack,
          combatState: { ...combatState, campaignId },
          spatialContext: attackSpatialContextRef.current,
          ...(reactionRequest?{attackResolutionId:`attack:${reactionRequest.opportunityId}`} : pendingStep ? { attackResolutionId: pendingStep.id, parentResolutionId: pendingStep.id.split(':step:')[0] } : {}),
          defenderReactionRequired: true,
          resolveDefenderReaction: resolveEnemyDefenderReaction,
          resolveFateWindow: resolveEnemyFateWindow,
          resolveCuttingWords: resolveEnemyCuttingWords,
          rollAttack: (_selected, rollMode) => pendingStep
            ? enemyMultiattackRef.current.roll(pendingStep.id, 'attack', () => handleEnemyAttackRoll(attacker, action, { ...rollMode, targeted: true }))
            : cachedOpportunityRoll(reactionRequest?.opportunityId,'attack',()=>handleEnemyAttackRoll(attacker, action, { ...rollMode, targeted: true })),
          rollDamage: (_selected, { critical } = {}) => pendingStep
            ? enemyMultiattackRef.current.roll(pendingStep.id, 'damage', () => handleEnemyDamageRoll(attacker, action, critical, { detailed: true }))
            : cachedOpportunityRoll(reactionRequest?.opportunityId,'damage',()=>handleEnemyDamageRoll(attacker, action, critical, { detailed: true })),
          applyDamage: async ({ damageApplied, result }) => {
            if(pendingStep)return enemyMultiattackRef.current.applyDamage(pendingStep.id,{targetId,damageApplied,damageBeforeTraits:result?.damageBeforeTraits,damageType:result?.damageType,...(result?.damageByType?{damageByType:result.damageByType}:{})});
            let resolved;
            if (target.entityType === 'enemy') {
              const response = await apiFetch(`/campaigns/${encodedCampaign}/enemies/${encodeURIComponent(targetId)}/health`, {
                method: 'PUT', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ delta: -damageApplied, damageBeforeTraits: result?.damageBeforeTraits, damageType: result?.damageType, damageByType: result?.damageByType, eventId: result?.resolutionId }),
              });
              if (!response.ok) throw new Error('The HP update could not be saved. No combat state was changed.');
              resolved = await response.json();
              if (resolved.enemy) setEnemies((items) => items.map((item) => item.enemyId === targetId ? { ...item, ...resolved.enemy } : item));
            } else {
              const response = await apiFetch(`/characters/update-temphealth/${encodeURIComponent(targetId)}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ delta: -damageApplied, damageBeforeTraits: result?.damageBeforeTraits, damageType: result?.damageType, damageByType: result?.damageByType, eventId: result?.resolutionId, sourceCombatantId: result?.attackerId, rolledDamage: result?.damage }),
              });
              if (!response.ok) throw new Error('The HP update could not be saved. No combat state was changed.');
              resolved = await response.json();
              const nextHp = Number(resolved.currentHp);
              setRecords((previous) => previous.map((record) =>
                getEntityId(record) === targetId ? { ...record, tempHealth: nextHp } : record));
            }
            return { previousHp: Number(resolved.previousHp), currentHp: Number(resolved.currentHp), appliedDamage: Number(resolved.actualHpLost), resistanceReduction: resolved.resistanceReduction };
          },
          onDamageResolved: async (damageEvent) => {
            // Damage has been persisted at this point. Queue the reaction in the
            // campaign combat document so the character's client, not just the DM,
            // receives the decision.
            const nextState = processRetaliationDamageEvent({
              combatState,
              character: target,
              damageEvent,
              sourceCombatant: attacker,
              targetCombatant: target,
              mapState: { tokens: activeMapTokens },
            });
            if (nextState !== combatState) await persistCombatState(nextState);
          },
          // The DM's roll log: the attack from roll to HP, named by attacker and target.
          writeLog: async (entry) => addDmRollLog({ ...entry, attackName: [combatantLabel(attacker, { dm: true, fallback: 'Enemy' }), entry.attackName].filter(Boolean).join(' · '),
            targetName: combatantLabel(target, { dm: true, fallback: targetId }) }),
          commitSapAttackRoll: (payload) => consumeSapAttackRoll(campaignId, payload),
          });
          const targetName = combatantLabel(target, { dm: true, fallback: targetId });
          setLatestEnemyRoll({
          enemyId: attacker?.enemyId || attacker?._id,
          enemyName: combatantLabel(attacker, { dm: true, fallback: 'Enemy' }),
          actionName: action?.name || 'Action',
          total: result.attackTotal,
          naturalRoll: result.naturalRoll,
          attackBonus: Number(action?.attack_bonus) || 0,
          breakdown: `${result.naturalRoll} (d20) ${Number(action?.attack_bonus) >= 0 ? '+' : '-'} ${Math.abs(Number(action?.attack_bonus) || 0)} Attack Bonus`,
          rollType: 'attack',
          targetId,
          targetName,
          targetArmorClass: result.targetArmorClass,
          ...(result.cover ? { cover: result.cover } : {}),
          outcome: result.outcome,
          damage: result.damageApplied,
          });
          if (result.resistanceReduction) notify(formatResistanceReduction(result.resistanceReduction), 'info');
          notify(`${combatantLabel(attacker, { dm: true, fallback: 'Enemy' })} → ${targetName}: ${action?.name || 'Action'} ${result.attackTotal} (${result.outcome === 'critical-hit' ? 'Critical Hit' : result.outcome === 'hit' ? 'Hit' : 'Miss'})${result.damageApplied ? `, ${result.damageApplied} damage` : ''}`, 'info');
          // A Sundering Blow spent on this attack roll goes away.
          if (result.sunderingBlowEffectId) await persistCombatState(removeActiveEffect(combatStateRef.current, result.sunderingBlowEffectId));
          // A hit that knocks the target Prone (a Wolf's Bite): the server checks the stat block, the size and immunities.
          if (['hit', 'critical-hit'].includes(result.outcome) && attacker?.entityType !== 'character' && actionProneLimit(action) && result.resolutionId) {
            try {
              const response = await apiFetch(`/campaigns/${encodedCampaign}/enemies/${encodeURIComponent(targeting.sourceCombatantId)}/prone-rider`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ resolutionId: result.resolutionId, actionName: action.name, targetId, turnSequence: combatStateRef.current?.turnSequence }) });
              const rider = await response.json().catch(() => ({}));
              if (!response.ok) throw new Error(rider.message || 'The Prone condition could not be applied.');
              if (rider.combat) { combatStateRef.current = normalizeCombatState(rider.combat); setCombatState(combatStateRef.current); }
              if (rider.prone && !rider.replayed) notify(`${targetName} is knocked Prone.`, 'info');
            } catch (riderError) { notify(riderError.message, 'warning'); }
          }
          // Multiattack passes exactly one action here; the next step chooses its own target.
          targetForAttack = { ...targetForAttack, currentHp: result.hpAfter };
          return result;
          },
        });
        if (targeting.multiattackStepId) {
          if (!targetedResults.length) throw new Error('The attacker or target is no longer available.');
          await enemyMultiattackRef.current.complete(targeting.multiattackStepId,{outcome:targetedResults[0].outcome,damageApplied:targetedResults[0].damageApplied || 0});
        }
        setPendingEnemyCriticalAttack(null);
      } catch (error) {
        if (targeting.multiattackStepId) enemyMultiattackRef.current?.fail(targeting.multiattackStepId, error);
        setStatus({ type: 'danger', message: error?.message || 'The attack could not be resolved.' });
        if(reactionRequest)throw error;
      } finally {
        targetingLockRef.current = false;
        setCombatTargeting(INACTIVE_COMBAT_TARGETING);
      }
    }, [activeMapTokens, addDmRollLog, campaignId, characterLookup, combatState, combatTargeting, displayEnemyDiceResults, encodedCampaign, getEntityId, handleEnemyAttackRoll, handleEnemyDamageRoll, persistCombatState, resolveEnemyDefenderReaction, setEnemies, showEnemyDiceOverlay]);

    useEffect(() => {
      if (combatTargeting.status === 'inactive') return undefined;
      const cancelTargeting = (event) => {
        if (event.key === 'Escape') { if(combatTargeting.enemySpell)enemySpellsRef.current?.cancel();setCombatTargeting(INACTIVE_COMBAT_TARGETING); }
      };
      window.addEventListener('keydown', cancelTargeting);
      return () => window.removeEventListener('keydown', cancelTargeting);
    }, [combatTargeting.status, combatTargeting.enemySpell]);

    useEffect(() => {
      if (combatTargeting.status === 'inactive') return;
      const attackerExists = characterLookup.has(combatTargeting.sourceCombatantId);
      const targetExists = !combatTargeting.targetCombatantId || characterLookup.has(combatTargeting.targetCombatantId);
      if (!attackerExists || !targetExists) {
        targetingLockRef.current = false;
        setCombatTargeting(INACTIVE_COMBAT_TARGETING);
      }
    }, [characterLookup, combatTargeting.sourceCombatantId, combatTargeting.status, combatTargeting.targetCombatantId]);

    const resolveDisplayName = useCallback(
      (characterId) => {
        if (typeof characterId !== 'string' || characterId.trim() === '') {
          return null;
        }

        const entity = characterLookup.get(characterId);
        if (!entity || typeof entity !== 'object') {
          return null;
        }

        return combatantLabel(entity, { dm: true, fallback: '' }) || null;
      },
      [characterLookup]
    );

    const resolveParticipantHealth = useCallback(
      (characterId) => {
        if (typeof characterId !== 'string' || characterId.trim() === '') {
          return {};
        }

        const entity = characterLookup.get(characterId);
        if (!entity || typeof entity !== 'object') {
          return {};
        }

        if (entity.entityType !== 'enemy') {
          return {};
        }

        const maxHp = toFiniteNumberOrNull(entity.maxHp ?? entity.hitPoints);
        const currentHpCandidate =
          entity.currentHp !== undefined
            ? toFiniteNumberOrNull(entity.currentHp)
            : null;
        const currentHp =
          currentHpCandidate !== null
            ? currentHpCandidate
            : maxHp !== null
              ? maxHp
              : null;

        return {
          ...(currentHp !== null ? { currentHp } : {}),
          ...(maxHp !== null ? { maxHp } : {}),
        };
      },
      [characterLookup]
    );

    const combatHeaderParticipants = useMemo(() => {
      const participants = Array.isArray(combatState.participants)
        ? combatState.participants
        : [];

      if (participants.length === 0) {
        return [];
      }

      const activeTurnIndex =
        Number.isInteger(combatState.activeTurn) && combatState.activeTurn >= 0
          ? combatState.activeTurn
          : null;

      const activeParticipantId =
        activeTurnIndex !== null &&
        activeTurnIndex < participants.length &&
        participants[activeTurnIndex]
          ? participants[activeTurnIndex].characterId
          : null;

      return participants
        .slice()
        .sort((a, b) => combatState.manualOrder ? 0 : b.initiative - a.initiative)
        .map((participant) => {
          const characterId = participant.characterId;
          const entity = characterLookup.get(characterId);
          const displayName =
            resolveDisplayName(characterId) ||
            (typeof participant.displayName === 'string' &&
            participant.displayName.trim() !== ''
              ? participant.displayName.trim()
              : null) ||
            characterId;

          const participantCurrentHp = toFiniteNumberOrNull(
            participant.currentHp ?? participant.hpCurrent,
          );
          const participantMaxHp = toFiniteNumberOrNull(
            participant.maxHp ?? participant.hpMax,
          );

          let normalizedCurrentHp = participantCurrentHp;
          let normalizedMaxHp = participantMaxHp;

          if (entity && entity.entityType !== 'enemy') {
            const { currentHp: derivedCurrent, maxHp: derivedMax } =
              calculateCharacterHitPoints(entity);
            const resolvedCurrent = toFiniteNumberOrNull(derivedCurrent);
            const resolvedMax = toFiniteNumberOrNull(derivedMax);

            if (resolvedMax !== null) {
              normalizedMaxHp = resolvedMax;
              if (normalizedCurrentHp === null) {
                normalizedCurrentHp =
                  resolvedCurrent !== null ? resolvedCurrent : resolvedMax;
              }
            } else if (resolvedCurrent !== null && normalizedCurrentHp === null) {
              normalizedCurrentHp = resolvedCurrent;
            }

            if (normalizedCurrentHp === null && normalizedMaxHp === null) {
              const fallbackMax = toFiniteNumberOrNull(
                entity.maxHp ?? entity.hpMax ?? entity.health,
              );
              if (fallbackMax !== null) {
                normalizedMaxHp = fallbackMax;
                if (normalizedCurrentHp === null) {
                  normalizedCurrentHp = fallbackMax;
                }
              }
            }
          } else {
            const enemyHealth = resolveParticipantHealth(characterId);
            const enemyCurrent = toFiniteNumberOrNull(enemyHealth.currentHp);
            const enemyMax = toFiniteNumberOrNull(enemyHealth.maxHp);
            if (enemyMax !== null) {
              normalizedMaxHp = enemyMax;
              if (normalizedCurrentHp === null) {
                normalizedCurrentHp =
                  enemyCurrent !== null ? enemyCurrent : enemyMax;
              }
            } else if (enemyCurrent !== null && normalizedCurrentHp === null) {
              normalizedCurrentHp = enemyCurrent;
            }
          }

          let hpDisplay = '—';
          if (normalizedCurrentHp !== null && normalizedMaxHp !== null) {
            hpDisplay = `${normalizedCurrentHp}/${normalizedMaxHp}`;
          } else if (normalizedCurrentHp !== null) {
            hpDisplay = `${normalizedCurrentHp}`;
          } else if (normalizedMaxHp !== null) {
            hpDisplay = `${normalizedMaxHp}`;
          }
          hpDisplay = withTemporaryHitPoints(hpDisplay, entity);

          return {
            characterId,
            name: displayName,
            hpCurrent: normalizedCurrentHp,
            hpMax: normalizedMaxHp,
            hpDisplay,
            initiative: participant.initiative,
            isActive:
              activeParticipantId !== null && characterId === activeParticipantId,
          };
        });
    }, [
      combatState.participants,
      combatState.activeTurn,
      characterLookup,
      resolveDisplayName,
      resolveParticipantHealth,
    ]);

    // Tools → Conditions targets any creature of the campaign: combat participants in initiative order, then the rest.
    const conditionCreatures = useMemo(() => {
      // `creature` is the record, for its condition immunities.
      const records = new Map(combinedRecords.map(record => [String(getEntityId(record)), record]));
      const inCombat = combatHeaderParticipants.map(participant => ({ characterId: participant.characterId, name: participant.name, inCombat: true, creature: records.get(String(participant.characterId)) }));
      const listed = new Set(inCombat.map(creature => String(creature.characterId)));
      const others = combinedRecords.map(record => ({ characterId: getEntityId(record), name: combatantLabel(record, { dm: true }), inCombat: false, creature: record }))
        .filter(creature => creature.characterId && !listed.has(String(creature.characterId)));
      return [...inCombat, ...others];
    }, [combatHeaderParticipants, combinedRecords, getEntityId]);

    const calculateEntityInitiative = useCallback(
      (entity) => {
        if (!entity || typeof entity !== 'object') {
          return 0;
        }

        if (entity.entityType === 'enemy') return enemyInitiativeModifier(entity);

        return calculateCharacterInitiative(entity);
      },
      [calculateCharacterInitiative]
    );

    const characterInitiativeRollModeMap = useMemo(() => {
      const map = new Map();
      if (Array.isArray(combinedRecords)) {
        combinedRecords.forEach((entity) => {
          const id = getEntityId(entity);
          if (!id) {
            return;
          }
          map.set(id, resolveInitiativeRollMode(entity, { disadvantageSources:[...((combatState?.activeEffects||[]).some(e=>String(e.targetCombatantId)===String(id)&&e.definitionId==='condition:poisoned')?['Poisoned']:[]), ...(incapacitatingEffects(combatState,id).length?['Incapacitated']:[])], advantageSources: [...(benefitsFromInvisible(combatState,id) ? ['Invisible'] : []), ...getBuffCheckAdvantageSources(combatState, id, 'dex')] }));
        });
      }
      return map;
    }, [combinedRecords, getEntityId, combatState]);

    const characterInitiativeMap = useMemo(() => {
      const map = new Map();
      if (Array.isArray(combinedRecords)) {
        combinedRecords.forEach((entity) => {
          const id = getEntityId(entity);
          if (!id) {
            return;
          }
          // Initiative is a Dexterity check, so Exhaustion's D20 Test penalty applies.
          const initiative = calculateEntityInitiative(entity) - 2 * exhaustionLevel(combatState, id);
          map.set(id, initiative);
        });
      }
      return map;
    }, [combinedRecords, calculateEntityInitiative, getEntityId, combatState]);

    const participantToggleLock = useRef(false);
    const handleToggleParticipant = useCallback(
      async (characterId) => {
        if (!characterId || participantToggleLock.current) return false;
        participantToggleLock.current = true;

        const participants = Array.isArray(combatState.participants)
          ? [...combatState.participants]
          : [];
        const existingIndex = participants.findIndex(
          (participant) => participant.characterId === characterId
        );

        let nextState;

        if (existingIndex === -1) {
          const derivedInitiative = characterInitiativeMap.get(characterId);
          const initiative =
            derivedInitiative !== undefined ? derivedInitiative : 0;
          const displayName = resolveDisplayName(characterId);
          const participant = {
            characterId,
            initiative,
            ...(displayName ? { displayName } : {}),
            ...resolveParticipantHealth(characterId),
          };
          const stateWithDerived = applyDerivedInitiativesToState(
            {
              ...combatState,
              participants: [...participants, participant],
              activeTurn: combatState.activeTurn,
            },
            characterInitiativeMap
          );
          nextState = normalizeCombatState(stateWithDerived);
        } else {
          const updatedParticipants = participants.filter((_, index) => index !== existingIndex);
          let nextActiveTurn = combatState.activeTurn;

          if (typeof nextActiveTurn === 'number') {
            if (existingIndex === nextActiveTurn) {
              nextActiveTurn =
                updatedParticipants.length > 0
                  ? Math.min(nextActiveTurn, updatedParticipants.length - 1)
                  : null;
            } else if (existingIndex < nextActiveTurn) {
              nextActiveTurn -= 1;
            }
          }

          nextState = normalizeCombatState({
            ...combatState,
            participants: updatedParticipants,
            activeTurn: nextActiveTurn,
          });
        }

        const previousActiveId = combatState.participants[combatState.activeTurn]?.characterId;
        const nextActiveId = nextState.participants[nextState.activeTurn]?.characterId;
        if (previousActiveId && nextActiveId && previousActiveId !== nextActiveId) {
          nextState = { ...nextState, turnSequence: (combatState.turnSequence || 0) + 1 };
          delete nextState.turnActionLedger;
        }
        setCombatState(nextState);
        try { return Boolean(await persistCombatState(nextState)); }
        finally { participantToggleLock.current = false; }
      },
      [
        combatState,
        persistCombatState,
        characterInitiativeMap,
        resolveDisplayName,
        resolveParticipantHealth,
      ]
    );

    const handleMapToggleCombat = useCallback(async characterId => {
      const wasIncluded = combatState.participants.some(p => p.characterId === characterId);
      const saved = await handleToggleParticipant(characterId);
      if (saved) notify(`${resolveDisplayName(characterId) || 'Unit'} ${wasIncluded ? 'removed from' : 'added to'} combat.`, 'success');
      return saved;
    }, [combatState.participants, handleToggleParticipant, resolveDisplayName]);

    const resolveRecurringSave = useCallback(async (descriptor) => {
      const target = combinedRecords.find((entity) =>
        getCanonicalCombatantIdentity(entity) === descriptor.targetCombatantId);
      if (!target) throw new Error('The recurring save target is not available on the GM screen.');
      const targetSaveModifier = getCombatantSaveModifier(target, descriptor.ability);
      const { mode } = savingThrowRollProfile(target, descriptor.ability, { combatState, targetCombatantId: descriptor.targetCombatantId, conditionId: descriptor.conditionId });
      const request = createTargetedSaveRequest({ ...descriptor, targetSaveModifier, mode });
      await showEnemyDiceOverlay();
      const roll = await rollSkillWithDiceBox(targetSaveModifier, { diceColor: DEFAULT_DICE_COLOR, rollMode: mode, diceModifiers: getRollDiceModifiers(combatState, descriptor.targetCombatantId, 'save') });
      const d20Result = roll.keptD20 ?? roll.d20;
      const resolved = { ...resolveTargetedSave({ ...request, targetSaveModifier: targetSaveModifier + modifierDiceTotal(roll.diceModifiers, roll.modifierDice) }, d20Result),
        baseSaveModifier: targetSaveModifier, modifierDice: roll.modifierDice, saveDice: roll.rolledD20s, effectId: descriptor.effectId,
        turnSequence: descriptor.turnSequence };
      const committed = await commitTargetedCombatSave(campaignId, resolved);
      if (!['resolved', 'replayed'].includes(committed?.status) || !committed?.save) {
        throw new Error('The recurring saving throw could not be persisted.');
      }
      const targetName = combatantLabel(characterLookup.get(descriptor.targetCombatantId), { dm: true, fallback: target.name || target.displayName || descriptor.targetCombatantId });
      setStatus({ type: committed.save.success ? 'success' : 'danger', message:
        `${targetName}: ${committed.save.ability.slice(0, 3).toUpperCase()} Save ${committed.save.total} vs DC ${committed.save.dc} — ${committed.save.success ? 'Success' : 'Failure'}` });
      return { ...committed.save, status: committed.status, combat: committed.combat };
    }, [campaignId, combatState, combinedRecords, showEnemyDiceOverlay]);

    const leaveCurrentTurn = useCallback(async (nextCombatant = null) => {
      if (turnTransitionLockRef.current) return;
      const current = combatStateRef.current;
      const active = current?.participants?.[current.activeTurn];
      turnTransitionLockRef.current = true;
      try {
        // A plain "next turn" is the server's end-turn command (audit P1): the server advances its stored combat and
        // lists any end-of-turn repeat saves, which the GM screen rolls. Starting combat and jumping to a chosen
        // combatant stay DM timeline edits.
        if (!nextCombatant && active) {
          const committed = normalizeCombatState(await requestServerEndTurn({ campaignId, combat: current, resolvePendingSave: resolveRecurringSave }));
          combatStateRef.current = committed;
          setCombatState(committed);
          return;
        }
        const transition = await requestEndTurn({ combat: current, currentCombatant: active,
          nextCombatant, resolveRecurringSave });
        const persisted = await persistCombatState(transition.state);
        if (!persisted) return; // persistCombatState already displays the server's explanation.
      } catch (error) {
        setStatus({ type: 'danger', message: error.message || 'The required end-of-turn save could not be completed.' });
      } finally {
        turnTransitionLockRef.current = false;
      }
    }, [campaignId, persistCombatState, resolveRecurringSave]);

    const handleSetTurn = useCallback(
      async (characterId) => {
        if (!characterId) {
          return;
        }

        const current = combatStateRef.current;
        const participants = Array.isArray(current.participants)
          ? [...current.participants]
          : [];
        const index = participants.findIndex((participant) => participant.characterId === characterId);

        if (index === -1 || current.activeTurn === index) {
          return;
        }
        await leaveCurrentTurn(participants[index]);
      },
      [leaveCurrentTurn]
    );

    const initiativeRollLock = useRef(false);
    const [initiativeRolling,setInitiativeRolling] = useState(false);
    const handleRollInitiative = useCallback(async () => {
      if(initiativeRollLock.current || !combatState.participants?.length)return;
      initiativeRollLock.current=true;setInitiativeRolling(true);
      try {
        const profiles=Object.fromEntries(combatState.participants.map(p=>{
          const mode=characterInitiativeRollModeMap.get(p.characterId);
          return [p.characterId,{modifier:characterInitiativeMap.get(p.characterId)||0,mode:mode?.mode||'normal',sources:mode?.advantageSources||[],disadvantageSources:mode?.disadvantageSources||[]}];
        }));
        const response=await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/initiative/roll`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({profiles})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.message||'Initiative could not be rolled.');
        const next=normalizeCombatState(result.combat);combatStateRef.current=next;setCombatState(next);
        notify(result.rolled ? `Rolled initiative for ${result.rolled} combatant${result.rolled===1?'':'s'}.` : 'Everyone in combat already has an initiative roll.','success');
      }catch(error){notify(error.message||'Initiative could not be rolled.','danger');}
      finally{initiativeRollLock.current=false;setInitiativeRolling(false);}
    },[campaignId,combatState.participants,characterInitiativeMap,characterInitiativeRollModeMap]);

    const handleAdvanceTurn = useCallback(
      async (direction) => {
        if (direction !== 1 && direction !== -1) {
          return;
        }

        const current = combatStateRef.current;
        const participants = Array.isArray(current.participants)
          ? [...current.participants]
          : [];
        const total = participants.length;

        if (total === 0) {
          if (current.activeTurn === null || current.activeTurn === undefined) {
            return;
          }

          const nextState = normalizeCombatState({
            participants,
            activeTurn: null,
          });

          setCombatState(nextState);
          persistCombatState(nextState);
          return;
        }

        if (direction === 1) {
          await leaveCurrentTurn();
          return;
        }
        const nextState = normalizeCombatState(undoTurn(current));

        setCombatState(nextState);
        persistCombatState(nextState);
      },
      [leaveCurrentTurn, persistCombatState]
    );

    const participantLookup = useMemo(() => {
      const map = new Map();
      if (Array.isArray(combatState.participants)) {
        combatState.participants.forEach((participant, index) => {
          if (participant && typeof participant.characterId === 'string') {
            map.set(participant.characterId, { ...participant, index });
          }
        });
      }
      return map;
    }, [combatState.participants]);

    const orderedCombatRecords = useMemo(() => {
      if (!Array.isArray(combinedRecords) || combinedRecords.length === 0) {
        return [];
      }

      // Enemies on other maps stay out of the tracker, unless they are already in this combat.
      return combinedRecords
        .filter((entity) => entity?.entityType !== 'enemy' || isEnemyOnMap(entity, normalizedActiveMapId) || participantLookup.has(getEntityId(entity)))
        .map((entity, recordIndex) => {
          if (!entity || typeof entity !== 'object') {
            return {
              character: entity,
              rowId: '',
              participantInfo: undefined,
              initiativeValue: undefined,
              sortInitiative: Number.NEGATIVE_INFINITY,
              recordIndex,
            };
          }

          const rowId = getEntityId(entity) || '';
          const participantInfo = rowId ? participantLookup.get(rowId) : undefined;
          const derivedInitiative = rowId ? characterInitiativeMap.get(rowId) : undefined;

          const initiativeValue =
            participantInfo && participantInfo.initiative !== undefined
              ? participantInfo.initiative
              : derivedInitiative;

          const numericInitiative =
            typeof initiativeValue === 'number' && Number.isFinite(initiativeValue)
              ? initiativeValue
              : Number.isFinite(Number(initiativeValue))
                ? Number(initiativeValue)
                : Number.NEGATIVE_INFINITY;

          return {
            character: entity,
            rowId,
            participantInfo,
            passivePerception: getEntityPassivePerception(entity),
            movementSpeedDisplay: getEntityMovementSpeedDisplay(entity, combatState, rowId),
            initiativeValue,
            sortInitiative: numericInitiative,
            recordIndex,
          };
        })
        .sort((a, b) => {
          if(combatState.manualOrder){
            if(a.participantInfo && b.participantInfo)return a.participantInfo.index-b.participantInfo.index;
            if(Boolean(a.participantInfo)!==Boolean(b.participantInfo))return a.participantInfo?-1:1;
          }
          if (b.sortInitiative !== a.sortInitiative) {
            return b.sortInitiative - a.sortInitiative;
          }

          const aIsParticipant = Boolean(a.participantInfo);
          const bIsParticipant = Boolean(b.participantInfo);
          if (aIsParticipant !== bIsParticipant) {
            return aIsParticipant ? -1 : 1;
          }

          if (
            a.participantInfo &&
            b.participantInfo &&
            a.participantInfo.index !== b.participantInfo.index
          ) {
            return a.participantInfo.index - b.participantInfo.index;
          }

          return a.recordIndex - b.recordIndex;
        });
    }, [combinedRecords, participantLookup, characterInitiativeMap, getEntityId, combatState, normalizedActiveMapId]);

    const formatArmorClass = useCallback((armorClass) => {
      if (typeof armorClass === 'number' && Number.isFinite(armorClass)) {
        return String(armorClass);
      }

      if (!Array.isArray(armorClass) || armorClass.length === 0) {
        return '—';
      }

      const parts = armorClass
        .map((entry) => {
          if (!entry || (entry.value === undefined && entry.value !== 0)) {
            return null;
          }
          const numeric = Number(entry.value);
          if (!Number.isFinite(numeric)) {
            return null;
          }
          const suffix = entry.type ? ` (${entry.type})` : '';
          return `${numeric}${suffix}`;
        })
        .filter(Boolean);

      return parts.length > 0 ? parts.join(', ') : '—';
    }, []);

    const formatSpeed = useCallback(formatMovementSpeed, []);

    const formatAbilityScore = useCallback((key, value) => {
      const label = STAT_LABELS[key] || key.toUpperCase();
      const numeric = Number(value);
      if (!Number.isFinite(numeric)) {
        return `${label}: —`;
      }
      const modifier = Math.floor((numeric - 10) / 2);
      const modifierText = modifier >= 0 ? `+${modifier}` : `${modifier}`;
      return `${label}: ${numeric} (${modifierText})`;
    }, []);

    const activeParticipant = useMemo(() => {
      if (!Array.isArray(combatState.participants)) {
        return null;
      }

      const { activeTurn } = combatState;

      if (
        !Number.isInteger(activeTurn) ||
        activeTurn < 0 ||
        activeTurn >= combatState.participants.length
      ) {
        return null;
      }

      return { ...combatState.participants[activeTurn], index: activeTurn };
    }, [combatState]);

    const activeDiceColor = useMemo(() => {
      const normalizeColor = (value) => {
        if (typeof value !== 'string') {
          return null;
        }
        const trimmed = value.trim();
        return /^#[0-9a-fA-F]{6}$/.test(trimmed) ? trimmed : null;
      };

      if (activeParticipant) {
        const character = characterLookup.get(activeParticipant.characterId);
        const color = normalizeColor(character?.diceColor);
        if (color) {
          return color;
        }
      }

      if (Array.isArray(records)) {
        for (const record of records) {
          const color = normalizeColor(record?.diceColor);
          if (color) {
            return color;
          }
        }
      }

      return DEFAULT_DICE_COLOR;
    }, [activeParticipant, characterLookup, records]);


    const activeTurnDisplayName = useMemo(() => {
      if (!activeParticipant) {
        return 'None';
      }

      const character = characterLookup.get(activeParticipant.characterId);
      if (character) {
        return (
          combatantLabel(character, { dm: true, fallback: activeParticipant.characterId })
        );
      }

      return activeParticipant.characterId;
    }, [activeParticipant, characterLookup]);

    const combatParticipantCount = Array.isArray(combatState.participants)
      ? combatState.participants.length
      : 0;
  
    const navigateToCharacter = (id) => {
      navigate(`/zombies-character-sheet/${id}`);
    }

    const previewMap = useMemo(() => {
      if (generatedMap) {
        return generatedMap;
      }

      if (selectedMapId) {
        const selected = maps.find((map) => map && map.mapId === selectedMapId);
        if (selected) {
          return selected;
        }
      }

      return campaignMap;
    }, [generatedMap, selectedMapId, maps, campaignMap]);

    const tokenMetaById = useMemo(() => {
      const lookup = {};

      if (Array.isArray(records)) {
        records.forEach((record) => {
          if (!record || typeof record !== 'object') {
            return;
          }

          const color =
            typeof record.diceColor === 'string' && record.diceColor.trim() !== ''
              ? record.diceColor.trim()
              : null;
          const label =
            (typeof record.characterName === 'string' && record.characterName.trim()) ||
            (typeof record.name === 'string' && record.name.trim()) ||
            (typeof record.token === 'string' && record.token.trim()) ||
            (typeof record._id === 'string' && record._id.trim()) ||
            (typeof record.characterId === 'string' && record.characterId.trim()) ||
            null;

          const entityTypeRaw =
            typeof record.entityType === 'string' && record.entityType.trim() !== ''
              ? record.entityType.trim()
              : 'character';
          const entityType = entityTypeRaw.toLowerCase();

          const { currentHp: derivedCurrentHp, maxHp: derivedMaxHp } =
            calculateCharacterHitPoints(record);

          const fallbackCurrentHp = toFiniteNumberOrNull(
            record.currentHp ?? record.hpCurrent ?? record.tempHealth ?? record.health
          );
          const fallbackMaxHp = toFiniteNumberOrNull(
            record.maxHp ?? record.hpMax ?? record.health
          );

          const normalizedCurrentHp = Number.isFinite(derivedCurrentHp)
            ? derivedCurrentHp
            : fallbackCurrentHp;
          const normalizedMaxHp = Number.isFinite(derivedMaxHp)
            ? derivedMaxHp
            : fallbackMaxHp;

          const identifiers = [record.characterId, record._id, record.token].filter(
            (value) => typeof value === 'string' && value.trim() !== ''
          );

          const recordSize = normalizeCreatureSize(
            record.size ??
              record.characterSize ??
              record?.character?.size ??
              record?.creature?.size ??
              record?.profile?.size ??
              record?.race?.size ??
              record?.attributes?.size ??
              record?.displayType
          );

          const { figurineImageUrl, figurineImagePublicId } = resolveFigurineImageData(record);

          identifiers.forEach((identifier) => {
            const trimmed = identifier.trim();
            if (!trimmed) {
              return;
            }

            lookup[trimmed] = {
              color,
              label,
              entityType,
              ...(record.disposition ? { disposition: record.disposition } : {}),
              ...(normalizedCurrentHp !== null ? { currentHp: normalizedCurrentHp } : {}),
              ...(normalizedMaxHp !== null ? { maxHp: normalizedMaxHp } : {}),
              ...(recordSize ? { size: recordSize } : {}),
              ...(figurineImageUrl ? { figurineImageUrl } : {}),
              ...(figurineImagePublicId ? { figurineImagePublicId } : {}),
            };
          });
        });
      }

      if (Array.isArray(enemies)) {
        enemies.forEach((enemy) => {
          if (!enemy || typeof enemy !== 'object') {
            return;
          }

          const enemyId =
            typeof enemy.enemyId === 'string' && enemy.enemyId.trim() !== ''
              ? enemy.enemyId.trim()
              : null;
          if (!enemyId) {
            return;
          }

          const label =
            combatantLabel(enemy, { dm: true, fallback: '' }) ||
            (typeof enemy.enemyType === 'string' && enemy.enemyType.trim()) ||
            enemyId;

          const enemyCurrentHp = toFiniteNumberOrNull(
            enemy.currentHp ?? enemy.maxHp ?? enemy.hitPoints
          );
          const enemyMaxHp = toFiniteNumberOrNull(enemy.maxHp ?? enemy.hitPoints);

        const enemySize = normalizeCreatureSize(
          enemy.size ?? enemy.displayType ?? enemy.type ?? enemy.enemyType
        );

        const { figurineImageUrl, figurineImagePublicId } = resolveFigurineImageData(enemy);

        lookup[enemyId] = {
          color: dispositionColor(enemy),
          disposition: dispositionOf(enemy),
          label,
          entityType: 'enemy',
          ...(enemyCurrentHp !== null ? { currentHp: enemyCurrentHp } : {}),
          ...(enemyMaxHp !== null ? { maxHp: enemyMaxHp } : {}),
          ...(enemySize ? { size: enemySize } : {}),
          ...(figurineImageUrl ? { figurineImageUrl } : {}),
          ...(figurineImagePublicId ? { figurineImagePublicId } : {}),
        };
      });
    }

      return applyEffectSizes(lookup, combatState, normalizeCreatureSize);
    }, [records, enemies, combatState]);

    const displayedMap = generatedMap || previewMap || campaignMap;
    const enemyMapId = normalizeMapId(displayedMap?.mapId) || normalizedActiveMapId;
    enemyMapRef.current = enemyMapId;
    // The map the library shows: the one picked in the list, or the active map.
    const librarySelectedMap = useMemo(
      () => (selectedMapId && maps.find((map) => map && map.mapId === selectedMapId)) || campaignMap || null,
      [selectedMapId, maps, campaignMap]
    );

    const activeMapTitle = useMemo(() => {
      if (campaignMap) {
        return getMapDisplayTitle(campaignMap, DEFAULT_MAP_TITLE);
      }
      if (
        displayedMap &&
        typeof displayedMap.mapId === 'string' &&
        typeof activeMapId === 'string' &&
        displayedMap.mapId.trim() === activeMapId.trim()
      ) {
        return getMapDisplayTitle(displayedMap, DEFAULT_MAP_TITLE);
      }
      return null;
    }, [activeMapId, campaignMap, displayedMap]);

    const shouldShowCampaignTokens = useMemo(() => {
      const normalizedDisplayedMapId =
        typeof displayedMap?.mapId === 'string' && displayedMap.mapId.trim() !== ''
          ? displayedMap.mapId.trim()
          : null;
      const normalizedCampaignMapId =
        typeof campaignMap?.mapId === 'string' && campaignMap.mapId.trim() !== ''
          ? campaignMap.mapId.trim()
          : null;
      const normalizedActiveMapId =
        typeof activeMapId === 'string' && activeMapId.trim() !== ''
          ? activeMapId.trim()
          : null;

      if (!normalizedDisplayedMapId || !normalizedCampaignMapId) {
        return false;
      }

      if (generatedMap) {
        return false;
      }

      return (
        normalizedDisplayedMapId === normalizedCampaignMapId &&
        normalizedDisplayedMapId === normalizedActiveMapId
      );
    }, [activeMapId, campaignMap, displayedMap, generatedMap]);

    const boardTokens = useMemo(() => {
      const activeCharacterId =
        typeof activeParticipant?.characterId === 'string' &&
        activeParticipant.characterId.trim() !== ''
          ? activeParticipant.characterId.trim()
          : null;
      const normalizedDisplayedMapId =
        typeof displayedMap?.mapId === 'string' && displayedMap.mapId.trim() !== ''
          ? displayedMap.mapId.trim()
          : null;
      if (!normalizedDisplayedMapId) {
        return [];
      }

      const combinedTokens = {
        ...(mapTokens?.[normalizedDisplayedMapId] || {}),
      };

      const normalizedActiveMapId =
        typeof activeMapId === 'string' && activeMapId.trim() !== ''
          ? activeMapId.trim()
          : null;

      if (
        normalizedActiveMapId &&
        normalizedActiveMapId === normalizedDisplayedMapId &&
        activeMapTokens &&
        typeof activeMapTokens === 'object'
      ) {
        Object.entries(activeMapTokens).forEach(([key, value]) => {
          if (!value || typeof value !== 'object') {
            return;
          }
          const identifier = typeof key === 'string' && key.trim() !== '' ? key.trim() : value.characterId;
          if (identifier) {
            combinedTokens[identifier] = { ...combinedTokens[identifier], ...value };
          }
        });
      }

      const tokensList = Object.values(combinedTokens).filter(
        (token) => token && typeof token === 'object' && token.characterId
      );

      return tokensList
        .map((token) => {
          const meta = tokenMetaById[token.characterId] || {};
          const rawLabel = meta.label || token.label || token.characterId;
          const label = typeof rawLabel === 'string' ? rawLabel.trim() : '';
          const normalizedTokenCharacterId =
            typeof token.characterId === 'string' && token.characterId.trim() !== ''
              ? token.characterId.trim()
              : null;
          const isActiveTurn =
            normalizedTokenCharacterId &&
            activeCharacterId &&
            normalizedTokenCharacterId === activeCharacterId;
          const normalizedCurrentHp = toFiniteNumberOrNull(
            meta.currentHp ?? token.currentHp ?? token.hpCurrent ?? token.health
          );
          const normalizedMaxHp = toFiniteNumberOrNull(
            meta.maxHp ?? token.maxHp ?? token.hpMax ?? token.health
          );
          const metaVariant =
            typeof meta.variant === 'string' && meta.variant.trim() !== ''
              ? meta.variant.trim().toLowerCase()
              : null;
          const tokenVariant =
            typeof token.variant === 'string' && token.variant.trim() !== ''
              ? token.variant.trim().toLowerCase()
              : null;
          const metaEntityType =
            typeof meta.entityType === 'string' && meta.entityType.trim() !== ''
              ? meta.entityType.trim().toLowerCase()
              : null;
          const tokenEntityType =
            typeof token.entityType === 'string' && token.entityType.trim() !== ''
              ? token.entityType.trim().toLowerCase()
              : null;
          const entityType = metaEntityType || tokenEntityType || null;

          const metaSize =
            typeof meta.size === 'string' && meta.size.trim() !== ''
              ? meta.size.trim().toLowerCase()
              : null;
          const tokenSize =
            typeof token.size === 'string' && token.size.trim() !== ''
              ? token.size.trim().toLowerCase()
              : null;
          const size = metaSize || tokenSize || null;

          let variant = metaVariant || tokenVariant || null;
          if (!variant && entityType) {
            if (entityType === 'enemy') {
              variant = 'enemy';
            } else if (entityType === 'character') {
              variant = 'ally';
            }
          }

          const baseColor = meta.color || token.color || null;
          const normalizedColor =
            typeof baseColor === 'string' && baseColor.trim() !== '' ? baseColor.trim() : null;

          const { figurineImageUrl, figurineImagePublicId } = resolveFigurineImageData(meta, token);

          return {
            ...token,
            label,
            color: normalizedColor,
            disposition: meta.disposition || token.disposition,
            isMovable: true,
            ...(entityType ? { entityType } : {}),
            ...(variant ? { variant } : {}),
            ...(isActiveTurn ? { isActiveTurn: true } : {}),
            ...(normalizedCurrentHp !== null ? { currentHp: normalizedCurrentHp } : {}),
            ...(normalizedMaxHp !== null ? { maxHp: normalizedMaxHp } : {}),
            ...(size ? { size } : {}),
            ...(figurineImageUrl ? { figurineImageUrl } : {}),
            ...(figurineImagePublicId ? { figurineImagePublicId } : {}),
          };
        })
        .sort((a, b) => {
          const labelA = (a.label || a.characterId || '').toLowerCase();
          const labelB = (b.label || b.characterId || '').toLowerCase();
          return labelA.localeCompare(labelB);
        });
    }, [
      activeMapId,
      activeMapTokens,
      activeParticipant,
      displayedMap,
      mapTokens,
      tokenMetaById,
    ]);
    attackSpatialContextRef.current = { map: displayedMap, tokens: Object.fromEntries(boardTokens.map(token => [token.characterId, token])) };
    // While choosing a monster attack's target, the map outlines its reach/range and colors the hovered creature.
    const enemyTargetingPreview = useMemo(() => buildEnemyTargetingPreview({ targeting: combatTargeting, combatState,
      spatialContext: { map: displayedMap, tokens: Object.fromEntries(boardTokens.map(token => [token.characterId, token])) } }),
    [combatTargeting, combatState, displayedMap, boardTokens]);

    const activeMapEnemySummaries = useMemo(
      () =>
        createActiveMapEnemySummaries({
          activeMapTokens,
          enemies,
          tokenMetaById,
          participantLookup,
          formatArmorClass,
          combatState,
          formatChallengeRatingValue,
          activeParticipantId: activeParticipant?.characterId,
        }),
      [
        activeMapTokens,
        enemies,
        combatState,
        formatArmorClass,
        formatChallengeRatingValue,
        participantLookup,
        activeParticipant?.characterId,
        tokenMetaById,
      ]
    );

    const placementEnemyName = useMemo(() => {
      if (typeof mapPlacementState.enemyName === 'string' && mapPlacementState.enemyName.trim() !== '') {
        return mapPlacementState.enemyName.trim();
      }
      return null;
    }, [mapPlacementState.enemyName]);
    // Parties: the players with a figure on the active map.
    const partyCharacters = useMemo(() => {
      const placed = new Set(boardTokens.map(token => String(token.characterId)));
      return combinedRecords.filter(record => record.entityType !== 'enemy' && placed.has(String(getEntityId(record))))
        .map(record => ({ id: String(getEntityId(record)), name: combatantLabel(record, { dm: true }), image: resolveFigurineImageData(record).figurineImageUrl }));
    }, [boardTokens, combinedRecords, getEntityId]);

    const mapPlacementInstruction = useMemo(() => {
      if (!mapPlacementState.show) {
        return '';
      }

      if (!shouldShowCampaignTokens) {
        return 'Activate the campaign map to place this enemy.';
      }

      if (placementEnemyName) {
        return `Click the map to place ${placementEnemyName}.`;
      }

      return 'Click the map to place the enemy.';
    }, [mapPlacementState.show, placementEnemyName, shouldShowCampaignTokens]);

    const handleTokenPositionChange = useCallback(
      ({ characterId, x, y, rotation }) => {
        const normalizedDisplayedMapId =
          typeof displayedMap?.mapId === 'string' && displayedMap.mapId.trim() !== ''
            ? displayedMap.mapId.trim()
            : null;
        const normalizedCampaignMapId =
          typeof campaignMap?.mapId === 'string' && campaignMap.mapId.trim() !== ''
            ? campaignMap.mapId.trim()
            : null;

        if (
          !shouldShowCampaignTokens ||
          !normalizedDisplayedMapId ||
          !normalizedCampaignMapId ||
          normalizedDisplayedMapId !== normalizedCampaignMapId
        ) {
          return;
        }

        persistTokenPosition({
          mapId: normalizedDisplayedMapId,
          characterId,
          x,
          y,
          rotation,
        });
      },
      [campaignMap, displayedMap, persistTokenPosition, shouldShowCampaignTokens]
    );

    const placementToken = mapPlacementState.show ? {
      ...tokenMetaById[mapPlacementState.enemyId], characterId:mapPlacementState.enemyId,
    } : null;
    const unplacedUnits = (enemies || []).filter(unit => isEnemyOnMap(unit, enemyMapId)).filter(unit => !boardTokens.some(token=>token.characterId===unit.enemyId) || (mapPlacementSaving && mapPlacementState.enemyId===unit.enemyId));

    const handleCloseMapPlacement = useCallback(() => {
      setMapPlacementState({ show: false, enemyId: null, enemyName: null });
    }, []);

    useEffect(() => {
      if (!mapPlacementState.show) {
        setMapPlacementSaving(false);
        setMapPlacementError(null);
      }
    }, [mapPlacementState.show]);

    useEffect(()=>{
      if(!mapPlacementState.show)return;
      const escape=event=>{if(event.key==='Escape' && !mapPlacementSaving){event.preventDefault();handleCloseMapPlacement();}};
      window.addEventListener('keydown',escape);return()=>window.removeEventListener('keydown',escape);
    },[mapPlacementState.show,mapPlacementSaving,handleCloseMapPlacement]);
    useEffect(()=>{handleCloseMapPlacement();},[displayedMap?.mapId,handleCloseMapPlacement]);

    const commitEnemyMapPlacement = useCallback(
      async ({ mapId, x, y, rotation }) => {
        if (!mapPlacementState.show || !shouldShowCampaignTokens) {
          return false;
        }

        const normalizedCharacterId =
          typeof mapPlacementState.enemyId === 'string' && mapPlacementState.enemyId.trim() !== ''
            ? mapPlacementState.enemyId.trim()
            : null;
        const candidateMapId =
          typeof mapId === 'string' && mapId.trim() !== '' ? mapId.trim() : null;
        const normalizedDisplayedMapId =
          typeof displayedMap?.mapId === 'string' && displayedMap.mapId.trim() !== ''
            ? displayedMap.mapId.trim()
            : null;
        const normalizedMapId = candidateMapId || normalizedDisplayedMapId;
        const clampedX = clamp01(x);
        const clampedY = clamp01(y);
        const normalizedRotation = normalizeRotation(rotation);

        if (!normalizedMapId || !normalizedCharacterId || clampedX === null || clampedY === null) {
          return false;
        }

        return Boolean(await persistTokenPosition({
          mapId: normalizedMapId,
          characterId: normalizedCharacterId,
          x: clampedX,
          y: clampedY,
          rotation: normalizedRotation,
        }));
      },
      [
        displayedMap,
        mapPlacementState.enemyId,
        mapPlacementState.show,
        persistTokenPosition,
        shouldShowCampaignTokens,
      ]
    );

    const handleMapBackgroundPlacement = useCallback(
      async ({ x, y }) => {
        if (!mapPlacementState.show || mapPlacementSaving) {
          return false;
        }

        setMapPlacementSaving(true);
        setMapPlacementError(null);

        try {
          const result = await commitEnemyMapPlacement({ x, y });
          if (!result) {
            setMapPlacementError('Unable to update figurine position.');
            return false;
          }

          handleCloseMapPlacement();
          return true;
        } catch (error) {
          const message =
            (error && typeof error.message === 'string' && error.message.trim()) ||
            'Failed to update figurine position.';
          setMapPlacementError(message);
          return false;
        } finally {
          setMapPlacementSaving(false);
        }
      },
      [commitEnemyMapPlacement, handleCloseMapPlacement, mapPlacementSaving, mapPlacementState.show]
    );


    const RESOURCE_TABS = useMemo(
      () => [
        { key: 'loot', title: 'Loot', icon: GiBackpack },
        { key: 'characters', title: 'Combat Tracker', icon: GiCharacter },
        { key: 'players', title: 'Players', icon: GiHolyGrail },
        { key: 'objectives', title: 'Objectives', icon: FaStar },
        { key: 'map', title: 'Map', icon: GiTreasureMap },
        { key: 'enemies', title: 'Enemies', icon: GiPentagramRose },
        { key: 'equipment', title: 'Equipment', icon: GiBackpack },
      ],
      []
    );
    const EQUIPMENT_TABS = [
        { key: 'weapons', title: 'Weapons', icon: GiBroadsword },
        { key: 'armor', title: 'Armor', icon: GiArmorVest },
        { key: 'items', title: 'Items', icon: GiBackpack },
        { key: 'accessories', title: 'Accessories', icon: GiSpellBook },
        { key: 'shop', title: 'Shop', icon: GiHolyGrail },
    ];
    const [activeResourceTab, setActiveResourceTab] = useState(null);

    const handleSelectResourceTab = useCallback((key) => {
      if (!key) {
        return;
      }

      setActiveResourceTab((current) => (current === key ? null : key));
    }, []);

    const handleShowEnemiesTab = useCallback(() => {
      setActiveResourceTab('enemies');
    }, [setActiveResourceTab]);

    const handleOpenMapPlacement = useCallback(
      (enemyId, enemyName) => {
        const normalizedId =
          typeof enemyId === 'string' && enemyId.trim() !== '' ? enemyId.trim() : null;

        if (!normalizedId) {
          return;
        }

        const normalizedName =
          typeof enemyName === 'string' && enemyName.trim() !== '' ? enemyName.trim() : null;

        setMapPlacementError(null);
        setMapPlacementState({
          show: true,
          enemyId: normalizedId,
          enemyName: normalizedName,
        });

        setActiveResourceTab((current) => (current === 'enemies' ? null : current));
      },
      [setActiveResourceTab, setMapPlacementState]
    );

    useEffect(() => {
      if (
        activeResourceTab === 'enemies' &&
        !monsterCatalogLoaded &&
        !monsterCatalogLoading
      ) {
        fetchMonsterCatalog();
      }
    }, [activeResourceTab, monsterCatalogLoaded, monsterCatalogLoading, fetchMonsterCatalog]);

    const handleGenerateMap = useCallback(async () => {
      const prompt = mapPrompt.trim();
      setMapGenerating(true);
      try {
        const response = await apiFetch('/ai/map', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ prompt, campaign: campaignId, lighting: mapLighting }),
        });

        if (!response.ok) {
          let message = response.statusText || 'Failed to generate map.';
          try {
            const errorBody = await response.json();
            message = errorBody?.message || message;
          } catch (error) {
            // ignore json parsing errors
          }
          throw new Error(message);
        }

        const mapData = await response.json();
        setGeneratedMap(mapData || null);
        setStatus({ type: 'success', message: 'Map generated.' });
      } catch (error) {
        console.error(error);
        setStatus({
          type: 'danger',
          message: error.message || 'Failed to generate map.',
        });
      } finally {
        setMapGenerating(false);
      }
    }, [mapPrompt, campaignId, mapLighting]);

    const handleSaveMap = useCallback(
      async (mode = 'update', options = {}) => {
        if (!campaignId || !encodedCampaign) {
          return;
        }

        const trimmedPrompt = mapPrompt.trim();
        const isCreate = mode === 'create';

        const sourceMap = isCreate
          ? generatedMap || previewMap || campaignMap
          : generatedMap || campaignMap;

        if (!sourceMap) {
          setStatus({ type: 'danger', message: 'No map available to save.' });
          return false;
        }

        // The draft's save bar names the map and its folder.
        const mapToSave =
          typeof options.title === 'string' && options.title.trim()
            ? { ...sourceMap, title: options.title.trim() }
            : sourceMap;
        const trimmedFolder =
          typeof options.folder === 'string'
            ? options.folder.trim()
            : typeof mapToSave?.folder === 'string'
            ? mapToSave.folder.trim()
            : '';

        setMapSaveMode(mode);
        const shouldActivateNewMap =
          options.activate === undefined ? true : Boolean(options.activate);

        const saveViaLegacyEndpoint = async () => {
          const response = await apiFetch(`/campaigns/${encodedCampaign}/map`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              map: mapToSave,
              prompt: trimmedPrompt || undefined,
            }),
          });

          if (!response.ok) {
            const message = await parseErrorMessage(response, 'Failed to save map.');
            throw new Error(message);
          }

          let savedMap = null;
          try {
            savedMap = await response.json();
          } catch (error) {
            savedMap = null;
          }

          const normalizedMap =
            savedMap && typeof savedMap === 'object' && !Array.isArray(savedMap)
              ? savedMap
              : mapToSave;

          const normalizedMapId =
            typeof normalizedMap?.mapId === 'string' && normalizedMap.mapId.trim() !== ''
              ? normalizedMap.mapId.trim()
              : null;

          applyMapPayload(
            {
              maps: normalizedMapId ? [normalizedMap] : [],
              activeMapId: normalizedMapId,
              map: normalizedMap,
            },
            { preferredSelectedId: normalizedMapId }
          );
          setGeneratedMap(null);
          setStatus({ type: 'success', message: 'Map saved.' });
        };

        setMapSaving(true);
        let saved = false;
        try {
          if (isCreate) {
            const mapPayload = { ...mapToSave };
            delete mapPayload.mapId;
            delete mapPayload.createdAt;
            delete mapPayload.updatedAt;
            if (trimmedFolder) {
              mapPayload.folder = trimmedFolder;
            } else {
              delete mapPayload.folder;
            }

            const response = await apiFetch(`/campaigns/${encodedCampaign}/maps`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                map: mapPayload,
                prompt: trimmedPrompt || undefined,
                activate: shouldActivateNewMap,
              }),
            });

            if (!response.ok) {
              if (response.status === 404) {
                await saveViaLegacyEndpoint();
                saved = true;
                return true;
              }
              const message = await parseErrorMessage(response, 'Failed to save map.');
              throw new Error(message);
            }

            let payload = null;
            try {
              payload = await response.json();
            } catch (error) {
              payload = null;
            }

            if (payload && typeof payload === 'object') {
              let preferredId =
                (payload.map && payload.map.mapId) || payload.activeMapId || null;

              if (!preferredId && Array.isArray(payload.maps)) {
                const matchingMap = payload.maps.find((map) => {
                  if (!map || typeof map !== 'object') {
                    return false;
                  }
                  if (map.mapId && map.mapId === mapToSave.mapId) {
                    return true;
                  }
                  return (
                    map.title === mapToSave.title &&
                    map.imageUrl === mapToSave.imageUrl &&
                    map.imageBase64 === mapToSave.imageBase64
                  );
                });
                preferredId = matchingMap?.mapId || null;
              }

              applyMapPayload(payload, {
                preferredSelectedId: preferredId || null,
              });
            } else {
              applyMapPayload({ maps: [], activeMapId: null, map: null });
            }

            setGeneratedMap(null);
            setStatus({ type: 'success', message: 'Map saved.' });
            setLastMapFolder(trimmedFolder);
            saved = true;
          } else {
            // Replace the map the DM named (the selected library map), falling back to the active map.
            const activeId =
              normalizeMapId(options.replaceMapId) ||
              activeMapId ||
              (typeof campaignMap?.mapId === 'string' && campaignMap.mapId.trim() !== ''
                ? campaignMap.mapId.trim()
                : null);

            if (!activeId) {
              setStatus({
                type: 'danger',
                message: 'No map chosen to replace.',
              });
              return false;
            }

            const mapPayload = { ...mapToSave };
            if (mapPayload.mapId && mapPayload.mapId !== activeId) {
              delete mapPayload.mapId;
            }
            if (trimmedFolder) {
              mapPayload.folder = trimmedFolder;
            } else {
              delete mapPayload.folder;
            }

            const response = await apiFetch(
              `/campaigns/${encodedCampaign}/maps/${encodeURIComponent(activeId)}`,
              {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  map: mapPayload,
                  prompt: trimmedPrompt || undefined,
                }),
              }
            );

            if (!response.ok) {
              if (response.status === 404) {
                await saveViaLegacyEndpoint();
                saved = true;
                return true;
              }
              const message = await parseErrorMessage(response, 'Failed to save map.');
              throw new Error(message);
            }

            let payload = null;
            try {
              payload = await response.json();
            } catch (error) {
              payload = null;
            }

            if (payload && typeof payload === 'object') {
              applyMapPayload(payload, { preferredSelectedId: activeId });
            }

            setGeneratedMap(null);
            setStatus({ type: 'success', message: 'Map saved.' });
            saved = true;
          }
        } catch (error) {
          console.error(error);
          setStatus({
            type: 'danger',
            message: error.message || 'Failed to save map.',
          });
        } finally {
          setMapSaving(false);
          setMapSaveMode(null);
        }
        return saved;
      },
      [
        campaignId,
        encodedCampaign,
        generatedMap,
        previewMap,
        campaignMap,
        mapPrompt,
        applyMapPayload,
        activeMapId,
        parseErrorMessage,
      ]
    );

    const handleSelectMap = useCallback(
      (mapId) => {
        const normalizedId =
          typeof mapId === 'string' && mapId.trim() !== '' ? mapId.trim() : null;
        setSelectedMapId(normalizedId);
        setGeneratedMap(null);
      },
      []
    );

    const beginMapUpload = useCallback(() => {
      setMapEditorSaving(false);
      setMapEditorErrors({});
      const defaultFolder = typeof lastMapFolder === 'string' ? lastMapFolder : '';
      setMapEditorState({
        show: false,
        mode: 'create',
        map: {},
        title: '',
        folder: defaultFolder,
        folderSelection: defaultFolder
          ? availableMapFolders.includes(defaultFolder) ? defaultFolder : NEW_FOLDER_OPTION_VALUE
          : '',
        imageUrl: '',
        imageBase64: '',
        imageType: '',
        imageWidth: null,
        imageHeight: null,
        altText: '',
        gridSelection: `${DEFAULT_MAP_GRID_DIMENSION}`,
        activateOnSave: maps.length === 0,
        fileInputKey: Date.now(),
      });
    }, [lastMapFolder, availableMapFolders, maps.length]);

    const openRenameMapModal = useCallback((map) => {
      if (!map || typeof map !== 'object') {
        return;
      }

      setMapEditorSaving(false);
      setMapEditorErrors({});
      const safeMap = map;

      setMapEditorState({
        show: true,
        mode: 'rename',
        map: safeMap,
        title: typeof safeMap.title === 'string' ? safeMap.title : '',
        folder:
          typeof safeMap.folder === 'string' && safeMap.folder.trim() !== ''
            ? safeMap.folder.trim()
            : '',
        folderSelection:
          typeof safeMap.folder === 'string' && safeMap.folder.trim() !== ''
            ? availableMapFolders.includes(safeMap.folder.trim())
              ? safeMap.folder.trim()
              : NEW_FOLDER_OPTION_VALUE
            : '',
        imageUrl: typeof safeMap.imageUrl === 'string' ? safeMap.imageUrl : '',
        imageBase64:
          typeof safeMap.imageBase64 === 'string' ? safeMap.imageBase64 : '',
        imageType:
          typeof safeMap.imageType === 'string' ? safeMap.imageType : '',
        imageWidth: Number.isFinite(Number(safeMap.imageWidth)) ? Number(safeMap.imageWidth) : null,
        imageHeight: Number.isFinite(Number(safeMap.imageHeight)) ? Number(safeMap.imageHeight) : null,
        altText: typeof safeMap.altText === 'string' ? safeMap.altText : '',
        gridSelection: resolveMapGridSelection(safeMap),
        activateOnSave: false,
        fileInputKey: Date.now(),
      });
    }, [availableMapFolders]);

    const handleMapEditorInputChange = useCallback(
      (field) => (event) => {
        const value = event?.target?.value ?? '';
        setMapEditorState((prev) => ({ ...prev, [field]: value }));
      },
      []
    );

    const handleMapEditorFolderSelectionChange = useCallback((event) => {
      const value = event?.target?.value ?? '';
      setMapEditorState((prev) => ({
        ...prev,
        folderSelection: value,
        folder: value && value !== NEW_FOLDER_OPTION_VALUE ? value : '',
      }));
    }, []);

    const handleMapEditorActivateChange = useCallback((event) => {
      const checked = Boolean(event?.target?.checked);
      setMapEditorState((prev) => ({ ...prev, activateOnSave: checked }));
    }, []);

    const handleMapEditorFileChange = useCallback((event) => {
      const file = event?.target?.files?.[0];
      if (!file) {
        setMapEditorState((prev) => ({
          ...prev,
          imageBase64: '',
          imageType: '',
          imageWidth: null,
          imageHeight: null,
        }));
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        const result = typeof reader.result === 'string' ? reader.result : '';
        if (!result) {
          setMapEditorState((prev) => ({
            ...prev,
            imageBase64: '',
            imageType: '',
            imageWidth: null,
            imageHeight: null,
          }));
          return;
        }

        let nextImageType = file.type || '';
        let nextImageBase64 = result;

        const commaIndex = result.indexOf(',');
        if (result.startsWith('data:') && commaIndex !== -1) {
          const meta = result.substring(5, commaIndex);
          const semicolonIndex = meta.indexOf(';');
          nextImageType =
            semicolonIndex !== -1 ? meta.substring(0, semicolonIndex) : meta;
          nextImageBase64 = result.substring(commaIndex + 1);
        }

        setMapEditorState((prev) => ({
          ...prev,
          imageBase64: nextImageBase64,
          imageType: nextImageType,
          imageUrl: '',
          imageWidth: null,
          imageHeight: null,
        }));

        const dataUrl = result.startsWith('data:') ? result : `data:${nextImageType || 'image/*'};base64,${nextImageBase64}`;

        loadMapEditorImageDimensions(dataUrl).then((dimensions) => {
          if (!dimensions) {
            return;
          }

          setMapEditorState((prev) => ({
            ...prev,
            imageWidth: dimensions.width,
            imageHeight: dimensions.height,
          }));
        });
      };

      reader.onerror = () => {
        setMapEditorState((prev) => ({
          ...prev,
          imageBase64: '',
          imageType: '',
          imageWidth: null,
          imageHeight: null,
        }));
      };

      reader.readAsDataURL(file);
    }, []);

    const handleSubmitMapEditor = useCallback(
      async (event) => {
        event.preventDefault();
        if (!campaignId || !encodedCampaign) {
          return;
        }

        const {
          mode,
          map: editorMap,
          title,
          folder,
          imageUrl,
          imageBase64,
          imageType,
          imageWidth,
          imageHeight,
          altText,
          gridSelection,
          activateOnSave,
        } = mapEditorState;

        const baseMap =
          mode === 'rename'
            ? editorMap || {}
            : editorMap || generatedMap || previewMap || {};

        const trimmedTitle = typeof title === 'string' ? title.trim() : '';
        const trimmedImageUrl = typeof imageUrl === 'string' ? imageUrl.trim() : '';
        const trimmedImageBase64 =
          typeof imageBase64 === 'string' ? imageBase64.trim() : '';
        const trimmedImageType =
          typeof imageType === 'string' ? imageType.trim() : '';
        const trimmedAltText = typeof altText === 'string' ? altText.trim() : '';
        const trimmedFolder = typeof folder === 'string' ? folder.trim() : '';

        const errors = {};

        if (!trimmedTitle) {
          errors.title = 'Title is required.';
        }

        if (!trimmedImageUrl && !trimmedImageBase64) {
          errors.imageSource = 'Provide an image URL or upload a file.';
        }

        if (Object.keys(errors).length > 0) {
          setMapEditorErrors(errors);
          return false;
        }

        setMapEditorErrors({});

        const normalizedTitle = trimmedTitle || getMapDisplayTitle(baseMap, DEFAULT_MAP_TITLE);

        const sanitizedBaseMap =
          baseMap && typeof baseMap === 'object' ? { ...baseMap } : {};
        delete sanitizedBaseMap.summary;
        delete sanitizedBaseMap.caption;
        delete sanitizedBaseMap.imageUrl;
        delete sanitizedBaseMap.imageBase64;
        delete sanitizedBaseMap.imageType;
        delete sanitizedBaseMap.folder;

        const payloadMap = {
          ...sanitizedBaseMap,
          title: normalizedTitle,
        };

        if (trimmedFolder) {
          payloadMap.folder = trimmedFolder;
        }

        if (trimmedAltText) {
          payloadMap.altText = trimmedAltText;
        } else if (mode === 'create') {
          payloadMap.altText = `Battle map: ${normalizedTitle}`;
        } else {
          delete payloadMap.altText;
        }

        if (trimmedImageUrl) {
          payloadMap.imageUrl = trimmedImageUrl;
        } else if (trimmedImageBase64) {
          payloadMap.imageBase64 = trimmedImageBase64;
          if (trimmedImageType) {
            payloadMap.imageType = trimmedImageType;
          }
        }

        const parsedGridSelection = Number.parseInt(gridSelection, 10);
        const resolvedGridDimension =
          Number.isInteger(parsedGridSelection) && parsedGridSelection >= 1 && parsedGridSelection <= 200
            ? parsedGridSelection
            : DEFAULT_MAP_GRID_DIMENSION;

        if (Number.isFinite(resolvedGridDimension) && resolvedGridDimension > 0) {
          const hasStoredImageDimensions =
            Number.isFinite(Number(imageWidth)) &&
            Number.isFinite(Number(imageHeight)) &&
            Number(imageWidth) > 0 &&
            Number(imageHeight) > 0;
          const existingDimensions = hasStoredImageDimensions
            ? { width: Number(imageWidth), height: Number(imageHeight) }
            : trimmedImageUrl
            ? await loadMapEditorImageDimensions(trimmedImageUrl)
            : null;
          const resolvedGridRows = resolveAspectMatchedGridRows(
            resolvedGridDimension,
            existingDimensions?.width,
            existingDimensions?.height
          );
          const gridDimensionString = formatGridDimensionString(resolvedGridDimension, resolvedGridRows);
          payloadMap.gridColumns = resolvedGridDimension;
          payloadMap.gridRows = resolvedGridRows;
          if (existingDimensions) {
            payloadMap.imageWidth = existingDimensions.width;
            payloadMap.imageHeight = existingDimensions.height;
          }
          payloadMap.gridDimensions = gridDimensionString;
          payloadMap.gridSize = gridDimensionString;

          const existingGrid =
            payloadMap.grid && typeof payloadMap.grid === 'object' ? payloadMap.grid : {};

          payloadMap.grid = {
            ...existingGrid,
            columns: resolvedGridDimension,
            rows: resolvedGridRows,
            dimensions: gridDimensionString,
            size: gridDimensionString,
            gridSize: gridDimensionString,
            gridDimensions: gridDimensionString,
          };
        }

        if (mode === 'create') {
          delete payloadMap.mapId;
          delete payloadMap.createdAt;
          delete payloadMap.updatedAt;
        }

        const trimmedPrompt = mapPrompt.trim();

        setMapEditorSaving(true);
        let saved = false;
        try {
          if (mode === 'create') {
            const response = await apiFetch(`/campaigns/${encodedCampaign}/maps`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                map: payloadMap,
                prompt: trimmedPrompt || undefined,
                activate: Boolean(activateOnSave),
              }),
            });

            if (!response.ok) {
              const message = await parseErrorMessage(response, 'Failed to save map.');
              throw new Error(message);
            }

            let payload = null;
            try {
              payload = await response.json();
            } catch (error) {
              payload = null;
            }

            if (payload && typeof payload === 'object') {
              let preferredId =
                (payload.map && payload.map.mapId) || payload.activeMapId || null;

              if (!preferredId && Array.isArray(payload.maps)) {
                const matchingMap = payload.maps.find((map) => {
                  if (!map || typeof map !== 'object') {
                    return false;
                  }
                  if (payloadMap.imageUrl && map.imageUrl === payloadMap.imageUrl) {
                    return true;
                  }
                  if (payloadMap.imageBase64 && map.imageBase64 === payloadMap.imageBase64) {
                    return true;
                  }
                  const normalizedPayloadTitle =
                    typeof payloadMap.title === 'string' ? payloadMap.title : '';
                  const normalizedMapTitle =
                    typeof map.title === 'string' ? map.title : '';
                  if (!normalizedPayloadTitle || normalizedMapTitle !== normalizedPayloadTitle) {
                    return false;
                  }

                  const normalizedPayloadPrompt =
                    typeof payloadMap.prompt === 'string' ? payloadMap.prompt : '';
                  const normalizedMapPrompt =
                    typeof map.prompt === 'string' ? map.prompt : '';
                  if (
                    normalizedPayloadPrompt &&
                    normalizedMapPrompt === normalizedPayloadPrompt
                  ) {
                    return true;
                  }

                  const normalizedPayloadAltText =
                    typeof payloadMap.altText === 'string' ? payloadMap.altText : '';
                  const normalizedMapAltText =
                    typeof map.altText === 'string' ? map.altText : '';
                  if (
                    normalizedPayloadAltText &&
                    normalizedMapAltText === normalizedPayloadAltText
                  ) {
                    return true;
                  }

                  return !normalizedPayloadPrompt && !normalizedPayloadAltText;
                });
                preferredId = matchingMap?.mapId || null;
              }

              applyMapPayload(payload, { preferredSelectedId: preferredId || null });
            } else {
              applyMapPayload({ maps: [], activeMapId: null, map: null });
            }

            setStatus({ type: 'success', message: 'Map saved.' });
            setLastMapFolder(trimmedFolder);
          } else {
            const targetMapId =
              typeof editorMap?.mapId === 'string' && editorMap.mapId.trim() !== ''
                ? editorMap.mapId.trim()
                : null;

            if (!targetMapId) {
              throw new Error('Map identifier is missing.');
            }

            const response = await apiFetch(
              `/campaigns/${encodedCampaign}/maps/${encodeURIComponent(targetMapId)}`,
              {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  map: payloadMap,
                  prompt: trimmedPrompt || undefined,
                }),
              }
            );

            if (!response.ok) {
              const message = await parseErrorMessage(response, 'Failed to update map.');
              throw new Error(message);
            }

            let payload = null;
            try {
              payload = await response.json();
            } catch (error) {
              payload = null;
            }

            if (payload && typeof payload === 'object') {
              applyMapPayload(payload, { preferredSelectedId: targetMapId });
            }

            setStatus({ type: 'success', message: 'Map updated.' });
            setLastMapFolder(trimmedFolder);
          }

          if (mode === 'create') {
            setGeneratedMap(null);
          }
          setMapEditorState((prev) => ({ ...prev, show: false }));
          saved = true;
        } catch (error) {
          console.error(error);
          setStatus({
            type: 'danger',
            message: error.message || 'Failed to save map.',
          });
        } finally {
          setMapEditorSaving(false);
        }
        return saved;
      },
      [
        campaignId,
        encodedCampaign,
        mapEditorState,
        mapPrompt,
        generatedMap,
        previewMap,
        applyMapPayload,
        parseErrorMessage,
        setLastMapFolder,
      ]
    );

    const mapLibraryEditor = useMemo(() => ({
      state: mapEditorState,
      errors: mapEditorErrors,
      saving: mapEditorSaving,
      folders: availableMapFolders,
      gridOptions: MAP_GRID_CHOICES,
      describedBy: imageSourceDescribedBy,
      onFieldChange: handleMapEditorInputChange,
      onFolderSelect: handleMapEditorFolderSelectionChange,
      onActivateChange: handleMapEditorActivateChange,
      onFileChange: handleMapEditorFileChange,
      onSubmit: handleSubmitMapEditor,
      beginEdit: openRenameMapModal,
      beginUpload: beginMapUpload,
    }), [mapEditorState, mapEditorErrors, mapEditorSaving, availableMapFolders, imageSourceDescribedBy,
      handleMapEditorInputChange, handleMapEditorFolderSelectionChange, handleMapEditorActivateChange,
      handleMapEditorFileChange, handleSubmitMapEditor, openRenameMapModal, beginMapUpload]);

    const handleActivateMap = useCallback(
      async (mapId) => {
        const normalizedId =
          typeof mapId === 'string' && mapId.trim() !== '' ? mapId.trim() : null;
        if (!campaignId || !encodedCampaign || !normalizedId || normalizedId === activeMapId) {
          return;
        }

        setMapActionLoadingId(normalizedId);
        try {
          const response = await apiFetch(
            `/campaigns/${encodedCampaign}/maps/${encodeURIComponent(normalizedId)}`,
            {
              method: 'PATCH',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ active: true }),
            }
          );

          if (!response.ok) {
            const message = await parseErrorMessage(response, 'Failed to activate map.');
            throw new Error(message);
          }

          let payload = null;
          try {
            payload = await response.json();
          } catch (error) {
            payload = null;
          }

          if (payload && typeof payload === 'object') {
            applyMapPayload(payload, { preferredSelectedId: normalizedId });
          }

          setStatus({ type: 'success', message: 'Active map updated.' });
        } catch (error) {
          console.error(error);
          setStatus({
            type: 'danger',
            message: error.message || 'Failed to activate map.',
          });
        } finally {
          setMapActionLoadingId(null);
        }
      },
      [campaignId, encodedCampaign, activeMapId, applyMapPayload, parseErrorMessage]
    );

    const handleDeleteMap = useCallback(
      async (mapId) => {
        const normalizedId =
          typeof mapId === 'string' && mapId.trim() !== '' ? mapId.trim() : null;
        if (!campaignId || !encodedCampaign || !normalizedId) {
          return;
        }

        const confirmed = window.confirm('Are you sure you want to delete this map?');
        if (!confirmed) {
          return;
        }

        setMapActionLoadingId(normalizedId);
        try {
          const response = await apiFetch(
            `/campaigns/${encodedCampaign}/maps/${encodeURIComponent(normalizedId)}`,
            {
              method: 'DELETE',
            }
          );

          if (!response.ok) {
            const message = await parseErrorMessage(response, 'Failed to delete map.');
            throw new Error(message);
          }

          let payload = null;
          try {
            payload = await response.json();
          } catch (error) {
            payload = null;
          }

          if (payload && typeof payload === 'object') {
            applyMapPayload(payload);
          } else {
            applyMapPayload({ maps: [], activeMapId: null, map: null });
          }

          setStatus({ type: 'success', message: 'Map deleted.' });
        } catch (error) {
          console.error(error);
          setStatus({
            type: 'danger',
            message: error.message || 'Failed to delete map.',
          });
        } finally {
          setMapActionLoadingId(null);
        }
      },
      [campaignId, encodedCampaign, applyMapPayload, parseErrorMessage]
    );
    //--------------------------------------------Currency Adjustments------------------------------
    const [currencyModalState, setCurrencyModalState] = useState({ show: false, character: null });
    const [currencyInputs, setCurrencyInputs] = useState({ cp: '0', sp: '0', gp: '0', pp: '0' });
    const [currencySubmitting, setCurrencySubmitting] = useState(false);

    const openCurrencyModal = (character) => {
      setCurrencyModalState({ show: true, character });
      setCurrencyInputs({ cp: '0', sp: '0', gp: '0', pp: '0' });
    };

    const closeCurrencyModal = () => {
      setCurrencyModalState({ show: false, character: null });
    };

    const updateCurrencyInput = (field, value) => {
      setCurrencyInputs((prev) => ({ ...prev, [field]: value }));
    };

    const convertCopperToCurrency = (totalCopper) => {
      const sign = totalCopper < 0 ? -1 : 1;
      let remaining = Math.abs(totalCopper);
      const pp = Math.floor(remaining / 1000);
      remaining %= 1000;
      const gp = Math.floor(remaining / 100);
      remaining %= 100;
      const sp = Math.floor(remaining / 10);
      remaining %= 10;
      const cp = remaining;

      return {
        pp: pp * sign,
        gp: gp * sign,
        sp: sp * sign,
        cp: cp * sign,
      };
    };

    const handleCurrencySubmit = async (event) => {
      event.preventDefault();
      if (!currencyModalState.character) {
        return;
      }
      setCurrencySubmitting(true);
      try {
        const parseField = (value) => {
          const parsed = parseInt(value, 10);
          return Number.isNaN(parsed) ? 0 : parsed;
        };

        const copper = parseField(currencyInputs.cp);
        const silver = parseField(currencyInputs.sp);
        const gold = parseField(currencyInputs.gp);
        const platinum = parseField(currencyInputs.pp);

        const totalCopper = copper + silver * 10 + gold * 100 + platinum * 1000;
        const normalized = convertCopperToCurrency(totalCopper);

        const response = await apiFetch(`/characters/${currencyModalState.character._id}/currency`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(normalized),
        });

        if (!response.ok) {
          throw new Error(response.statusText || 'Failed to update currency');
        }

        await fetchRecords();
        setStatus({ type: 'success', message: 'Currency updated.' });
        closeCurrencyModal();
      } catch (error) {
        setStatus({ type: 'danger', message: error.message || 'Failed to update currency' });
      } finally {
        setCurrencySubmitting(false);
      }
    };
//--------------------------------------------Campaign Section------------------------------


// Fetch CampaignsDM
useEffect(() => {
  if (!user) {
    return;
  }
  async function fetchCampaignsDM() {
    const response = await apiFetch(`/campaigns/dm/${user.username}/${params.campaign}`);

    if (!response.ok) {
      const message = `An error has occurred: ${response.statusText}`;
      setStatus({ type: 'danger', message });
      return;
    }

    const record = await response.json();
    if (!record) {
      setStatus({ type: 'danger', message: 'Record not found' });
      navigate("/");
      return;
    }
    setCampaignDM( record );
  }
  fetchCampaignsDM();   
  return;
  
}, [ navigate, user, params.campaign ]);

//---------------------------------------Add Player-------------------------------------------
const [players, setPlayers] = useState({ 
  players: [] 
});

const [playersSearch, setPlayersSearch] = useState("");

 useEffect(() => {
    if (!user) {
      return;
    }

    async function fetchUsers() {
      const response = await apiFetch(`/users`);

      if (!response.ok) {
        const message = `An error has occurred: ${response.statusText}`;
        setStatus({ type: 'danger', message });
        return;
      }

      const record = await response.json();
      if (!record) {
        setStatus({ type: 'danger', message: 'Record not found' });
        navigate("/");
        return;
      }
      setPlayers({players: record});
    }

    fetchUsers();
  }, [navigate, user]);

async function newPlayerSubmit(e) {
  e.preventDefault();   
   sendNewPlayersToDb();
}

const currentCampaign = params.campaign.toString();
async function sendNewPlayersToDb() {
  const newPlayers = [playersSearch];
  await apiFetch(`/campaigns/players/add/${currentCampaign}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(newPlayers),
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(response.status === 400 ? "Player already exists!" : "Failed to add player");
    }
    return response.text(); // Change to text() instead of json()
  })
  .then(data => {
    setStatus({ type: 'success', message: 'Player Successfully Added!' });
    setPlayersSearch(""); // Clear input after successful submission
    navigate(0);
  })
  .catch(error => {
    console.error('Error:', error);
    setStatus({ type: 'danger', message: error.message });
  });
}

//---------------------------------------Weapons----------------------------------------------

const [form2, setForm2] = useState({
    campaign: currentCampaign,
    name: "",
    type: "",
    category: "",
    damage: "",
    properties: [],
    weight: "",
    cost: "",
  });

  const [weaponPrompt, setWeaponPrompt] = useState("");
  const [loading, setLoading] = useState(false);

  const [armorPrompt, setArmorPrompt] = useState("");
  const [armorLoading, setArmorLoading] = useState(false);

  const [isCreatingWeapon, setIsCreatingWeapon] = useState(false);

  const [weapons, setWeapons] = useState([]);
  const [weaponOptions, setWeaponOptions] = useState({
    types: [],
    categories: [],
    properties: [],
  });

    const fetchWeapons = useCallback(async () => {
      const response = await apiFetch(`/equipment/weapons/${currentCampaign}`);
      if (!response.ok) {
        const message = `An error has occurred: ${response.statusText}`;
        setStatus({ type: 'danger', message });
        return;
      }
      const data = await response.json();
      setWeapons(data);
    }, [currentCampaign]);

    const fetchWeaponOptions = useCallback(async () => {
      const response = await apiFetch('/weapons/options');
      if (!response.ok) {
        const message = `An error has occurred: ${response.statusText}`;
        setStatus({ type: 'danger', message });
        return;
      }
      const data = await response.json();
      setWeaponOptions(data);
    }, []);

    useEffect(() => {
      if (activeResourceTab === 'weapons') {
        fetchWeapons();
        fetchWeaponOptions();
      }
    }, [activeResourceTab, fetchWeapons, fetchWeaponOptions]);
  
  function updateForm2(value) {
    return setForm2((prev) => {
      return { ...prev, ...value };
    });
  }

  async function generateWeapon() {
    setLoading(true);
    try {
      if (!weaponOptions.types.length || !weaponOptions.categories.length) {
        setStatus({ type: 'danger', message: 'Weapon options not loaded' });
        return;
      }
      const response = await apiFetch('/ai/weapon', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: weaponPrompt }),
      });
      if (!response.ok) {
        let message;
        try {
          const errorData = await response.json();
          message = errorData?.message || response.statusText;
        } catch {
          message = response.statusText;
        }
        setStatus({ type: 'danger', message });
        return;
      }
      const weapon = await response.json();
      updateForm2({
        name: weapon.name || '',
        type: weapon.type || '',
        category: weapon.category || '',
        damage: weapon.damage || '',
        properties: weapon.properties || [],
        weight: weapon.weight ?? '',
        cost: weapon.cost ?? '',
      });
    } catch (err) {
      setStatus({ type: 'danger', message: err.message || 'Failed to generate weapon' });
    } finally {
      setLoading(false);
    }
  }
  
  async function onSubmit2(e) {
    e.preventDefault();   
     sendToDb2();
  }
  
  async function sendToDb2(){
    const weightNumber = form2.weight === "" ? undefined : Number(form2.weight);
    const costNumber = form2.cost === "" ? undefined : Number(form2.cost);
    const newWeapon = {
      campaign: currentCampaign,
      name: form2.name,
      type: form2.type,
      category: form2.category,
      damage: form2.damage,
      properties: form2.properties,
      weight: weightNumber,
      cost: costNumber,
    };
    Object.keys(newWeapon).forEach((key) => {
      if (newWeapon[key] === "" || newWeapon[key] === undefined) {
        delete newWeapon[key];
      }
    });
    try {
      const response = await apiFetch("/equipment/weapon/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newWeapon),
      });

      if (!response.ok) {
        let message;
        try {
          const errorData = await response.json();
          message = errorData?.message || errorData?.error || response.statusText;
        } catch {
          message = response.statusText;
        }
        setStatus({ type: 'danger', message });
        return;
      }

      setForm2({
        campaign: currentCampaign,
        name: "",
        type: "",
        category: "",
        damage: "",
        properties: [],
        weight: "",
        cost: "",
      });
      setIsCreatingWeapon(false);
      fetchWeapons();
    } catch (error) {
      setStatus({ type: 'danger', message: error.toString() });
    }
  }

  async function deleteWeapon(id) {
    try {
      const response = await apiFetch(`/equipment/weapon/${id}`, { method: 'DELETE' });
      if (!response.ok) {
        const message = `An error has occurred: ${response.statusText}`;
        setStatus({ type: 'danger', message });
        return;
      }
      setWeapons((prev) => prev.filter((w) => w._id !== id));
    } catch (error) {
      setStatus({ type: 'danger', message: error.toString() });
    }
  }
   //  ------------------------------------Armor-----------------------------------
  
  const [isCreatingArmor, setIsCreatingArmor] = useState(false);

  const [armor, setArmor] = useState([]);
  const [armorOptions, setArmorOptions] = useState({
    types: [],
    categories: [],
    slots: [],
  });

  const [form3, setForm3] = useState({
    campaign: currentCampaign,
    armorName: "",
    type: "",
    category: "",
    slot: "",
    armorBonus: "",
    maxDex: "",
    strength: "",
    stealth: "",
    weight: "",
    cost: "",
  });
  
  function updateForm3(value) {
    return setForm3((prev) => {
      return { ...prev, ...value };
    });
  }

  const fetchArmor = useCallback(async () => {
    const response = await apiFetch(`/equipment/armor/${currentCampaign}`);
    if (!response.ok) {
      const message = `An error has occurred: ${response.statusText}`;
      setStatus({ type: 'danger', message });
      return;
    }
    const data = await response.json();
    setArmor(data);
  }, [currentCampaign]);

  const fetchArmorOptions = useCallback(async () => {
    const response = await apiFetch('/armor/options');
    if (!response.ok) {
      const message = `An error has occurred: ${response.statusText}`;
      setStatus({ type: 'danger', message });
      return;
    }
    const data = await response.json();
    const { types = [], categories = [], slots = [] } = data || {};
    setArmorOptions({ types, categories, slots });
  }, []);

  const armorSlotLabels = useMemo(() => {
    const labels = {};
    (armorOptions.slots || []).forEach((slot) => {
      if (!slot || !slot.key) {
        return;
      }
      labels[slot.key] = slot.label || slot.key;
    });
    return labels;
  }, [armorOptions.slots]);

  const getArmorSlotLabel = useCallback(
    (armorEntry) => {
      const slotKey = armorEntry?.slot || armorEntry?.equipmentSlot;
      if (!slotKey) {
        return '—';
      }
      return armorSlotLabels[slotKey] || slotKey;
    },
    [armorSlotLabels]
  );

  useEffect(() => {
    if (activeResourceTab === 'armor') {
      fetchArmor();
      fetchArmorOptions();
    }
  }, [activeResourceTab, fetchArmor, fetchArmorOptions]);

  async function generateArmor() {
    setArmorLoading(true);
    try {
      if (!armorOptions.types.length || !armorOptions.categories.length) {
        setStatus({ type: 'danger', message: 'Armor options not loaded' });
        return;
      }
      const response = await apiFetch('/ai/armor', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: armorPrompt }),
      });
      if (!response.ok) {
        let message;
        try {
          const errorData = await response.json();
          message = errorData?.message || response.statusText;
        } catch {
          message = response.statusText;
        }
        setStatus({ type: 'danger', message });
        return;
      }
      const armor = await response.json();
      updateForm3({
        armorName: armor.name || '',
        type: armor.type || '',
        category: armor.category || '',
        slot: armor.slot || armor.equipmentSlot || '',
        armorBonus: armor.armorBonus ?? armor.acBonus ?? '',
        maxDex: armor.maxDex !== undefined ? String(armor.maxDex) : '',
        strength: armor.strength ?? '',
        stealth: armor.stealth !== undefined ? String(armor.stealth) : '',
        weight: armor.weight ?? '',
        cost: armor.cost !== undefined ? String(armor.cost) : '',
      });
    } catch (err) {
      setStatus({ type: 'danger', message: err.message || 'Failed to generate armor' });
    } finally {
      setArmorLoading(false);
    }
  }
  
  async function onSubmit3(e) {
    e.preventDefault();   
     sendToDb3();
  }
  
  async function sendToDb3(){
    const numericFields = ['armorBonus', 'maxDex', 'strength', 'weight'];
    const newArmor = Object.fromEntries(
      Object.entries(form3)
        .filter(([_, v]) => v !== "")
        .map(([key, value]) => [
          key,
          numericFields.includes(key) ? Number(value) : key === "cost" ? String(value) : value,
        ])
    );
    if (newArmor.slot && !newArmor.equipmentSlot) {
      newArmor.equipmentSlot = newArmor.slot;
    } else if (newArmor.equipmentSlot && !newArmor.slot) {
      newArmor.slot = newArmor.equipmentSlot;
    }
    await apiFetch("/equipment/armor/add", {
       method: "POST",
       headers: {
         "Content-Type": "application/json",
       },
       body: JSON.stringify(newArmor),
     })
   .catch(error => {
     setStatus({ type: 'danger', message: error.toString() });
     return;
   });

   setForm3({
    campaign: currentCampaign,
    armorName: "",
    type: "",
    category: "",
    slot: "",
    armorBonus: "",
    maxDex: "",
    strength: "",
    stealth: "",
    weight: "",
    cost: "",
  });
   fetchArmor();
   setIsCreatingArmor(false);
  }

  async function deleteArmor(id) {
    try {
      const response = await apiFetch(`/equipment/armor/${id}`, { method: 'DELETE' });
      if (!response.ok) {
        const message = `An error has occurred: ${response.statusText}`;
        setStatus({ type: 'danger', message });
        return;
      }
      await response.json();
      setArmor((prev) => prev.filter((a) => a._id !== id));
    } catch (error) {
      setStatus({ type: 'danger', message: error.toString() });
    }
  }
  
//------------------------------------Items------------------------------------------------------------
  const [isCreatingItem, setIsCreatingItem] = useState(false);

  const [items, setItems] = useState([]);
  const [itemOptions, setItemOptions] = useState({
    categories: [],
  });

  const [form4, setForm4] = useState({
    campaign: currentCampaign,
    name: "",
    category: "",
    weight: "",
    cost: "",
    notes: "",
    statBonuses: {},
    skillBonuses: {},
  });

  const [itemPrompt, setItemPrompt] = useState("");
  const [itemLoading, setItemLoading] = useState(false);
  const [showItemNotes, setShowItemNotes] = useState(false);
  const [currentItemNote, setCurrentItemNote] = useState('');

  const openItemNote = (note) => {
    setCurrentItemNote(note);
    setShowItemNotes(true);
  };

  const closeItemNote = () => setShowItemNotes(false);

  function updateForm4(value) {
    return setForm4((prev) => {
      return { ...prev, ...value };
    });
  }

  const fetchItems = useCallback(async () => {
    const response = await apiFetch(`/equipment/items/${currentCampaign}`);
    if (!response.ok) {
      const message = `An error has occurred: ${response.statusText}`;
      setStatus({ type: 'danger', message });
      return;
    }
    const data = await response.json();
    setItems(data);
  }, [currentCampaign]);

  const fetchItemOptions = useCallback(async () => {
    const response = await apiFetch('/items/options');
    if (!response.ok) {
      const message = `An error has occurred: ${response.statusText}`;
      setStatus({ type: 'danger', message });
      return;
    }
    const data = await response.json();
    setItemOptions(data);
  }, []);

  useEffect(() => {
    if (activeResourceTab === 'items') {
      fetchItems();
      fetchItemOptions();
    }
  }, [activeResourceTab, fetchItems, fetchItemOptions]);

  async function generateItem() {
    setItemLoading(true);
    try {
      if (!itemOptions.categories.length) {
        setStatus({ type: 'danger', message: 'Item options not loaded' });
        return;
      }
      const response = await apiFetch('/ai/item', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: itemPrompt }),
      });
      if (!response.ok) {
        let message;
        try {
          const errorData = await response.json();
          message = errorData?.message || response.statusText;
        } catch {
          message = response.statusText;
        }
        setStatus({ type: 'danger', message });
        return;
      }
      const item = await response.json();
      const normalizeBonuses = (bonuses, lookup) => {
        const result = {};
        for (const [k, v] of Object.entries(bonuses || {})) {
          const key = lookup[k.toLowerCase()] || k;
          result[key] = v;
        }
        return result;
      };
      const updates = {
        name: item.name || '',
        category: item.category || '',
        weight: item.weight ?? '',
        cost: item.cost ?? '',
      };
      if (item.statBonuses) {
        updates.statBonuses = normalizeBonuses(item.statBonuses, STAT_LOOKUP);
      }
      if (item.skillBonuses) {
        updates.skillBonuses = normalizeBonuses(item.skillBonuses, SKILL_LOOKUP);
      }
      updateForm4(updates);
    } catch (err) {
      setStatus({ type: 'danger', message: err.message || 'Failed to generate item' });
    } finally {
      setItemLoading(false);
    }
  }

  async function onSubmit4(e) {
    e.preventDefault();
    sendToDb4();
  }

  async function sendToDb4() {
    const weightNumber = form4.weight === "" ? undefined : Number(form4.weight);
    const normalizeBonuses = (obj) => {
      const entries = Object.entries(obj || {}).filter(([, v]) => v !== '' && v !== undefined);
      if (!entries.length) return undefined;
      return Object.fromEntries(entries.map(([k, v]) => [k, Number(v)]));
    };
    const statBonuses = normalizeBonuses(form4.statBonuses);
    const skillBonuses = normalizeBonuses(form4.skillBonuses);
    const newItem = {
      campaign: currentCampaign,
      name: form4.name,
      category: form4.category,
      weight: weightNumber,
      cost: form4.cost,
      ...(form4.notes && { notes: form4.notes }),
      ...(statBonuses && { statBonuses }),
      ...(skillBonuses && { skillBonuses }),
    };
    try {
      const response = await apiFetch('/equipment/items', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newItem),
      });
      if (!response.ok) {
        let message;
        try {
          const errorData = await response.json();
          message = errorData?.message || errorData?.error || response.statusText;
        } catch {
          message = response.statusText;
        }
        setStatus({ type: 'danger', message });
        return;
      }
      setForm4({
        campaign: currentCampaign,
        name: "",
        category: "",
        weight: "",
        cost: "",
        notes: "",
        statBonuses: {},
        skillBonuses: {},
      });
      setIsCreatingItem(false);
      fetchItems();
    } catch (error) {
      setStatus({ type: 'danger', message: error.toString() });
    }
  }

  async function deleteItem(id) {
    try {
      const response = await apiFetch(`/equipment/items/${id}`, { method: 'DELETE' });
      if (!response.ok) {
        const message = `An error has occurred: ${response.statusText}`;
        setStatus({ type: 'danger', message });
        return;
      }
      setItems((prev) => prev.filter((i) => i._id !== id));
    } catch (error) {
      setStatus({ type: 'danger', message: error.toString() });
    }
  }

  //------------------------------------Accessories------------------------------------------------------------
  const [isCreatingAccessory, setIsCreatingAccessory] = useState(false);

  const [accessories, setAccessories] = useState([]);
  const [accessoryOptions, setAccessoryOptions] = useState({
    categories: [],
    slots: [],
  });

  const [accessoryForm, setAccessoryForm] = useState({
    campaign: currentCampaign,
    name: '',
    category: '',
    targetSlots: [],
    rarity: '',
    weight: null,
    cost: '',
    notes: '',
    statBonuses: {},
    skillBonuses: {},
  });

  const [accessoryPrompt, setAccessoryPrompt] = useState('');
  const [accessoryLoading, setAccessoryLoading] = useState(false);

  const handleCloseResourceTab = useCallback(
    (key) => {
      switch (key) {
        case 'enemies':
          setCombatTargeting(INACTIVE_COMBAT_TARGETING);
          break;
        case 'weapons':
          setIsCreatingWeapon(false);
          break;
        case 'armor':
          setIsCreatingArmor(false);
          break;
        case 'items':
          setIsCreatingItem(false);
          break;
        case 'accessories':
          setIsCreatingAccessory(false);
          break;
        case 'players':
          setPlayersSearch('');
          break;
        case 'map':
          setGeneratedMap(null);
          setMapPrompt('');
          break;
        default:
          break;
      }
      setActiveResourceTab((current) => (current === key ? null : current));
    },
    [setActiveResourceTab, setPlayersSearch, setGeneratedMap, setMapPrompt, setCombatTargeting]
  );

  const updateAccessoryForm = (value) => {
    setAccessoryForm((prev) => ({ ...prev, ...value }));
  };

  const toggleAccessorySlot = (slotKey) => {
    setAccessoryForm((prev) => {
      const currentSlots = new Set(prev.targetSlots || []);
      if (currentSlots.has(slotKey)) {
        currentSlots.delete(slotKey);
      } else {
        currentSlots.add(slotKey);
      }
      return { ...prev, targetSlots: Array.from(currentSlots) };
    });
  };

  const fetchAccessories = useCallback(async () => {
    const response = await apiFetch(`/equipment/accessories/${currentCampaign}`);
    if (!response.ok) {
      const message = `An error has occurred: ${response.statusText}`;
      setStatus({ type: 'danger', message });
      return;
    }
    const data = await response.json();
    setAccessories(data);
  }, [currentCampaign]);

  const fetchAccessoryOptions = useCallback(async () => {
    const response = await apiFetch('/accessories/options');
    if (!response.ok) {
      const message = `An error has occurred: ${response.statusText}`;
      setStatus({ type: 'danger', message });
      return;
    }
    const data = await response.json();
    setAccessoryOptions({
      categories: data?.categories || [],
      slots: data?.slots || [],
    });
  }, []);

  const accessorySlotLabels = useMemo(() => {
    const labels = {};
    (accessoryOptions.slots || []).forEach((slot) => {
      if (!slot || !slot.key) {
        return;
      }
      labels[slot.key] = slot.label || slot.key;
    });
    return labels;
  }, [accessoryOptions.slots]);

  useEffect(() => {
    if (activeResourceTab === 'accessories') {
      fetchAccessories();
      fetchAccessoryOptions();
    }
  }, [activeResourceTab, fetchAccessories, fetchAccessoryOptions]);

  async function generateAccessory() {
    setAccessoryLoading(true);
    try {
      if (!accessoryOptions.categories.length || !accessoryOptions.slots.length) {
        setStatus({ type: 'danger', message: 'Accessory options not loaded' });
        return;
      }
      const response = await apiFetch('/ai/accessory', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: accessoryPrompt }),
      });
      if (!response.ok) {
        let message;
        try {
          const errorData = await response.json();
          message = errorData?.message || response.statusText;
        } catch {
          message = response.statusText;
        }
        setStatus({ type: 'danger', message });
        return;
      }
      const accessory = await response.json();
      const normalizeBonuses = (bonuses, lookup) => {
        const result = {};
        for (const [k, v] of Object.entries(bonuses || {})) {
          const key = lookup[k.toLowerCase()] || k;
          result[key] = v;
        }
        return result;
      };
      const updates = {
        name: accessory.name || '',
        category: accessory.category || '',
        targetSlots: Array.isArray(accessory.targetSlots) ? accessory.targetSlots : [],
        rarity: accessory.rarity || '',
        weight: accessory.weight ?? null,
        cost: accessory.cost ?? '',
        notes: accessory.notes || '',
      };
      if (accessory.statBonuses) {
        updates.statBonuses = normalizeBonuses(accessory.statBonuses, STAT_LOOKUP);
      }
      if (accessory.skillBonuses) {
        updates.skillBonuses = normalizeBonuses(accessory.skillBonuses, SKILL_LOOKUP);
      }
      updateAccessoryForm(updates);
    } catch (err) {
      setStatus({ type: 'danger', message: err.message || 'Failed to generate accessory' });
    } finally {
      setAccessoryLoading(false);
    }
  }

  const normalizeAccessoryBonuses = (obj) => {
    const entries = Object.entries(obj || {}).filter(([, v]) => v !== '' && v !== undefined);
    if (!entries.length) return undefined;
    return Object.fromEntries(entries.map(([k, v]) => [k, Number(v)]));
  };

  async function sendAccessoryToDb() {
    if (!accessoryForm.targetSlots || accessoryForm.targetSlots.length === 0) {
      setStatus({ type: 'danger', message: 'Select at least one target slot' });
      return;
    }
    const weightNumber =
      accessoryForm.weight === '' || accessoryForm.weight === null
        ? undefined
        : Number(accessoryForm.weight);
    if (weightNumber !== undefined && Number.isNaN(weightNumber)) {
      setStatus({ type: 'danger', message: 'Weight must be a number' });
      return;
    }
    const statBonuses = normalizeAccessoryBonuses(accessoryForm.statBonuses);
    const skillBonuses = normalizeAccessoryBonuses(accessoryForm.skillBonuses);
    const newAccessory = {
      campaign: currentCampaign,
      name: accessoryForm.name,
      category: accessoryForm.category,
      targetSlots: accessoryForm.targetSlots,
      ...(accessoryForm.rarity && { rarity: accessoryForm.rarity }),
      ...(weightNumber !== undefined ? { weight: weightNumber } : {}),
      ...(accessoryForm.cost && { cost: accessoryForm.cost }),
      ...(accessoryForm.notes && { notes: accessoryForm.notes }),
      ...(statBonuses && { statBonuses }),
      ...(skillBonuses && { skillBonuses }),
    };

    try {
      const response = await apiFetch('/equipment/accessories', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newAccessory),
      });
      if (!response.ok) {
        let message;
        try {
          const errorData = await response.json();
          message = errorData?.message || errorData?.error || response.statusText;
        } catch {
          message = response.statusText;
        }
        setStatus({ type: 'danger', message });
        return;
      }
      await fetchAccessories();
      setAccessoryForm({
        campaign: currentCampaign,
        name: '',
        category: '',
        targetSlots: [],
        rarity: '',
        weight: null,
        cost: '',
        notes: '',
        statBonuses: {},
        skillBonuses: {},
      });
      setAccessoryPrompt('');
      setIsCreatingAccessory(false);
    } catch (error) {
      setStatus({ type: 'danger', message: error.toString() });
    }
  }

  async function onSubmitAccessory(e) {
    e.preventDefault();
    await sendAccessoryToDb();
  }

  async function deleteAccessory(id) {
    try {
      const response = await apiFetch(`/equipment/accessories/${id}`, { method: 'DELETE' });
      if (!response.ok) {
        const message = `An error has occurred: ${response.statusText}`;
        setStatus({ type: 'danger', message });
        return;
      }
      setAccessories((prev) => prev.filter((acc) => acc._id !== id));
    } catch (error) {
      setStatus({ type: 'danger', message: error.toString() });
    }
  }

  const getAccessorySlotLabel = useCallback(
    (slots) => {
      if (!Array.isArray(slots) || slots.length === 0) {
        return '—';
      }
      return slots
        .map((slot) => accessorySlotLabels[slot] || slot)
        .join(', ');
    },
    [accessorySlotLabels]
  );

const renderBonuses = (bonuses, labels) =>
  Object.entries(bonuses || {})
    .map(([k, v]) => `${labels[k] || k}: ${v}`)
    .join(', ');

const weaponCategoryIcons = {
  'simple melee': GiStoneAxe,
  'simple ranged': GiBowArrow,
  'martial melee': GiBroadsword,
  'martial ranged': GiCrossbow,
};

const armorCategoryIcons = {
  light: GiLeatherArmor,
  medium: GiBreastplate,
  heavy: GiChainMail,
  shield: GiShield,
};

const itemCategoryIcons = {
  'adventuring gear': GiBackpack,
  ammunition: GiAmmoBox,
  consumable: GiPotionBall,
  tool: GiHammerNails,
  mount: GiHorseHead,
  'tack and harness': GiSaddle,
  vehicle: GiChariot,
  'water vehicle': GiSailboat,
  custom: GiTreasureMap,
};

const accessoryCategoryIcons = {
  belt: GiBackpack,
  cloak: GiBackpack,
  ring: GiTreasureMap,
  amulet: GiTreasureMap,
  necklace: GiTreasureMap,
  trinket: GiTreasureMap,
};

const resolveIcon = (category, iconMap, fallback) => {
  const normalized = String(category || '').toLowerCase();
  if (iconMap[normalized]) {
    return iconMap[normalized];
  }
  const matchKey = Object.keys(iconMap).find((key) => normalized.includes(key));
  return matchKey ? iconMap[matchKey] : fallback;
};


// -----------------------------------Display-----------------------------------------------------------------------------
  return (
    <CombatantNamesProvider enemies={enemies} dm>
    <div
      className="zombies-dm-page text-center"
      style={{
        fontFamily: 'Raleway, sans-serif',
        backgroundImage: `url(${loginbg})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
      }}
    >
      <OpportunityAttackPrompt campaignId={campaignId} combatState={combatState} controlledIds={enemies.map(e=>String(e.enemyId||e._id))}
        onCombatChange={state=>{combatStateRef.current=normalizeCombatState(state);setCombatState(combatStateRef.current);}}
        attackOptions={id=>(enemies.find(e=>String(e.enemyId||e._id)===id)?.actions||[]).filter(a=>Number.isFinite(a.attack_bonus)&&/melee/i.test(a.desc||'')).map((a,i)=>({...a,id:String(i)}))}
        onAttack={async(opportunity,action)=>{
          const attacker=characterLookup.get(opportunity.sourceCombatantId);
          if(!attacker)throw new Error('Attacker no longer exists.');
          await handleEnemyTargetClick(opportunity.targetCombatantId,{status:'selecting-target',attacker,sourceCombatantId:opportunity.sourceCombatantId,attackId:action.id,action,actions:[action],opportunityId:opportunity.opportunityId});
        }}/>
      <EnemyMultiattackControls ref={enemyMultiattackRef} campaignId={campaignId} combatState={combatState} enemies={enemies}
        onBeginTargeting={request=>setCombatTargeting(request)} onCancelTargeting={()=>setCombatTargeting(INACTIVE_COMBAT_TARGETING)}
        onLedgerChange={ledger=>{const state=combatStateRef.current;if(ledger?.turnSequence!==state.turnSequence)return;const next=normalizeCombatState({...state,turnActionLedger:ledger});combatStateRef.current=next;setCombatState(next);}}
        onStartSpell={request=>enemySpellsRef.current.startMultiattackSpell(request)} onCancelSpell={()=>enemySpellsRef.current?.cancelMultiattackSpell()} />
      <EnemySpellcastingControls ref={enemySpellsRef} campaignId={campaignId} combatState={combatState}
        onMultiattackSpellEvent={event=>enemyMultiattackRef.current?.spellEvent(event)} isMultiattackActive={()=>enemyMultiattackRef.current?.isActive()}
        spatialContext={{map:displayedMap,tokens:Object.fromEntries(boardTokens.map(token=>[token.characterId,token]))}}
        externalDiceSurface={showEnemyDiceOverlay} externalDiceResults={displayEnemyDiceResults} resolveDefenderReaction={resolveEnemyDefenderReaction} resolveCastWindow={resolveEnemyCastWindow} resolveFateWindow={resolveEnemyFateWindow} resolveCuttingWords={resolveEnemyCuttingWords}
        onBeginTargeting={request=>setCombatTargeting({...request,status:'selecting-target'})} onCancelTargeting={()=>setCombatTargeting(INACTIVE_COMBAT_TARGETING)}
        onCombatChange={state=>{combatStateRef.current=normalizeCombatState(state);setCombatState(combatStateRef.current);}}
        onLedgerChange={ledger=>{const current=combatStateRef.current;if(ledger?.turnSequence!==current.turnSequence)return;const next=normalizeCombatState({...current,turnActionLedger:ledger});combatStateRef.current=next;setCombatState(next);}}
        onMapReconciled={applyMapPayload} onDamageSummaryChange={handleEnemySpellSummary}
        onAttackResolved={result=>notify(`${result.attackName}: ${result.outcome}${result.damageApplied ? ` · ${result.damageApplied} damage` : ''}`,'info')}
        onDamageResolved={async damageEvent=>{
          const target=characterLookupRef.current.get(damageEvent.targetCombatantId),source=characterLookupRef.current.get(damageEvent.sourceCombatantId),current=combatStateRef.current;
          const next=processRetaliationDamageEvent({combatState:current,character:target,damageEvent,sourceCombatant:source,targetCombatant:target,mapState:{tokens:activeMapTokens}});
          if(next!==current)await persistCombatState(next);
        }}
        onApplyDamage={async ({targetId,damageApplied,result,multiattack})=>{
          if(multiattack)return (await multiattackRequest(campaignId,multiattack,'damage',{targetId,damageApplied,damageBeforeTraits:result.damageBeforeTraits,damageType:result.damageType,...(result.damageByType?{damageByType:result.damageByType}:{}),eventId:result.resolutionId})).hp;
          const target=characterLookupRef.current.get(targetId),enemy=target?.entityType==='enemy';
          const response=await apiFetch(enemy ? `/campaigns/${encodedCampaign}/enemies/${encodeURIComponent(targetId)}/health` : `/characters/update-temphealth/${encodeURIComponent(targetId)}`,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify({delta:-damageApplied,damageBeforeTraits:result.damageBeforeTraits,damageType:result.damageType,damageByType:result.damageByType,eventId:result.resolutionId,sourceCombatantId:result.attackerId,rolledDamage:result.damage})});
          const record=await response.json();if(!response.ok)throw new Error(record.message || 'Damage could not be saved.');
          if(record.enemy)setEnemies(previous=>previous.map(item=>item.enemyId===targetId ? {...item,...record.enemy} : item));
          else setRecords(previous=>previous.map(item=>getEntityId(item)===targetId ? {...item,tempHealth:record.currentHp} : item));
          return {previousHp:record.previousHp,currentHp:record.currentHp,appliedDamage:record.actualHpLost,resistanceReduction:record.resistanceReduction};
        }}/>
      <WebSpellControls combatState={combatState} campaignId={campaignId} view="dm" onCombatChange={setCombatState} beforeRoll={showEnemyDiceOverlay} onRollResult={displayEnemyDiceResults} />
      <BaneSaveControls campaignId={campaignId} combatState={combatState} onCombatChange={setCombatState} beforeRoll={showEnemyDiceOverlay} onRollResult={displayEnemyDiceResults} />
      <CommandTurnReminder campaignId={campaignId} combatState={combatState} nameFor={id => combatantLabel(characterLookupRef.current.get(id), { dm: true, fallback: 'This creature' })} />
      <ConcentrationSaveControls campaignId={campaignId} onCombatChange={setCombatState} beforeRoll={showEnemyDiceOverlay} onRollResult={displayEnemyDiceResults} />
      <div className="zombies-dm-page__map-surface" role="presentation">
        {displayedMap ? (
          <CampaignMapBoard fogView="dm" campaignId={campaignId} combatState={combatState} onCombatChange={setCombatState} onMapReconciled={applyMapPayload}
            persistentEffects={combatState.activeEffects}
            className="zombies-dm-page__map-board"
            map={displayedMap}
            tokens={boardTokens}
            disabled={!shouldShowCampaignTokens || mapPlacementSaving}
            allowWheelZoom
            targeting={combatTargeting.status !== 'inactive'}
            rangePreview={enemyTargetingPreview}
            repositionToken={
              mapPlacementState.show
                ? placementToken
                : null
            }
            areaTargeting={combatTargeting.enemySpell && combatTargeting.status === 'selecting-target' && combatTargeting.selectionMode === 'area' ? combatTargeting : null}
            onAreaSelected={selection=>Promise.resolve(enemySpellsRef.current?.chooseArea({...selection,actionType:combatTargeting.actionType})).catch(error=>setStatus({type:'danger',message:error.message}))}
            onTokenClick={targetId=>void handleEnemyTargetClick(targetId)}
            onTokenPositionChange={
              shouldShowCampaignTokens && !mapPlacementSaving
                ? handleTokenPositionChange
                : undefined
            }
            onTokenRemove={handleMapTokenRemove}
            onToggleCombat={handleMapToggleCombat}
            placementControls={shouldShowCampaignTokens ? <UnplacedUnits units={unplacedUnits} selectedId={mapPlacementState.enemyId} onSelect={handleOpenMapPlacement} onCancel={handleCloseMapPlacement} saving={mapPlacementSaving} error={mapPlacementError}/> : null}
            onBackgroundClick={
              mapPlacementState.show && shouldShowCampaignTokens && !mapPlacementSaving
                ? handleMapBackgroundPlacement
                : undefined
            }
          />
        ) : (
          <div className="zombies-dm-page__map-empty text-light">
            No map selected.
          </div>
        )}
      </div>
      {combatTargeting.status !== 'inactive' && (
        <div className="combat-targeting-instruction" role="status" aria-live="polite">
          <strong>{pendingFateWindow ? `Waiting for ${pendingFateWindow.cuttingWords ? 'Cutting Words' : 'Improve Fate'}…` : pendingDefenderReaction
            ? `Waiting for ${pendingDefenderReaction.targetName}'s reaction…`
            : combatTargeting.status === 'resolving'
            ? `Rolling ${combatTargeting.actionType === 'save-damage' ? 'save action damage' : combatTargeting.isMultiattack ? 'Multiattack' : 'attack'}…`
            : combatTargeting.enemySpell ? `${combatTargeting.label || 'Spell'} — ${combatTargeting.selectionMode === 'area' ? 'Select an area' : 'Select a recipient'}`
            : combatTargeting.actionType === 'save-damage' ? `${combatTargeting.definition.displayName} — Select one affected creature` : `Select a target${combatTargeting.isMultiattack ? ' for Multiattack' : ''}`}</strong>
          <span>{pendingFateWindow ? (pendingFateWindow.cuttingWords ? 'A College of Lore Bard can subtract their die from this roll.' : 'A character with Boon of Fate can subtract 2d4 from this attack roll before damage.') : pendingDefenderReaction
            ? 'Damage will be applied after the defender uses or skips their Reaction.'
            : combatTargeting.status === 'resolving' ? 'Preparing the saving throw and damage.'
            : combatTargeting.enemySpell ? `${combatTargeting.prompt || 'Choose a spell target on the map.'} Esc to cancel.`
            : combatTargeting.actionType === 'save-damage' ? `${combatTargeting.definition.areaLabel}. Esc to cancel.` : 'Click a living combatant to attack. Esc to cancel.'}</span>
          {pendingFateWindow && (
            <Button type="button" variant="outline-light" size="sm" onClick={skipPendingFateWindow}>
              Continue / Skip {pendingFateWindow.cuttingWords ? 'Cutting Words' : 'Improve Fate'}
            </Button>
          )}
          {pendingDefenderReaction && (
            <Button type="button" variant="outline-light" size="sm" onClick={skipPendingDefenderReaction}>
              Continue / Skip defender Reaction
            </Button>
          )}
          {combatTargeting.status === 'selecting-target' && (
            <Button
              type="button"
              variant="outline-light"
              size="sm"
              onClick={() => { if (combatTargeting.enemySpell) enemySpellsRef.current?.cancel(); setCombatTargeting(INACTIVE_COMBAT_TARGETING); }}
            >
              Cancel
            </Button>
          )}
        </div>
      )}
      {combatTargeting.status === 'inactive' && enemySaveDamage?.status === 'waiting-save' && (
        <div className="combat-targeting-instruction" role="status">
          Waiting for {combatantLabel(characterLookup.get(enemySaveDamage.targetCombatantId), { dm: true, fallback: enemySaveDamage.targetCombatantId })}'s Dexterity save…
        </div>
      )}
      {combatTargeting.status === 'inactive' && enemySaveDamage?.status === 'complete' && Number.isFinite(enemySaveDamage.result?.damageOutcome?.finalDamage) && (
        <div className="combat-targeting-instruction" role="status">{enemySaveDamage.result.damageOutcome.finalDamage} Acid</div>
      )}
      <TacticalMindControls dm campaignId={campaignId} combatState={combatState}/>
      <FastHandsControls dm campaignId={campaignId} combatState={combatState} onCombatChange={state => setCombatState(normalizeCombatState(state))} />
      <OpenHandSavePrompt combat={combatState} campaignId={campaignId}
        controlledIds={enemies.map(enemy=>enemy.enemyId||enemy._id)} onMapReconciled={applyMapPayload}
        onCombatChange={state=>{combatStateRef.current=normalizeCombatState(state);setCombatState(combatStateRef.current);}}
        beforeRoll={async()=>{await showEnemyDiceOverlay();setDiceBoxThemeColor(DEFAULT_DICE_COLOR);}}
        onRollResult={value=>displayEnemyDiceResults([{sides:20,value,type:'Saving Throw'}])}/>
      <CunningStrikeSavePrompt stunningStrike combat={combatState} campaignId={campaignId}
        controlledIds={enemies.map(enemy => enemy.enemyId || enemy._id)}
        onCombatChange={state => { combatStateRef.current = normalizeCombatState(state); setCombatState(combatStateRef.current); }}
        beforeRoll={async () => { await showEnemyDiceOverlay(); setDiceBoxThemeColor(DEFAULT_DICE_COLOR); }}
        onRollResult={value => displayEnemyDiceResults([{ sides: 20, value, type: 'Saving Throw' }])} />
      <CunningStrikeSavePrompt combat={combatState} campaignId={campaignId}
        controlledIds={enemies.map(enemy => enemy.enemyId || enemy._id)}
        onCombatChange={state => { combatStateRef.current = normalizeCombatState(state); setCombatState(combatStateRef.current); }}
        beforeRoll={async () => { await showEnemyDiceOverlay(); setDiceBoxThemeColor(DEFAULT_DICE_COLOR); }}
        onRollResult={value => displayEnemyDiceResults([{ sides: 20, value, type: 'Saving Throw' }])} />
      {pendingCastWindow && (
        <div className="combat-targeting-instruction" role="status" aria-live="polite">
          <strong>Waiting for a Reaction…</strong>
          <span>{pendingCastWindow.kind === 'counterspell' ? `A character can try to Counterspell ${pendingCastWindow.spellName}.` : 'A targeted character can cast Shield against Magic Missile.'}</span>
          <Button type="button" variant="outline-light" size="sm" onClick={skipPendingCastWindow}>Continue / Skip Reaction</Button>
        </div>
      )}
      {pendingFateWindow && combatTargeting.status === 'inactive' && (
        <div className="combat-targeting-instruction" role="status" aria-live="polite">
          <strong>Waiting for {pendingFateWindow.cuttingWords ? 'Cutting Words' : 'Improve Fate'}…</strong>
          <span>{pendingFateWindow.cuttingWords ? 'A College of Lore Bard can subtract their die from this roll.' : <>A character with Boon of Fate can subtract 2d4 from {pendingFateWindow.saverName ? `${pendingFateWindow.saverName}'s saving throw` : 'this roll'}.</>}</span>
          <Button type="button" variant="outline-light" size="sm" onClick={skipPendingFateWindow}>Continue / Skip {pendingFateWindow.cuttingWords ? 'Cutting Words' : 'Improve Fate'}</Button>
        </div>
      )}
      <CombatSavePrompt opportunity={resolvingEnemyTargetSave ? null : pendingEnemyTargetSave}
        onRoll={() => answerEnemyTargetSave('roll')} onPass={() => answerEnemyTargetSave('pass')}
        resolving={resolvingEnemyTargetSave} error={enemyTargetSaveError} />
      <div className="zombies-dm-page__chrome">
        {status && activeResourceTab !== 'map' && (
          <Alert
            variant={status.type}
            dismissible
            onClose={() => setStatus(null)}
            className="zombies-dm-page__status-alert"
          >
            {status.message}
          </Alert>
        )}

        {mapPlacementState.show && (
          <div
            className="zombies-dm-page__map-placement-overlay"
            data-testid="map-placement-overlay"
          >
            <div
              className="zombies-dm-page__map-placement-message"
              aria-live="polite"
            >
              {mapPlacementSaving ? (
                <>
                  <Spinner
                    animation="border"
                    role="status"
                    size="sm"
                    className="me-2"
                  >
                    <span className="visually-hidden">Saving figurine position…</span>
                  </Spinner>
                  <span>Saving figurine position…</span>
                </>
              ) : (
                <span>{mapPlacementInstruction}</span>
              )}
            </div>
            {mapPlacementError && (
              <div
                className="zombies-dm-page__map-placement-error"
                role="alert"
              >
                {mapPlacementError}
              </div>
            )}
            <div className="zombies-dm-page__map-placement-actions">
              <Button
                variant="outline-light"
                size="sm"
                onClick={handleCloseMapPlacement}
                disabled={mapPlacementSaving}
              >
                Cancel
              </Button>
            </div>
          </div>
        )}

        <div className="zombies-dm-page__combat-header">
          <CombatTurnHeader
            participants={combatHeaderParticipants}
            tokenLookup={tokenMetaById}
          />
        </div>


        {enemyDiceOverlayActive && (
          <div className="zombies-dm-roll-dice-overlay" aria-hidden="true">
            <div className="damage-roller__dice-wrapper zombies-dm-roll-dice-overlay__wrapper">
              <div className="damage-roller__dice-area zombies-dm-roll-dice-overlay__area">
                <DamageDiceCanvas
                  dice={enemyRollDice}
                  diceColor={DEFAULT_DICE_COLOR}
                  instanceKey="zombies-dm-enemy-rolls"
                  showOverlayDice={false}
                  diceAreaSize={520}
                />
              </div>
            </div>
          </div>
        )}

        {(enemyRollPopup || spellFeedback) && (
          <div className="combat-hud-damage-popup" role="status" aria-live="polite">
            <button
              type="button"
              className="combat-hud-damage-popup__close"
              onClick={() => { dismissSpellFeedback(); setEnemyRollPopup(null); }}
              aria-label="Close enemy roll popup"
            >
              ×
            </button>
            <span className="combat-hud-damage-popup__label">{spellFeedback?.label || enemyRollPopup?.label || 'Damage'}</span>
            <strong className="combat-hud-damage-popup__value">{spellFeedback?.value ?? enemyRollPopup?.value}</strong>
            <SpellSaveResults feedback={spellFeedback} targetName={id => combatantLabel(enemies.find(enemy => String(enemy.enemyId || enemy._id) === String(id)), { dm: true, fallback: records.find(character => String(character._id || character.characterId) === String(id))?.characterName || id })} />
            {spellFeedback && <button className="combat-hud-damage-popup__log" onClick={() => setShowSpellDamageLog(true)}>Log</button>}
          </div>
        )}

        <Modal centered show={showSpellDamageLog} onHide={() => setShowSpellDamageLog(false)}>
          <Modal.Header closeButton><Modal.Title>Spell damage log</Modal.Title></Modal.Header>
          <Modal.Body>{spellDamageLog.map(entry => <div key={entry.id}>{entry.label} — {combatantLabel(enemies.find(enemy => String(enemy.enemyId || enemy._id) === String(entry.targetCombatantId)), { dm: true, fallback: entry.targetCombatantId })}: save {entry.success ? 'succeeded' : 'failed'}, {entry.finalDamage} {entry.damageType} damage</div>)}</Modal.Body>
        </Modal>

        <ActiveEnemyQuickList
          summaries={activeMapEnemySummaries.map((summary) => ({
            ...summary,
            speedDisplay: formatMovementSpeed(getEffectiveMovement(summary.enemy.speed, combatState, summary.enemy.enemyId || summary.enemy._id)),
          }))}
          activeMapTitle={activeMapTitle}
          onManageEnemies={handleShowEnemiesTab}
          onRollInitiative={handleRollInitiative}
          onAdvanceTurn={handleAdvanceTurn}
          combatControlsDisabled={combatParticipantCount === 0}
          onToggleParticipant={handleToggleParticipant}
          onOpenMapPlacement={handleOpenMapPlacement}
          onChangeDisposition={handleChangeDisposition}
          onViewDetails={handleShowEnemiesTab}
          enemyHealthAdjustments={enemyHealthAdjustments}
          enemyHealthSaving={enemyHealthSaving}
          onEnemyAdjustmentInputChange={handleEnemyAdjustmentInputChange}
          onApplyEnemyHealthAdjustment={handleApplyEnemyHealthAdjustment}
          onResetEnemyHealth={handleResetEnemyHealth}
          onEnemyDamageRoll={handleEnemyDamageRoll}
          onEnemyAttackRoll={beginEnemyTargeting}
          onEnemyMultiattackRoll={handleEnemyMultiattackRoll}
          onEnemySaveAction={beginEnemySaveTargeting}
          formatAttackBonus={formatAttackBonus}
          getEnemyActionDamageString={getEnemyActionDamageString}
          latestEnemyRoll={latestEnemyRoll}
          onEnemySpells={enemy=>enemySpellsRef.current?.open(enemy.enemyId || enemy._id)}
          renderConditionControls={(enemy) => (
            <BuffStatusControls campaignId={campaignId} characterId={String(enemy.enemyId || enemy._id)} combatState={combatState} inline onCombatChange={setCombatState} />
          )}
          getConditionsForEnemy={(enemyId) => getActiveConditionsForCombatant(enemyId, combatState, (sourceId) => {
            const source = characterLookup.get(sourceId);
            return combatantLabel(source, { dm: true, fallback: sourceId });
          })}
          getProneActionForEnemy={(enemy) => {
            const combatantId = enemy.enemyId || enemy._id;
            if (!isProne(combatState, combatantId)) return null;
            const baseSpeed = getEntityMovementSpeed(enemy);
            const speed = baseSpeed === null ? null : getEffectiveSpeed(baseSpeed, combatState, combatantId);
            const active = combatState.participants?.[combatState.activeTurn];
            const isCurrentTurn = String(active?.characterId || active?.enemyId || '') === String(combatantId);
            return {
              speed,
              cost: getStandUpCost(speed),
              disabled: !isCurrentTurn || speed === null || speed === 0,
              pending: standUpPendingId === combatantId,
              onStandUp: () => handleEnemyStandUp(enemy),
            };
          }}
        />
      </div>

      <div
        className="zombies-dm-bottom-bar"
        role="toolbar"
        aria-label="Dungeon Master resources"
      >
        <Dropdown drop="up">
          <Dropdown.Toggle id="dm-tools-menu" variant="outline-light" className="zombies-dm-bottom-bar__button">
            <FaTools className="zombies-dm-bottom-bar__icon" aria-hidden="true" />
            <span>Tools</span>
          </Dropdown.Toggle>
          <Dropdown.Menu variant="dark" renderOnMount style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <UnarmedOptionsControls dm campaignId={campaignId} units={combinedRecords.map(u=>({id:getEntityId(u),name:combatantLabel(u,{dm:true})})).filter(u=>u.id)} controlledIds={enemies.map(e=>e.enemyId||e._id)} combatState={combatState} onCombatChange={state=>setCombatState(normalizeCombatState(state))} onMapReconciled={applyMapPayload} beforeRoll={async()=>{await showEnemyDiceOverlay();setDiceBoxThemeColor(DEFAULT_DICE_COLOR);}} renderTrigger={open => <Dropdown.Item onClick={open}>Unarmed</Dropdown.Item>}/>
        <FallingDamageControls dm={campaignDM.dm===user?.username} campaignId={campaignId} combatState={combatState} onCombatChange={state=>setCombatState(normalizeCombatState(state))} units={combinedRecords.map(unit=>({id:getEntityId(unit),name:combatantLabel(unit,{dm:true})})).filter(unit=>unit.id)} renderTrigger={open => <Dropdown.Item onClick={open}>Falling Damage</Dropdown.Item>}/>
      <BuffStatusControls campaignId={campaignId} combatState={combatState} dm onCombatChange={setCombatState} resolveCombatantName={id => { const target = characterLookup.get(id); return combatantLabel(target, { dm: true, fallback: target?.label }); }} renderTrigger={open => <Dropdown.Item onClick={open}>Spell Time</Dropdown.Item>} />
        <DmConditionsTool campaignId={campaignId} combatState={combatState} participants={conditionCreatures} onUpdated={state => setCombatState(normalizeCombatState(state))} renderTrigger={open => <Dropdown.Item onClick={open}>Conditions</Dropdown.Item>} />
        <WardSavePrompt />
        <ActionSavePrompt campaignId={campaignId} combatantId={combatState?.participants?.[combatState?.activeTurn]?.enemyId} name={combatState?.participants?.[combatState?.activeTurn]?.name} combatState={combatState} onCombatStateReconciled={state => setCombatState(normalizeCombatState(state))} />
        <DmSpellWallsTool campaignId={campaignId} combatState={combatState} onUpdated={state => setCombatState(normalizeCombatState(state))} renderTrigger={open => <Dropdown.Item onClick={open}>Spell Walls</Dropdown.Item>} />
        <DmPartiesTool campaignId={campaignId} characters={partyCharacters} renderTrigger={open => <Dropdown.Item onClick={open}>Parties</Dropdown.Item>} />
        <HeroicInspirationControls campaignId={campaignId} renderTrigger={open => <Dropdown.Item onClick={open}>Heroic Inspiration</Dropdown.Item>} />
        <RollRequestControls campaignId={campaignId} onResult={addDmRollLog} renderTrigger={open => <Dropdown.Item onClick={open}>Request a roll</Dropdown.Item>} />
          </Dropdown.Menu>
        </Dropdown>
        <ExperienceAwards campaignId={campaignId}/>
        <DmRollLog entries={dmRollLogEntries} />
        <DmNotes campaignId={campaignId} />
        {RESOURCE_TABS.map(({ key, title, icon: DockIcon }) => {
          if (key === 'equipment') {
            const equipmentActive = EQUIPMENT_TABS.some((tab) => tab.key === activeResourceTab);
            return (
              <Dropdown key={key} drop="up">
                <Dropdown.Toggle
                  id="dm-equipment-menu"
                  variant={equipmentActive ? 'primary' : 'outline-light'}
                  className="zombies-dm-bottom-bar__button"
                >
                  <GiBackpack className="zombies-dm-bottom-bar__icon" aria-hidden="true" />
                  <span>Equipment</span>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  variant="dark"
                  style={{ maxHeight: '70vh', overflowY: 'auto' }}
                >
                  {EQUIPMENT_TABS.map(({ key: equipmentKey, title: equipmentTitle, icon: EquipmentIcon }) => (
                    <Dropdown.Item
                      key={equipmentKey}
                      active={activeResourceTab === equipmentKey}
                      onClick={() => handleSelectResourceTab(equipmentKey)}
                    >
                      <EquipmentIcon className="me-2" aria-hidden="true" />
                      {equipmentTitle}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            );
          }
          const isActiveTab = activeResourceTab === key;
          const tabClassName = `zombies-dm-bottom-bar__button btn ${
            isActiveTab ? 'btn-primary' : 'btn-outline-light'
          }`;

          return (
            <button
              key={key}
              type="button"
              className={tabClassName}
              onClick={() => handleSelectResourceTab(key)}
              role="tab"
              aria-selected={isActiveTab}
              aria-pressed={isActiveTab}
            >
              {DockIcon && <DockIcon className="zombies-dm-bottom-bar__icon" aria-hidden="true" />}
              <span>{title}</span>
            </button>
          );
        })}
      </div>

      <LootModal key={`loot:${campaignId}`} campaignId={campaignId} isDm show={activeResourceTab === 'loot'} onHide={() => handleCloseResourceTab('loot')} />
      <ObjectivesModal
        key={campaignId}
        show={activeResourceTab === 'objectives'}
        onHide={() => handleCloseResourceTab('objectives')}
        campaignId={campaignId}
        isDm
      />
          <Modal
        show={activeResourceTab === 'characters'}
        onHide={() => handleCloseResourceTab('characters')}
        size="xl"
        scrollable
        centered
        className="dnd-modal zombies-dm-resource-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Combat Tracker</Modal.Title>
        </Modal.Header>
        <Modal.Body>
      {activeResourceTab === 'characters' && (
        <div className="text-center">
          <Card className="modern-card" data-testid="resource-characters-card">
            
            <Card.Body
              className="resource-tab-safe-area"
              style={{ overflowY: 'auto', maxHeight: '70vh' }}
            >
              <Card className="mb-4 bg-dark bg-opacity-75 border border-secondary text-start">
                <Card.Header className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2 bg-transparent border-secondary text-light">
                  <h3 className="h5 mb-0">Combat Tracker</h3>
                  <div className="small">
                    <strong>Active Turn: {activeTurnDisplayName}</strong>{combatState.manualOrder && <span className="ms-2 badge bg-secondary">Manual order</span>}
                  </div>
                </Card.Header>
                <Card.Body className="bg-transparent text-light">
                  <div className="d-flex flex-wrap justify-content-end gap-2 mb-3">
                    <CampaignRestControls campaignId={campaignId} />
                    <Button
                      variant="outline-light"
                      size="sm"
                      onClick={handleRollInitiative}
                      disabled={initiativeRolling || combatParticipantCount === 0}
                    >
                      Roll Initiative
                    </Button>
                    <Button
                      variant="outline-light"
                      size="sm"
                      onClick={() => handleAdvanceTurn(-1)}
                      disabled={combatParticipantCount === 0}
                    >
                      Previous Turn
                    </Button>
                    <Button
                      variant="outline-light"
                      size="sm"
                      onClick={() => handleAdvanceTurn(1)}
                      disabled={combatParticipantCount === 0}
                    >
                      Next Turn
                    </Button>
                  </div>
                  <div className="visually-hidden" role="status" aria-live="polite">{combatOrderDrag.announcement}{combatOrderDrag.preview ? ` Drop at position ${combatOrderDrag.preview.index+1}.` : ''}</div>
                  {combatOrderDrag.saving && <div role="status" className="small mb-2">Saving initiative order…</div>}
                  <div className="table-responsive">
                    <table className="table table-dark table-striped table-hover align-middle mb-0">
                      <thead>
                        <tr>
                          <th scope="col">Character</th>
                          <th scope="col">Player</th>
                          <th scope="col" className="text-center">In Combat</th>
                          <th scope="col" className="text-center combat-tracker-movespeed">Movespeed</th>
                          <th scope="col" className="text-center">Passive Perception</th>
                          <th scope="col" className="text-center">Initiative</th>
                          <th scope="col" className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orderedCombatRecords.length > 0 ? (
                          orderedCombatRecords.map(
                            ({
                              character,
                              rowId,
                              participantInfo,
                              passivePerception,
                              movementSpeedDisplay,
                              initiativeValue,
                              recordIndex,
                            }) => {
                              const resolvedRowId = rowId || '';
                              const isParticipant = Boolean(participantInfo);
                              const displayInitiative =
                                initiativeValue !== undefined && initiativeValue !== null
                                  ? initiativeValue
                                  : '—';
                              const displayPassivePerception =
                                passivePerception !== undefined && passivePerception !== null
                                  ? passivePerception
                                  : '—';
                              const displayMovementSpeed = movementSpeedDisplay || '—';
                              const isActive =
                                isParticipant &&
                                Number.isInteger(combatState.activeTurn) &&
                                participantInfo.index === combatState.activeTurn;
                              const displayName = combatantLabel(character, { dm: true, fallback: '—' });
                              const playerName = character?.token || '—';
                              const checkboxLabel = displayName;

                              const sanitizeIdentifier = (value, fallbackIndex) =>
                                typeof value === 'string' && value.trim() !== ''
                                  ? value.trim().replace(/[^0-9A-Za-z_-]/g, '-')
                                  : `participant-${fallbackIndex}`;
                              const rowTestId = `combat-row-${sanitizeIdentifier(
                                resolvedRowId,
                                recordIndex
                              )}`;
                              const rowCurrentHp = toFiniteNumberOrNull(
                                character?.currentHp ??
                                  character?.hpCurrent ??
                                  character?.tempHealth ??
                                  character?.health ??
                                  participantInfo?.currentHp ??
                                  participantInfo?.hpCurrent ??
                                  participantInfo?.health
                              );
                              const rowMaxHp = toFiniteNumberOrNull(
                                character?.maxHp ??
                                  character?.hpMax ??
                                  character?.health ??
                                  participantInfo?.maxHp ??
                                  participantInfo?.hpMax ??
                                  participantInfo?.health
                              );
                              const rowTempHp = toFiniteNumberOrNull(
                                character?.tempHealth ?? participantInfo?.tempHealth
                              );

                              const rowDataAttributes = {
                                'data-testid': rowTestId,
                                ...(rowCurrentHp !== null
                                  ? { 'data-current-hp': rowCurrentHp }
                                  : {}),
                                ...(rowMaxHp !== null ? { 'data-max-hp': rowMaxHp } : {}),
                                ...(rowTempHp !== null ? { 'data-temp-hp': rowTempHp } : {}),
                              };

                              return (
                                <tr
                                  key={resolvedRowId || playerName}
                                  className={isActive ? 'table-success text-dark combat-tracker__active-row' : undefined}
                                  {...rowDataAttributes}
                                  {...(isParticipant ? combatOrderDrag.rowProps(resolvedRowId) : {})}
                                >
                                  <td className="fw-semibold">
                                    {isParticipant && <CombatOrderControls id={resolvedRowId} label={displayName} index={participantInfo.index} total={combatState.participants.length} drag={combatOrderDrag} />}
                                    {displayName}
                                    <div className="mt-1">
                                      <DeathStateBadge deathState={character?.deathState} />
                                    </div>
                                  </td>
                                  <td>{playerName}</td>
                                  <td className="text-center">
                                    <Form.Check
                                      type="checkbox"
                                      id={`combat-toggle-${resolvedRowId}`}
                                      checked={isParticipant}
                                      onChange={() =>
                                        resolvedRowId && handleToggleParticipant(resolvedRowId)
                                      }
                                      aria-label={`Toggle ${checkboxLabel} in combat`}
                                    />
                                  </td>
                                  <td className="text-center combat-tracker-movespeed">
                                    {displayMovementSpeed}
                                  </td>
                                  <td className="text-center" style={{ width: '150px' }}>
                                    {displayPassivePerception}
                                  </td>
                                  <td className="text-center" style={{ width: '110px' }}>
                                    {displayInitiative}
                                  </td>
                                  <td className="text-center">
                                    <div className="d-flex justify-content-center gap-2">
                                      <Button
                                        variant={isActive ? 'success' : 'outline-light'}
                                        size="sm"
                                        onClick={() =>
                                          resolvedRowId && handleSetTurn(resolvedRowId)
                                        }
                                        disabled={!isParticipant}
                                      >
                                        Set Turn
                                      </Button>

                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        ) : (
                          <tr>
                            <td colSpan={7} className="text-center text-muted py-3">
                              No characters available.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </Card.Body>
              </Card>

            </Card.Body>
          </Card>
        </div>
      )}
            </Modal.Body>
      </Modal>
          <Modal
        show={activeResourceTab === 'players'}
        onHide={() => handleCloseResourceTab('players')}
        size="xl"
        scrollable
        centered
        className="dnd-modal zombies-dm-resource-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Players</Modal.Title>
        </Modal.Header>
        <Modal.Body>
      {activeResourceTab === 'players' && (
        <div className="text-center">
          <Card className="modern-card" data-testid="resource-players-card">
            
            <Card.Body
              className="resource-tab-safe-area"
              style={{ overflowY: 'auto', maxHeight: '70vh' }}
            >
              <Container className="mt-3">
                <Row className="justify-content-center">
                  <Col md={8} lg={6}>
                    <Form onSubmit={newPlayerSubmit}>
                      <Form.Group className="mb-3">
                        <Form.Label className="text-light">Select New Player</Form.Label>
                        <Form.Select
                          onChange={(e) => setPlayersSearch(e.target.value)}
                          value={playersSearch}
                          type="text"
                        >
                          <option value="" disabled>
                            Select Player
                          </option>
                          {players.players && players.players.length > 0 ? (
                            players.players.map((el) => (
                              <option key={el.username} value={el.username}>
                                {el.username}
                              </option>
                            ))
                          ) : (
                            <option>No players available</option>
                          )}
                        </Form.Select>
                      </Form.Group>
                      <div className="text-center pb-2">
                        <Button
                          disabled={!playersSearch}
                          className="rounded-pill"
                          variant="outline-light"
                          type="submit"
                        >
                          Add Player
                        </Button>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </Container>
              <ResourceGrid
                dataTestId="players-resource-grid"
                items={Array.isArray(campaignDM.players) ? campaignDM.players : []}
                emptyMessage="No players added yet."
                getKey={(player, index) => player || index}
                renderItem={(playerName) => (
                  <Card className="resource-card h-100 w-100 text-center">
                    <Card.Body className="d-flex flex-column align-items-center justify-content-center py-4">
                      <div className="d-flex justify-content-center mb-2 w-100">
                        <GiCharacter size={40} title="Player" />
                      </div>
                      <Card.Title className="mb-1">{playerName}</Card.Title>
                      <Card.Text className="text-muted small mb-0">
                        Campaign Member
                      </Card.Text>
                    </Card.Body>
                  </Card>
                )}
              />
              <section className="mt-4 text-start" aria-labelledby="dm-player-characters-heading">
                <h3 id="dm-player-characters-heading" className="h5 text-light mb-3">Player Characters</h3>
                <ResourceGrid
                  dataTestId="characters-resource-grid"
                  items={Array.isArray(records) ? records : []}
                  emptyMessage="No characters found."
                  getKey={(character) => character._id}
                  renderItem={(character, itemIndex) => {
                    const occupation = Array.isArray(character.occupation)
                      ? character.occupation
                      : [];
                    const totalLevel = occupation.reduce(
                      (total, role) => total + (Number(role.Level) || 0),
                      0
                    );
                    const classSummary =
                      occupation.length > 0
                        ? occupation
                            .map((role) => `${role.Level} ${role.Occupation}`)
                            .join(', ')
                        : '—';
  
                    const uniqueClasses = [];
                    const seenClasses = new Set();
                    occupation.forEach((role) => {
                      const rawOccupation =
                        role?.Occupation ?? role?.occupation ?? '';
                      const trimmedOccupation = String(rawOccupation || '').trim();
                      if (!trimmedOccupation) {
                        return;
                      }
  
                      const normalizedKey = trimmedOccupation.toLowerCase();
                      if (seenClasses.has(normalizedKey)) {
                        return;
                      }
  
                      seenClasses.add(normalizedKey);
                      uniqueClasses.push({
                        original: trimmedOccupation,
                        normalizedKey,
                      });
                    });
  
                    const classIcons = (uniqueClasses.length > 0
                      ? uniqueClasses
                      : [{ original: null, normalizedKey: null }]
                    ).map(({ original, normalizedKey }, index) => {
                      const iconEntry =
                        (normalizedKey && CLASS_ICON_MAP[normalizedKey]) ||
                        CLASS_ICON_MAP.default;
                      const IconComponent = iconEntry.icon;
                      const displayLabel = original || iconEntry.label;
                      const accessibleLabel = `${displayLabel} class`;
  
                      return {
                        IconComponent,
                        accessibleLabel,
                        key: `${normalizedKey || 'default'}-${index}`,
                      };
                    });
  
                    const identifierCandidates = [];
                    if (typeof character._id === 'string' && character._id.trim() !== '') {
                      identifierCandidates.push(character._id.trim());
                    }
                    if (
                      typeof character.characterId === 'string' &&
                      character.characterId.trim() !== ''
                    ) {
                      identifierCandidates.push(character.characterId.trim());
                    }
                    const primaryIdentifier = identifierCandidates[0] || `character-${itemIndex}`;
                    const sanitizeIdentifier = (value) =>
                      typeof value === 'string'
                        ? value.replace(/[^0-9A-Za-z_-]/g, '-')
                        : `character-${itemIndex}`;
                    const cardTestId = `character-card-${sanitizeIdentifier(primaryIdentifier)}`;
  
                    const { currentHp: derivedCurrentHp, maxHp: derivedMaxHp } =
                      calculateCharacterHitPoints(character);
                    const fallbackCurrentHp = toFiniteNumberOrNull(
                      character.currentHp ??
                        character.hpCurrent ??
                        character.tempHealth ??
                        character.health
                    );
                    const fallbackMaxHp = toFiniteNumberOrNull(
                      character.maxHp ?? character.hpMax ?? character.health
                    );
                    const normalizedCurrentHp = Number.isFinite(derivedCurrentHp)
                      ? derivedCurrentHp
                      : fallbackCurrentHp;
                    const normalizedMaxHp = Number.isFinite(derivedMaxHp)
                      ? derivedMaxHp
                      : fallbackMaxHp;
                    const normalizedTempHp = toFiniteNumberOrNull(character.tempHealth);
  
                    const cardDataAttributes = {
                      'data-testid': cardTestId,
                      ...(typeof primaryIdentifier === 'string'
                        ? { 'data-character-id': primaryIdentifier }
                        : {}),
                      ...(normalizedCurrentHp !== null
                        ? { 'data-current-hp': normalizedCurrentHp }
                        : {}),
                      ...(normalizedMaxHp !== null ? { 'data-max-hp': normalizedMaxHp } : {}),
                      ...(normalizedTempHp !== null ? { 'data-temp-hp': normalizedTempHp } : {}),
                    };
  
                    const detailRows = [
                      { label: 'Level', value: totalLevel },
                      { label: 'Passive Perception', value: getEntityPassivePerception(character) },
                      { label: 'Classes', value: classSummary },
                    ];
  
                    return (
                      <Card
                        className="resource-card h-100 w-100 text-start"
                        {...cardDataAttributes}
                      >
                        <Card.Body className="d-flex flex-column">
                          <div className="d-flex justify-content-center mb-2">
                            <div className="d-flex flex-wrap justify-content-center align-items-center gap-2">
                              {classIcons.map(({ IconComponent, accessibleLabel, key }) => (
                                <span
                                  key={key}
                                  className="d-inline-flex align-items-center text-primary"
                                  role="img"
                                  aria-label={accessibleLabel}
                                  title={accessibleLabel}
                                >
                                  <IconComponent aria-hidden="true" focusable="false" size={26} />
                                </span>
                              ))}
                            </div>
                          </div>
                          <Card.Title className="mb-1">
                            {character.characterName || 'Unnamed Character'}
                          </Card.Title>
                          <Card.Subtitle className="text-muted small mb-2">
                            Player: {character.token || '—'}
                          </Card.Subtitle>
                            <div className="d-grid gap-1">
                              {detailRows.map(({ label, value }) => {
                                const displayValue =
                                  value || value === 0 ? value : '—';
                                return (
                                  <Card.Text
                                    key={label}
                                    className="small mb-1 text-body fw-semibold text-break"
                                  >
                                    <span className="visually-hidden">{`${label}: ${displayValue}`}</span>
                                    <span
                                      className="text-muted text-uppercase fw-semibold me-1"
                                      aria-hidden="true"
                                    >
                                      {`${label}:`}
                                    </span>
                                    <span aria-hidden="true" className="text-break">
                                      {displayValue}
                                    </span>
                                  </Card.Text>
                                );
                              })}
                            </div>
                        </Card.Body>
                        <Card.Footer className="d-flex flex-wrap gap-2 justify-content-end">
                          <Button
                            size="sm"
                            variant="secondary"
                            className="rounded-pill"
                            onClick={() => openCurrencyModal(character)}
                            aria-label={`Adjust currency for ${
                              character.characterName || character.token || 'this character'
                            }`}
                          >
                            Adjust Currency
                          </Button>
                          <Button
                            size="sm"
                            variant="outline-primary"
                            className="rounded-pill"
                            onClick={() => navigateToCharacter(character._id)}
                          >
                            View Sheet
                          </Button>
                        </Card.Footer>
                      </Card>
                    );
                  }}
                />
              </section>
              <CustomPlayerTokens campaignId={currentCampaign} />
            </Card.Body>
          </Card>
        </div>
      )}
            </Modal.Body>
      </Modal>
      <MapLibraryModal
        show={activeResourceTab === 'map'}
        onHide={() => handleCloseResourceTab('map')}
        loading={mapLoading}
        status={status}
        onDismissStatus={() => setStatus(null)}
        groupedMaps={groupedMaps}
        folderExpansion={mapFolderExpansion}
        onToggleFolder={handleToggleMapFolder}
        activeMapId={normalizedActiveMapId}
        selectedMap={librarySelectedMap}
        onSelectMap={handleSelectMap}
        onActivateMap={handleActivateMap}
        onDeleteMap={handleDeleteMap}
        actionLoadingId={mapActionLoadingId}
        board={displayedMap ? (
          <CampaignMapBoard fogView="dm" campaignId={campaignId} combatState={combatState} onCombatChange={setCombatState} onMapReconciled={applyMapPayload}
            persistentEffects={combatState.activeEffects}
            map={displayedMap}
            tokens={boardTokens}
            disabled={!shouldShowCampaignTokens}
            allowWheelZoom
            onTokenPositionChange={shouldShowCampaignTokens ? handleTokenPositionChange : undefined}
            onTokenRemove={handleMapTokenRemove}
            onToggleCombat={handleMapToggleCombat}
          />
        ) : null}
        editor={mapLibraryEditor}
        draft={generatedMap}
        onDiscardDraft={() => setGeneratedMap(null)}
        prompt={mapPrompt}
        onPromptChange={setMapPrompt}
        lighting={mapLighting}
        onLightingChange={setMapLighting}
        generating={mapGenerating}
        onGenerate={handleGenerateMap}
        onOpenMapMaker={() => setShowMapMaker(true)}
        onSaveDraft={({ replaceMapId, ...options }) => (replaceMapId
          ? handleSaveMap('update', { replaceMapId })
          : handleSaveMap('create', options))}
        saving={mapSaving}
        saveMode={mapSaveMode}
        campaignReady={Boolean(campaignId)}
      />
          <Modal
        show={activeResourceTab === 'enemies'}
        onHide={() => handleCloseResourceTab('enemies')}
        size="xl"
        scrollable
        centered
        className="dnd-modal zombies-dm-resource-modal"
      >
        <Modal.Header closeButton className="flex-wrap gap-2">
          <Modal.Title>Enemies</Modal.Title>
          <div className="d-flex flex-wrap gap-2 ms-auto me-3">
            <Button variant="outline-light" size="sm" onClick={() => setShowCustomMonsterManager(true)}>
              View Custom Monsters
            </Button>
            <Button
              variant="outline-light"
              size="sm"
              onClick={() => { setCustomMonsterCopySource(null); setShowCustomMonsterEditor(true); }}
            >
              Create Custom Monster
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
      {activeResourceTab === 'enemies' && (
        <div className="text-center">
          <Card className="modern-card" data-testid="resource-enemies-card">
            
            <Card.Body
              className="resource-tab-safe-area"
              style={{ overflowY: 'auto', maxHeight: '70vh' }}
            >
              <Container className="mt-3">
                <Form.Group className="mb-3"><Form.Label>Show disposition</Form.Label>
                  <Form.Select aria-label="Filter creatures by disposition" value={npcDispositionFilter} onChange={event=>setNpcDispositionFilter(event.target.value)}>
                    <option value="all">All creatures</option><option value="enemy">Enemies</option><option value="neutral">Neutrals</option><option value="ally">Allies</option>
                  </Form.Select></Form.Group>
                <Form.Check className="mb-3" type="switch" id="enemy-show-all-maps" label="Show all maps" checked={showAllMapEnemies} onChange={event=>setShowAllMapEnemies(event.target.checked)}/>
                <Form onSubmit={handleAddEnemy}>
                  <Row className="g-3 align-items-end">
                    <Col md={6} lg={4}>
                      <Form.Group className="mb-3 mb-md-0">
                        <Form.Label className="text-light">Search Monsters</Form.Label>
                        <Form.Control
                          type="text"
                          value={monsterSearch}
                          onChange={(e) => setMonsterSearch(e.target.value)}
                          placeholder="Search by name"
                          disabled={monsterCatalogLoading && !monsterCatalogLoaded}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} lg={4}>
                      <Form.Group className="mb-3 mb-md-0">
                        <Form.Label className="text-light">Challenge Rating</Form.Label>
                        <div className="d-flex flex-column flex-lg-row gap-2">
                          <Form.Select
                            value={monsterMinChallengeRating}
                            onChange={(event) => setMonsterMinChallengeRating(event.target.value)}
                            disabled={monsterCatalogLoading && !monsterCatalogLoaded}
                            aria-label="Minimum challenge rating"
                          >
                            <option value="">No minimum</option>
                            {challengeRatingOptions.map((option) => (
                              <option key={`min-${option.value}`} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Select
                            value={monsterMaxChallengeRating}
                            onChange={(event) => setMonsterMaxChallengeRating(event.target.value)}
                            disabled={monsterCatalogLoading && !monsterCatalogLoaded}
                            aria-label="Maximum challenge rating"
                          >
                            <option value="">No maximum</option>
                            {challengeRatingOptions.map((option) => (
                              <option key={`max-${option.value}`} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </Form.Select>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={12} lg={4}>
                      <Form.Group controlId="monster-select">
                        <Form.Label className="text-light">Select Monster</Form.Label>
                        <Form.Select
                          value={selectedMonsterIndex}
                          onChange={handleMonsterSelectChange}
                          disabled={monsterCatalogLoading && !monsterCatalogLoaded}
                        >
                          <option value="" disabled>
                            {monsterCatalogLoading && !monsterCatalogLoaded
                              ? 'Loading monsters...'
                              : 'Select Monster'}
                          </option>
                          {filteredMonsterCatalog.length > 0 ? (
                            [
                              ...(!filteredMonsterCatalog.some((monster) => monster.index === selectedMonsterIndex)
                                ? monsterCatalog.filter((monster) => monster.index === selectedMonsterIndex)
                                : []),
                              ...filteredMonsterCatalog,
                            ].map((monster) => (
                              <option key={monster.index} value={monster.index}>
                                {monster.name}{monster.source === 'custom' || monster.custom ? ' (Custom)' : ''}
                              </option>
                            ))
                          ) : (
                            monsterCatalogLoaded && (
                              <option value="" disabled>
                                No monsters match your filters
                              </option>
                            )
                          )}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="g-3 align-items-end mt-0">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="text-light">Custom Name (optional)</Form.Label>
                        <Form.Control
                          type="text"
                          value={customEnemyName}
                          onChange={(e) => setCustomEnemyName(e.target.value)}
                          placeholder="Override monster name"
                          disabled={!selectedMonsterIndex}
                        />
                      </Form.Group>
                      <div className="d-flex flex-column align-items-start mt-3 gap-2">
                        <Button
                          variant="outline-light"
                          size="sm"
                          onClick={handleOpenEnemyTokenPicker}
                          disabled={!selectedMonsterIndex}
                        >
                          {enemyTokenSelection?.figurineImageUrl || enemyTokenSelection?.figurineImagePublicId
                            ? 'Change Token'
                            : 'Choose Token'}
                        </Button>
                        {enemyTokenSelection?.figurineImageUrl ? (
                          <img
                            src={enemyTokenSelection.figurineImageUrl}
                            alt="Selected enemy token"
                            style={{ maxHeight: '96px', maxWidth: '96px', objectFit: 'contain' }}
                          />
                        ) : null}
                      </div>
                    </Col>
                    <Col md={6} className="d-flex justify-content-center justify-content-md-end">
                      <div className="d-flex flex-column flex-md-row gap-2 mt-3 mt-md-0">
                        <Button
                          type="submit" value="enemy"
                          variant="outline-light"
                          className="rounded-pill"
                          disabled={!selectedMonsterIndex || addingEnemy}
                        >
                          {addingEnemy && (
                            <Spinner
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                              className="me-2"
                            />
                          )}
                          Add Enemy
                        </Button>
                        <Button type="button" onClick={event=>handleAddEnemy(event,'neutral')} value="neutral" variant="outline-warning" disabled={!selectedMonsterIndex || addingEnemy}>Add Neutral</Button>
                        <Button type="button" onClick={event=>handleAddEnemy(event,'ally')} value="ally" variant="outline-success" disabled={!selectedMonsterIndex || addingEnemy}>Add Ally</Button>
                        <Button
                          type="button"
                          variant="outline-light"
                          className="rounded-pill"
                          onClick={() => setShowDiceRoller(true)}
                        >
                          Roll
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
                {monsterCatalogError && (
                  <div className="text-warning small mt-3">
                    {monsterCatalogError}{' '}
                    <Button
                      variant="outline-light"
                      size="sm"
                      onClick={() => fetchMonsterCatalog()}
                      disabled={monsterCatalogLoading}
                    >
                      Retry
                    </Button>
                  </div>
                )}
                <div className="mt-3">
                  {monsterDetailLoading ? (
                    <div className="text-light text-center">
                      <Spinner animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                      Loading monster details...
                    </div>
                  ) : selectedMonster ? (
                    <Card className="bg-dark border border-secondary text-start text-light mt-3">
                      <Card.Body>
                        <Card.Title className="h5 mb-1 text-light">{selectedMonster.name}</Card.Title>
                        <Card.Subtitle className="text-white-50 small mb-3">
                          {[selectedMonster.size, selectedMonster.type].filter(Boolean).join(' ') || '—'}
                          {selectedMonster.challengeRating !== null && selectedMonster.challengeRating !== undefined
                            ? ` • CR ${formatChallengeRatingValue(selectedMonster.challengeRating)}`
                            : ''}
                        </Card.Subtitle>
                        <div className="mb-3">
                          {selectedMonster.source === 'custom' && <Badge bg="info" text="dark" className="me-2">Custom</Badge>}
                          <Button
                            type="button"
                            variant="outline-light"
                            size="sm"
                            onClick={() => { setCustomMonsterCopySource(selectedMonster); setShowCustomMonsterEditor(true); }}
                          >
                            Copy as Custom
                          </Button>
                        </div>
                        <div className="d-grid gap-1">
                          <Card.Text className="small mb-1 text-light fw-semibold text-break">
                            <span
                              className="text-white-50 text-uppercase fw-semibold me-1"
                              aria-hidden="true"
                            >
                              Size:
                            </span>
                            <span aria-hidden="true">
                              {selectedMonster.size || selectedMonster.type || '—'}
                            </span>
                          </Card.Text>
                          <Card.Text className="small mb-1 text-light fw-semibold text-break">
                            <span className="text-white-50 text-uppercase fw-semibold me-1" aria-hidden="true">
                              AC:
                            </span>
                            <span aria-hidden="true">{formatArmorClass(selectedMonster.armorClass)}</span>
                          </Card.Text>
                          <Card.Text className="small mb-1 text-light fw-semibold text-break">
                            <span className="text-white-50 text-uppercase fw-semibold me-1" aria-hidden="true">
                              HP:
                            </span>
                            <span aria-hidden="true">{selectedMonster.hitPoints ?? '—'}</span>
                          </Card.Text>
                          <Card.Text className="small mb-1 text-light fw-semibold text-break">
                            <span className="text-white-50 text-uppercase fw-semibold me-1" aria-hidden="true">
                              Hit Dice:
                            </span>
                            <span aria-hidden="true">{selectedMonster.hitDice || '—'}</span>
                          </Card.Text>
                          <Card.Text className="small mb-1 text-light fw-semibold text-break">
                            <span className="text-white-50 text-uppercase fw-semibold me-1" aria-hidden="true">
                              Speed:
                            </span>
                            <span aria-hidden="true">{formatSpeed(selectedMonster.speed)}</span>
                          </Card.Text>
                          <Card.Text className="small mb-1 text-light fw-semibold text-break">
                            <span className="text-white-50 text-uppercase fw-semibold me-1" aria-hidden="true">
                              Alignment:
                            </span>
                            <span aria-hidden="true">{selectedMonster.alignment || '—'}</span>
                          </Card.Text>
                          <Card.Text className="small mb-1 text-light fw-semibold text-break">
                            <span className="text-white-50 text-uppercase fw-semibold me-1" aria-hidden="true">
                              Languages:
                            </span>
                            <span aria-hidden="true">
                              {Array.isArray(selectedMonster.languages)
                                ? selectedMonster.languages.join(', ')
                                : selectedMonster.languages || '—'}
                            </span>
                          </Card.Text>
                        </div>
                        <div className="mt-3">
                          <h6 className="text-uppercase text-muted small fw-semibold mb-1">Abilities</h6>
                          <div className="d-flex flex-wrap gap-2">
                            {STAT_KEYS_ORDER.map((key) => (
                              <span key={`preview-${key}`} className="badge bg-secondary">
                                {formatAbilityScore(key, selectedMonster?.abilityScores?.[key])}
                              </span>
                            ))}
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  ) : null}
                </div>
              </Container>
              <ResourceGrid
                dataTestId="enemies-resource-grid"
                items={enemiesForPanel(normalizedEnemies, enemyMapId, showAllMapEnemies).filter(enemy=>npcDispositionFilter==='all'||dispositionOf(enemy)===npcDispositionFilter)}
                emptyMessage={showAllMapEnemies ? 'No enemies added yet.' : 'No enemies on this map.'}
                getKey={(enemy) => enemy.enemyId}
                renderItem={(enemy) => {
                  const participantInfo = enemy.enemyId ? participantLookup.get(enemy.enemyId) : undefined;
                  const inCombat = Boolean(participantInfo);
                  const challengeText =
                    enemy.challengeRating !== null && enemy.challengeRating !== undefined
                      ? `CR ${formatChallengeRatingValue(enemy.challengeRating)}`
                      : null;
                  const languagesDisplay = Array.isArray(enemy.languages)
                    ? enemy.languages.join(', ')
                    : enemy.languages || '—';
                  const maxHpValue = toFiniteNumberOrNull(enemy.maxHp ?? enemy.hitPoints);
                  const currentHpCandidate =
                    enemy.currentHp !== undefined
                      ? toFiniteNumberOrNull(enemy.currentHp)
                      : null;
                  const resolvedCurrentHp =
                    currentHpCandidate !== null
                      ? currentHpCandidate
                      : maxHpValue !== null
                        ? maxHpValue
                        : null;
                  const sizeDisplay = enemy.size || enemy.displayType || '—';
                  const healthSummary =
                    maxHpValue !== null
                      ? `${resolvedCurrentHp !== null ? resolvedCurrentHp : '—'} / ${maxHpValue}`
                      : resolvedCurrentHp !== null
                        ? `${resolvedCurrentHp}`
                        : '—';
                  const damagingActions = Array.isArray(enemy.actions)
                    ? enemy.actions.filter((action) => Boolean(getEnemyActionDamageString(action)) || isMultiattackAction(action))
                    : [];
                  const armorClassDisplay = formatArmorClass(resolveCombatantArmorClass({ ...enemy, entityType: 'enemy' }, { combatState, targetCombatantId: enemy.enemyId || enemy._id }));
                  const speedDisplay = formatSpeed(getEffectiveMovement(enemy.speed, combatState, enemy.enemyId));
                  const alignmentDisplay = enemy.alignment || '—';
                  const savingThrowsDisplay = formatSavingThrowsDisplay(enemy.savingThrows);
                  const skillsDisplay = formatSkillsDisplay(enemy.skills);
                  const sightRange = effectiveDarkvision(enemy, combatState, enemy.enemyId || enemy._id);
                  const sensesDisplay = [formatSensesDisplay(enemy.senses), sightRange > 0 ? `Darkvision ${sightRange} ft` : ''].filter(Boolean).join(' · ');
                  const xpDisplay = formatXpDisplay(enemy.xp);
                  const damageVulnerabilitiesDisplay = formatDamageTraitsDisplay(
                    enemy.damageVulnerabilities
                  );
                  const damageResistancesDisplay = formatDamageTraitsDisplay(enemy.damageResistances);
                  const damageImmunitiesDisplay = formatDamageTraitsDisplay(enemy.damageImmunities);
                  const conditionImmunitiesDisplay = formatDamageTraitsDisplay(enemy.conditionImmunities);
                  const abilityScoreBadges = STAT_KEYS_ORDER.map((key) => ({
                    key,
                    value: formatAbilityScore(key, enemy?.abilityScores?.[key]),
                  }));
                  const actionsList = Array.isArray(enemy.actions) ? enemy.actions : [];
                  const bonusActionsList = Array.isArray(enemy.bonusActions)
                    ? enemy.bonusActions
                    : [];
                  const reactionsList = Array.isArray(enemy.reactions) ? enemy.reactions : [];
                  const legendaryActionsList = Array.isArray(enemy.legendaryActions)
                    ? enemy.legendaryActions
                    : [];

                  return (
                    <EnemyCard
                      enemy={enemy}
                      inCombat={inCombat}
                      challengeText={challengeText}
                      sizeDisplay={sizeDisplay}
                      armorClassDisplay={armorClassDisplay}
                      maxHpValue={maxHpValue}
                      resolvedCurrentHp={resolvedCurrentHp}
                      healthSummary={healthSummary}
                      languagesDisplay={languagesDisplay}
                      alignmentDisplay={alignmentDisplay}
                      speedDisplay={speedDisplay}
                      activeEffects={getActiveConditionsForCombatant(enemy.enemyId, combatState, (id) => {
                        const source = normalizedEnemies.find((candidate) => candidate.enemyId === id);
                        return combatantLabel(source, { dm: true, fallback: combatState.participants.find((participant) => participant.characterId === id)?.displayName || '' });
                      })}
                      savingThrowsDisplay={savingThrowsDisplay}
                      skillsDisplay={skillsDisplay}
                      sensesDisplay={sensesDisplay}
                      xpDisplay={xpDisplay}
                      damageVulnerabilitiesDisplay={damageVulnerabilitiesDisplay}
                      damageResistancesDisplay={damageResistancesDisplay}
                      damageImmunitiesDisplay={damageImmunitiesDisplay}
                      conditionImmunitiesDisplay={conditionImmunitiesDisplay}
                      abilityScoreBadges={abilityScoreBadges}
                      damagingActions={damagingActions}
                      actionsList={actionsList}
                      bonusActionsList={bonusActionsList}
                      reactionsList={reactionsList}
                      legendaryActionsList={legendaryActionsList}
                      latestEnemyRoll={latestEnemyRoll}
                      onEnemyDamageRoll={handleEnemyDamageRoll}
                      onEnemyAttackRoll={beginEnemyTargeting}
                      onEnemyMultiattackRoll={handleEnemyMultiattackRoll}
                      onEnemySaveAction={beginEnemySaveTargeting}
                      onEnemyAdjustmentInputChange={handleEnemyAdjustmentInputChange}
                      onApplyEnemyHealthAdjustment={handleApplyEnemyHealthAdjustment}
                      onResetEnemyHealth={handleResetEnemyHealth}
                      enemyHealthAdjustments={enemyHealthAdjustments}
                      enemyHealthSaving={enemyHealthSaving}
                      onToggleParticipant={handleToggleParticipant}
                      onOpenMapPlacement={handleOpenMapPlacement}
          onChangeDisposition={handleChangeDisposition}
                      mapTag={enemyMapTag(enemy, enemyMapId, normalizedMaps)}
                      onMoveToMap={handleMoveEnemyToMap}
                      onRemoveEnemy={handleRemoveEnemy}
                      removingEnemyId={removingEnemyId}
                      formatAttackBonus={formatAttackBonus}
                      getEnemyActionDamageString={getEnemyActionDamageString}
                    />
                  );
                }}
              />
            </Card.Body>
          </Card>
        </div>
      )}
            </Modal.Body>
      </Modal>
      <CustomMonsterEditor
        show={showCustomMonsterEditor}
        copyFrom={customMonsterCopySource}
        campaignId={params.campaign}
        onHide={() => { setShowCustomMonsterEditor(false); setCustomMonsterCopySource(null); }}
        onSaved={handleCustomMonsterSaved}
      />
      <CustomMonsterManager
        show={showCustomMonsterManager}
        onHide={() => setShowCustomMonsterManager(false)}
        onDeleted={handleCustomMonsterDeleted}
      />
          <Modal
        show={activeResourceTab === 'weapons'}
        onHide={() => handleCloseResourceTab('weapons')}
        size="xl"
        scrollable
        centered
        className="dnd-modal zombies-dm-resource-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Weapons</Modal.Title>
        </Modal.Header>
        <Modal.Body>
      {activeResourceTab === 'weapons' && (
        <div className="text-center">
          <Card className="modern-card" data-testid="resource-weapons-card">
            
            <Card.Body
              className="resource-tab-safe-area"
              style={{ overflowY: 'auto', maxHeight: '70vh' }}
            >
              <div className="text-center">
                {!isCreatingWeapon && (
                  <div className="d-flex flex-wrap justify-content-end gap-2 mb-3">
                    <Button
                      variant="outline-primary"
                      type="button"
                      onClick={() => setIsCreatingWeapon(true)}
                      className="d-inline-flex align-items-center"
                    >
                      <FiPlus aria-hidden="true" className="me-2" />
                      Create Weapon
                    </Button>
                  </div>
                )}
                {isCreatingWeapon ? (
                  <Form onSubmit={onSubmit2} className="px-5">
                    <Form.Group className="mb-3 pt-3">
                      <Form.Label className="text-light">Weapon Prompt</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={weaponPrompt}
                        onChange={(e) => setWeaponPrompt(e.target.value)}
                        type="text"
                        placeholder="Describe a weapon"
                      />
                      <Button
                        className="mb-3"
                        variant="outline-primary"
                        onClick={(e) => {
                          e.preventDefault();
                          generateWeapon();
                        }}
                        disabled={loading}
                      >
                        {loading ? (
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        ) : (
                          'Generate with AI'
                        )}
                      </Button>
                      <br></br>
                      <Form.Label className="text-light">Name</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={form2.name}
                        onChange={(e) => updateForm2({ name: e.target.value })}
                        type="text"
                        placeholder="Enter weapon name"
                      />

                      <Form.Label className="text-light">Type</Form.Label>
                      <Form.Select
                        className="mb-2"
                        value={form2.type}
                        onChange={(e) => updateForm2({ type: e.target.value })}
                      >
                        <option value="">Select type</option>
                        {weaponOptions.types.map((t) => (
                          <option key={t} value={t}>
                            {t}
                          </option>
                        ))}
                      </Form.Select>

                      <Form.Label className="text-light">Category</Form.Label>
                      <Form.Select
                        className="mb-2"
                        value={form2.category}
                        onChange={(e) => updateForm2({ category: e.target.value })}
                      >
                        <option value="">Select category</option>
                        {weaponOptions.categories.map((c) => (
                          <option key={c} value={c}>
                            {c}
                          </option>
                        ))}
                      </Form.Select>

                      <Form.Label className="text-light">Damage</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={form2.damage}
                        onChange={(e) => updateForm2({ damage: e.target.value })}
                        type="text"
                        placeholder="Enter damage"
                      />

                      <Form.Label className="text-light">Properties</Form.Label>
                      <Form.Select
                        multiple
                        className="mb-2"
                        value={form2.properties}
                        onChange={(e) => {
                          const selected = Array.from(e.target.selectedOptions, (opt) => opt.value);
                          updateForm2({ properties: selected });
                        }}
                      >
                        {weaponOptions.properties.map((p) => (
                          <option key={p} value={p}>
                            {p}
                          </option>
                        ))}
                      </Form.Select>

                      <Form.Label className="text-light">Weight</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={form2.weight}
                        onChange={(e) =>
                          updateForm2({ weight: e.target.value === '' ? '' : Number(e.target.value) })
                        }
                        type="number"
                        placeholder="Enter weight"
                      />

                      <Form.Label className="text-light">Cost</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={form2.cost}
                        onChange={(e) =>
                          updateForm2({ cost: e.target.value === '' ? '' : Number(e.target.value) })
                        }
                        type="number"
                        placeholder="Enter cost"
                      />
                    </Form.Group>
                    <div className="text-center">
                      <Button variant="primary" type="submit">
                        Create
                      </Button>
                      <Button className="ms-4" variant="secondary" onClick={() => setIsCreatingWeapon(false)}>
                        Cancel
                      </Button>
                    </div>
                  </Form>
                ) : (
                  <ResourceGrid
                    dataTestId="weapons-resource-grid"
                    items={Array.isArray(weapons) ? weapons : []}
                    emptyMessage="No weapons created yet."
                    getKey={(weapon) => weapon._id}
                    renderItem={(weapon) => {
                      const Icon = resolveIcon(
                        weapon.category,
                        weaponCategoryIcons,
                        GiCrossedSwords
                      );
                      const detailRows = [
                        { label: 'Type', value: weapon.type || '—' },
                        { label: 'Category', value: weapon.category || '—' },
                        { label: 'Damage', value: weapon.damage || '—' },
                        {
                          label: 'Properties',
                          value: weapon.properties?.length
                            ? weapon.properties.join(', ')
                            : '—',
                        },
                        { label: 'Weight', value: weapon.weight ?? '—' },
                        { label: 'Cost', value: weapon.cost ?? '—' },
                      ];

                      return (
                        <Card className="weapon-card h-100 w-100 text-start">
                          <Card.Body className="d-flex flex-column">
                            <div className="d-flex justify-content-center mb-2">
                              <Icon size={40} title={weapon.category || 'Weapon'} />
                            </div>
                            <Card.Title className="mb-2">{weapon.name}</Card.Title>
                            <div className="d-grid gap-1">
                              {detailRows.map(({ label, value }) => {
                                const displayValue =
                                  value || value === 0 ? value : '—';
                                return (
                                  <Card.Text
                                    key={label}
                                    className="small mb-1 text-body fw-semibold text-break"
                                  >
                                    <span className="visually-hidden">{`${label}: ${displayValue}`}</span>
                                    <span
                                      className="text-muted text-uppercase fw-semibold me-1"
                                      aria-hidden="true"
                                    >
                                      {`${label}:`}
                                    </span>
                                    <span aria-hidden="true" className="text-break">
                                      {displayValue}
                                    </span>
                                  </Card.Text>
                                );
                              })}
                            </div>
                          </Card.Body>
                          <Card.Footer className="d-flex justify-content-end">
                            <Button
                              className="btn-danger action-btn fa-solid fa-trash"
                              onClick={() => deleteWeapon(weapon._id)}
                              aria-label={`Delete ${weapon.name || 'weapon'}`}
                              title="Delete weapon"
                            />
                          </Card.Footer>
                        </Card>
                      );
                    }}
                  />
                )}
              </div>
            </Card.Body>
          </Card>
        </div>
      )}
            </Modal.Body>
      </Modal>
          <Modal
        show={activeResourceTab === 'armor'}
        onHide={() => handleCloseResourceTab('armor')}
        size="xl"
        scrollable
        centered
        className="dnd-modal zombies-dm-resource-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Armor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
      {activeResourceTab === 'armor' && (
        <div className="text-center">
          <Card className="modern-card" data-testid="resource-armor-card">
            
            <Card.Body
              className="resource-tab-safe-area"
              style={{ maxHeight: '70vh', overflowY: 'auto' }}
            >
              <div className="text-center">
                {!isCreatingArmor && (
                  <div className="d-flex flex-wrap justify-content-end gap-2 mb-3">
                    <Button
                      variant="outline-primary"
                      type="button"
                      onClick={() => setIsCreatingArmor(true)}
                      className="d-inline-flex align-items-center"
                    >
                      <FiPlus aria-hidden="true" className="me-2" />
                      Create Armor
                    </Button>
                  </div>
                )}
                {isCreatingArmor ? (
                  <Form onSubmit={onSubmit3} className="px-5">
                    <Form.Group className="mb-3 pt-3">
                      <Form.Label className="text-light">Armor Prompt</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={armorPrompt}
                        onChange={(e) => setArmorPrompt(e.target.value)}
                        type="text"
                        placeholder="Describe armor"
                      />
                      <Button
                        className="mb-3"
                        variant="outline-primary"
                        onClick={(e) => {
                          e.preventDefault();
                          generateArmor();
                        }}
                        disabled={armorLoading}
                      >
                        {armorLoading ? (
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        ) : (
                          'Generate Armor'
                        )}
                      </Button>
                      <br></br>
                      <Form.Label className="text-light">Name</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={form3.armorName}
                        onChange={(e) => updateForm3({ armorName: e.target.value })}
                        type="text"
                        placeholder="Enter armor name"
                      />

                      <Form.Label className="text-light">Type</Form.Label>
                      <Form.Select
                        className="mb-2"
                        value={form3.type}
                        onChange={(e) => updateForm3({ type: e.target.value })}
                      >
                        <option value="">Select type</option>
                        {armorOptions.types.map((t) => (
                          <option key={t} value={t}>
                            {t}
                          </option>
                        ))}
                      </Form.Select>

                      <Form.Label className="text-light">Category</Form.Label>
                      <Form.Select
                        className="mb-2"
                        value={form3.category}
                        onChange={(e) => updateForm3({ category: e.target.value })}
                      >
                        <option value="">Select category</option>
                        {armorOptions.categories.map((c) => (
                          <option key={c} value={c}>
                            {c}
                          </option>
                        ))}
                      </Form.Select>

                      <Form.Label className="text-light">Slot</Form.Label>
                      <Form.Select
                        className="mb-2"
                        value={form3.slot}
                        onChange={(e) => updateForm3({ slot: e.target.value })}
                      >
                        <option value="">Select slot</option>
                        {armorOptions.slots.map((slot) => (
                          <option key={slot.key} value={slot.key}>
                            {slot.label}
                          </option>
                        ))}
                      </Form.Select>

                      <Form.Label className="text-light">AC Bonus</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={form3.armorBonus}
                        onChange={(e) => updateForm3({ armorBonus: e.target.value })}
                        type="text"
                        placeholder="Enter AC Bonus"
                      />

                      <Form.Label className="text-light">Max Dex Bonus</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={form3.maxDex}
                        onChange={(e) => updateForm3({ maxDex: e.target.value })}
                        type="text"
                        placeholder="Enter Max Dex Bonus"
                      />

                      <Form.Label className="text-light">Strength Requirement</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={form3.strength}
                        onChange={(e) => updateForm3({ strength: e.target.value })}
                        type="text"
                        placeholder="Enter Strength Requirement"
                      />

                      <Form.Label className="text-light">Stealth</Form.Label>
                      <Form.Select
                        className="mb-2"
                        value={form3.stealth}
                        onChange={(e) => updateForm3({ stealth: e.target.value })}
                      >
                        <option value="">Select option</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </Form.Select>

                      <Form.Label className="text-light">Weight</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={form3.weight}
                        onChange={(e) => updateForm3({ weight: e.target.value })}
                        type="text"
                        placeholder="Enter Weight"
                      />

                      <Form.Label className="text-light">Cost</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={form3.cost}
                        onChange={(e) => updateForm3({ cost: e.target.value })}
                        type="text"
                        placeholder="Enter Cost"
                      />
                    </Form.Group>
                    <div className="text-center">
                      <Button variant="primary" type="submit">
                        Create
                      </Button>
                      <Button className="ms-4" variant="secondary" onClick={() => setIsCreatingArmor(false)}>
                        Cancel
                      </Button>
                    </div>
                  </Form>
                ) : (
                  <ResourceGrid
                    dataTestId="armor-resource-grid"
                    items={Array.isArray(armor) ? armor : []}
                    emptyMessage="No armor created yet."
                    getKey={(piece) => piece._id}
                    renderItem={(piece) => {
                      const acBonus = piece.armorBonus ?? piece.acBonus ?? piece.ac ?? '—';
                      const maxDex = piece.maxDex ?? '—';
                      const slotLabel = getArmorSlotLabel(piece);
                      const Icon = resolveIcon(
                        piece.category,
                        armorCategoryIcons,
                        GiArmorVest
                      );
                      const detailRows = [
                        { label: 'Type', value: piece.type || '—' },
                        { label: 'Category', value: piece.category || '—' },
                        { label: 'AC Bonus', value: acBonus },
                        { label: 'Max Dex', value: maxDex },
                        { label: 'Slot', value: slotLabel },
                        {
                          label: 'Strength',
                          value: piece.strength ?? piece.strRequirement ?? '—',
                        },
                        {
                          label: 'Stealth',
                          value: piece.stealth ? 'Disadvantage' : '—',
                        },
                        { label: 'Weight', value: piece.weight ?? '—' },
                        { label: 'Cost', value: piece.cost ?? '—' },
                      ];

                      return (
                        <Card className="armor-card h-100 w-100 text-start">
                          <Card.Body className="d-flex flex-column">
                            <div className="d-flex justify-content-center mb-2">
                              <Icon size={40} title={piece.category || 'Armor'} />
                            </div>
                            <Card.Title className="mb-2">
                              {piece.armorName ?? piece.name}
                            </Card.Title>
                            <div className="d-grid gap-1">
                              {detailRows.map(({ label, value }) => {
                                const displayValue =
                                  value || value === 0 ? value : '—';
                                return (
                                  <Card.Text
                                    key={label}
                                    className="small mb-1 text-body fw-semibold text-break"
                                  >
                                    <span className="visually-hidden">{`${label}: ${displayValue}`}</span>
                                    <span
                                      className="text-muted text-uppercase fw-semibold me-1"
                                      aria-hidden="true"
                                    >
                                      {`${label}:`}
                                    </span>
                                    <span aria-hidden="true" className="text-break">
                                      {displayValue}
                                    </span>
                                  </Card.Text>
                                );
                              })}
                            </div>
                          </Card.Body>
                          <Card.Footer className="d-flex justify-content-end">
                            <Button
                              className="btn-danger action-btn fa-solid fa-trash"
                              onClick={() => deleteArmor(piece._id)}
                              aria-label={`Delete ${piece.armorName ?? piece.name ?? 'armor'}`}
                              title="Delete armor"
                            />
                          </Card.Footer>
                        </Card>
                      );
                    }}
                  />
                )}
              </div>
            </Card.Body>
          </Card>
        </div>
      )}
            </Modal.Body>
      </Modal>
          <Modal
        show={activeResourceTab === 'accessories'}
        onHide={() => handleCloseResourceTab('accessories')}
        size="xl"
        scrollable
        centered
        className="dnd-modal zombies-dm-resource-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Accessories</Modal.Title>
        </Modal.Header>
        <Modal.Body>
      {activeResourceTab === 'accessories' && (
        <div className="text-center">
          <Card className="modern-card" data-testid="resource-accessories-card">
            
            <Card.Body
              className="resource-tab-safe-area"
              style={{ overflowY: 'auto', maxHeight: '70vh' }}
            >
              <div className="text-center">
                {!isCreatingAccessory && (
                  <div className="d-flex flex-wrap justify-content-end gap-2 mb-3">
                    <Button
                      variant="outline-primary"
                      type="button"
                      onClick={() => setIsCreatingAccessory(true)}
                      className="d-inline-flex align-items-center"
                    >
                      <FiPlus aria-hidden="true" className="me-2" />
                      Create Accessory
                    </Button>
                  </div>
                )}
                {isCreatingAccessory ? (
                  <Form onSubmit={onSubmitAccessory} className="px-5">
                    <Form.Group className="mb-3 pt-3">
                      <Form.Label className="text-light">Accessory Prompt</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={accessoryPrompt}
                        onChange={(e) => setAccessoryPrompt(e.target.value)}
                        type="text"
                        placeholder="Describe an accessory"
                      />
                      <Button
                        className="mb-3"
                        variant="outline-primary"
                        onClick={(e) => {
                          e.preventDefault();
                          generateAccessory();
                        }}
                        disabled={accessoryLoading}
                      >
                        {accessoryLoading ? (
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        ) : (
                          'Generate Accessory'
                        )}
                      </Button>
                      <br></br>
                      <Form.Label className="text-light">Name</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={accessoryForm.name}
                        onChange={(e) => updateAccessoryForm({ name: e.target.value })}
                        type="text"
                        placeholder="Enter accessory name"
                      />

                      <Form.Label className="text-light">Category</Form.Label>
                      <Form.Select
                        className="mb-2"
                        value={accessoryForm.category}
                        onChange={(e) => updateAccessoryForm({ category: e.target.value })}
                      >
                        <option value="">Select category</option>
                        {accessoryOptions.categories.map((c) => (
                          <option key={c} value={c}>
                            {c}
                          </option>
                        ))}
                      </Form.Select>

                      <Form.Label className="text-light">Target Slots</Form.Label>
                      <Form.Select
                        multiple
                        className="mb-2"
                        value={accessoryForm.targetSlots}
                        onChange={(e) => {
                          const selected = Array.from(e.target.selectedOptions, (opt) => opt.value);
                          updateAccessoryForm({ targetSlots: selected });
                        }}
                      >
                        {accessoryOptions.slots.map((slot) => (
                          <option key={slot.key} value={slot.key}>
                            {slot.label}
                          </option>
                        ))}
                      </Form.Select>

                      <Form.Label className="text-light">Rarity</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={accessoryForm.rarity}
                        onChange={(e) => updateAccessoryForm({ rarity: e.target.value })}
                        type="text"
                        placeholder="Enter rarity"
                      />

                      <Form.Label className="text-light">Weight</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={accessoryForm.weight === null ? '' : accessoryForm.weight}
                        onChange={(e) => updateAccessoryForm({ weight: e.target.value === '' ? null : Number(e.target.value) })}
                        type="number"
                        placeholder="Enter weight"
                      />

                      <Form.Label className="text-light">Cost</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={accessoryForm.cost}
                        onChange={(e) => updateAccessoryForm({ cost: e.target.value })}
                        type="text"
                        placeholder="Enter cost"
                      />

                      <Form.Label className="text-light">Notes</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={accessoryForm.notes}
                        onChange={(e) => updateAccessoryForm({ notes: e.target.value })}
                        type="text"
                        placeholder="Enter notes"
                      />

                      <Form.Label className="text-light">Stat Bonuses</Form.Label>
                      {STATS.map(({ key, label }) => (
                        <Form.Control
                          key={key}
                          className="mb-2"
                          type="number"
                          placeholder={label}
                          value={accessoryForm.statBonuses?.[key] ?? ''}
                          onChange={(e) =>
                            updateAccessoryForm({
                              statBonuses: {
                                ...accessoryForm.statBonuses,
                                [key]: e.target.value === '' ? '' : Number(e.target.value),
                              },
                            })
                          }
                        />
                      ))}

                      <Form.Label className="text-light">Skill Bonuses</Form.Label>
                      {SKILLS.map(({ key, label }) => (
                        <Form.Control
                          key={key}
                          className="mb-2"
                          type="number"
                          placeholder={label}
                          value={accessoryForm.skillBonuses?.[key] ?? ''}
                          onChange={(e) =>
                            updateAccessoryForm({
                              skillBonuses: {
                                ...accessoryForm.skillBonuses,
                                [key]: e.target.value === '' ? '' : Number(e.target.value),
                              },
                            })
                          }
                        />
                      ))}
                    </Form.Group>
                    <div className="text-center">
                      <Button variant="primary" type="submit">
                        Create
                      </Button>
                      <Button className="ms-4" variant="secondary" onClick={() => setIsCreatingAccessory(false)}>
                        Cancel
                      </Button>
                    </div>
                  </Form>
                ) : (
                  <ResourceGrid
                    dataTestId="accessories-resource-grid"
                    items={Array.isArray(accessories) ? accessories : []}
                    emptyMessage="No accessories created yet."
                    getKey={(accessory) => accessory._id}
                    renderItem={(accessory) => {
                      const slotLabel = getAccessorySlotLabel(accessory.targetSlots || accessory.slots);
                      const statBonuses = renderBonuses(accessory.statBonuses, STAT_LABELS);
                      const skillBonuses = renderBonuses(accessory.skillBonuses, SKILL_LABELS);
                      const Icon = resolveIcon(
                        accessory.category,
                        accessoryCategoryIcons,
                        GiTreasureMap
                      );
                      const detailRows = [
                        { label: 'Category', value: accessory.category || '—' },
                        { label: 'Slots', value: slotLabel || '—' },
                        { label: 'Rarity', value: accessory.rarity || '—' },
                        { label: 'Weight', value: accessory.weight ?? '—' },
                        { label: 'Cost', value: accessory.cost ?? '—' },
                      ];
                      if (accessory.notes) {
                        detailRows.push({ label: 'Notes', value: accessory.notes });
                      }
                      if (statBonuses) {
                        detailRows.push({ label: 'Stats', value: statBonuses });
                      }
                      if (skillBonuses) {
                        detailRows.push({ label: 'Skills', value: skillBonuses });
                      }

                      return (
                        <Card className="item-card h-100 w-100 text-start">
                          <Card.Body className="d-flex flex-column">
                            <div className="d-flex justify-content-center mb-2">
                              <Icon size={40} title={accessory.category || 'Accessory'} />
                            </div>
                            <Card.Title className="mb-2">{accessory.name}</Card.Title>
                            <div className="d-grid gap-1">
                              {detailRows.map(({ label, value }) => {
                                const displayValue =
                                  value || value === 0 ? value : '—';
                                return (
                                  <Card.Text
                                    key={label}
                                    className="small mb-1 text-body fw-semibold text-break"
                                  >
                                    <span className="visually-hidden">{`${label}: ${displayValue}`}</span>
                                    <span
                                      className="text-muted text-uppercase fw-semibold me-1"
                                      aria-hidden="true"
                                    >
                                      {`${label}:`}
                                    </span>
                                    <span aria-hidden="true" className="text-break">
                                      {displayValue}
                                    </span>
                                  </Card.Text>
                                );
                              })}
                            </div>
                          </Card.Body>
                          <Card.Footer className="d-flex justify-content-end">
                            <Button
                              className="btn-danger action-btn fa-solid fa-trash"
                              onClick={() => deleteAccessory(accessory._id)}
                              aria-label={`Delete ${accessory.name || 'accessory'}`}
                              title="Delete accessory"
                            />
                          </Card.Footer>
                        </Card>
                      );
                    }}
                  />
                )}
              </div>
            </Card.Body>
          </Card>
        </div>
      )}
            </Modal.Body>
      </Modal>
          <Modal
        show={activeResourceTab === 'items'}
        onHide={() => handleCloseResourceTab('items')}
        size="xl"
        scrollable
        centered
        className="dnd-modal zombies-dm-resource-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
      {activeResourceTab === 'items' && (
        <div className="text-center">
          <Card className="modern-card" data-testid="resource-items-card">
            
            <Card.Body
              className="resource-tab-safe-area"
              style={{ overflowY: 'auto', maxHeight: '70vh' }}
            >
              <div className="text-center">
                {!isCreatingItem && (
                  <div className="d-flex flex-wrap justify-content-end gap-2 mb-3">
                    <Button
                      variant="outline-primary"
                      type="button"
                      onClick={() => setIsCreatingItem(true)}
                      className="d-inline-flex align-items-center"
                    >
                      <FiPlus aria-hidden="true" className="me-2" />
                      Create Item
                    </Button>
                  </div>
                )}
                {isCreatingItem ? (
                  <Form onSubmit={onSubmit4} className="px-5">
                    <Form.Group className="mb-3 pt-3">
                      <Form.Label className="text-light">Item Prompt</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={itemPrompt}
                        onChange={(e) => setItemPrompt(e.target.value)}
                        type="text"
                        placeholder="Describe an item"
                      />
                      <Button
                        className="mb-3"
                        variant="outline-primary"
                        onClick={(e) => {
                          e.preventDefault();
                          generateItem();
                        }}
                        disabled={itemLoading}
                      >
                        {itemLoading ? (
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        ) : (
                          'Generate Item'
                        )}
                      </Button>
                      <br></br>
                      <Form.Label className="text-light">Name</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={form4.name}
                        onChange={(e) => updateForm4({ name: e.target.value })}
                        type="text"
                        placeholder="Enter item name"
                      />

                      <Form.Label className="text-light">Category</Form.Label>
                      <Form.Select
                        className="mb-2"
                        value={form4.category}
                        onChange={(e) => updateForm4({ category: e.target.value })}
                      >
                        <option value="">Select category</option>
                        {itemOptions.categories.map((c) => (
                          <option key={c} value={c}>
                            {c}
                          </option>
                        ))}
                      </Form.Select>

                      <Form.Label className="text-light">Weight</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={form4.weight}
                        onChange={(e) => updateForm4({ weight: e.target.value })}
                        type="text"
                        placeholder="Enter weight"
                      />

                      <Form.Label className="text-light">Cost</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={form4.cost}
                        onChange={(e) => updateForm4({ cost: e.target.value })}
                        type="text"
                        placeholder="Enter cost"
                      />

                      <Form.Label className="text-light">Notes</Form.Label>
                      <Form.Control
                        className="mb-2"
                        value={form4.notes}
                        onChange={(e) => updateForm4({ notes: e.target.value })}
                        type="text"
                        placeholder="Enter notes"
                      />

                      <Form.Label className="text-light">Stat Bonuses</Form.Label>
                      {STATS.map(({ key, label }) => (
                        <Form.Control
                          key={key}
                          className="mb-2"
                          type="number"
                          placeholder={label}
                          value={form4.statBonuses[key] ?? ''}
                          onChange={(e) =>
                            updateForm4({
                              statBonuses: {
                                ...form4.statBonuses,
                                [key]: e.target.value === '' ? '' : Number(e.target.value),
                              },
                            })
                          }
                        />
                      ))}

                      <Form.Label className="text-light">Skill Bonuses</Form.Label>
                      {SKILLS.map(({ key, label }) => (
                        <Form.Control
                          key={key}
                          className="mb-2"
                          type="number"
                          placeholder={label}
                          value={form4.skillBonuses[key] ?? ''}
                          onChange={(e) =>
                            updateForm4({
                              skillBonuses: {
                                ...form4.skillBonuses,
                                [key]: e.target.value === '' ? '' : Number(e.target.value),
                              },
                            })
                          }
                        />
                      ))}
                    </Form.Group>
                    <div className="text-center">
                      <Button variant="primary" type="submit">
                        Create
                      </Button>
                      <Button className="ms-4" variant="secondary" onClick={() => setIsCreatingItem(false)}>
                        Cancel
                      </Button>
                    </div>
                  </Form>
                ) : (
                  <ResourceGrid
                    dataTestId="items-resource-grid"
                    items={Array.isArray(items) ? items : []}
                    emptyMessage="No items created yet."
                    getKey={(item) => item._id}
                    renderItem={(item) => {
                      const statBonuses = renderBonuses(item.statBonuses, STAT_LABELS);
                      const skillBonuses = renderBonuses(item.skillBonuses, SKILL_LABELS);
                      const Icon = resolveIcon(item.category, itemCategoryIcons, GiTreasureMap);
                      const detailRows = [
                        { label: 'Category', value: item.category || '—' },
                        { label: 'Weight', value: item.weight ?? '—' },
                        { label: 'Cost', value: item.cost ?? '—' },
                      ];
                      if (statBonuses) {
                        detailRows.push({ label: 'Stats', value: statBonuses });
                      }
                      if (skillBonuses) {
                        detailRows.push({ label: 'Skills', value: skillBonuses });
                      }

                      return (
                        <Card className="item-card h-100 w-100 text-start">
                          <Card.Body className="d-flex flex-column">
                            <div className="d-flex justify-content-center mb-2">
                              <Icon size={40} title={item.category || 'Item'} />
                            </div>
                            <Card.Title className="mb-2">{item.name}</Card.Title>
                            <div className="d-grid gap-1">
                              {detailRows.map(({ label, value }) => {
                                const displayValue =
                                  value || value === 0 ? value : '—';
                                return (
                                  <Card.Text
                                    key={label}
                                    className="small mb-1 text-body fw-semibold text-break"
                                  >
                                    <span className="visually-hidden">{`${label}: ${displayValue}`}</span>
                                    <span
                                      className="text-muted text-uppercase fw-semibold me-1"
                                      aria-hidden="true"
                                    >
                                      {`${label}:`}
                                    </span>
                                    <span aria-hidden="true" className="text-break">
                                      {displayValue}
                                    </span>
                                  </Card.Text>
                                );
                              })}
                            </div>
                            {item.notes ? (
                              <Button
                                variant="link"
                                size="sm"
                                className="p-0 align-self-start mt-2"
                                onClick={() => openItemNote(item.notes)}
                              >
                                View Notes
                              </Button>
                            ) : null}
                          </Card.Body>
                          <Card.Footer className="d-flex justify-content-end">
                            <Button
                              className="btn-danger action-btn fa-solid fa-trash"
                              onClick={() => deleteItem(item._id)}
                              aria-label={`Delete ${item.name || 'item'}`}
                              title="Delete item"
                            />
                          </Card.Footer>
                        </Card>
                      );
                    }}
                  />
                )}
              </div>
            </Card.Body>
          </Card>
        </div>
      )}
            </Modal.Body>
      </Modal>
          <Modal
        show={activeResourceTab === 'shop'}
        onHide={() => handleCloseResourceTab('shop')}
        size="xl"
        scrollable
        centered
        className="dnd-modal zombies-dm-resource-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Shop</Modal.Title>
        </Modal.Header>
        <Modal.Body>
      {activeResourceTab === 'shop' && (
        <div className="text-center">
          <Card className="modern-card" data-testid="resource-shop-card">
            
            <Card.Body
              className="resource-tab-safe-area text-start"
              style={{ overflowY: 'auto', maxHeight: '70vh' }}
            >
              <ShopVisibilityManager
                campaign={currentCampaign}
                active={activeResourceTab === 'shop'}
                onStatus={setStatus}
                characters={Array.isArray(records) ? records : []}
                onInventoryUpdate={fetchRecords}
              />
            </Card.Body>
          </Card>
        </div>
      )}
            </Modal.Body>
      </Modal>
      <Modal show={showMapMaker} onHide={() => setShowMapMaker(false)} fullscreen className="map-maker-modal" aria-labelledby="map-maker-title">
        <Modal.Header closeButton closeVariant="white"><Modal.Title id="map-maker-title">Map Maker</Modal.Title></Modal.Header>
        <Modal.Body>{showMapMaker && <MapMaker campaignId={campaignId} onClose={() => setShowMapMaker(false)}
          onGenerated={(map) => { setGeneratedMap(map); setShowMapMaker(false);
            setStatus({ type: 'success', message: 'Map generated from your layout. Review it, then save it to the library.' }); }} />}</Modal.Body>
      </Modal>
      <TokenPickerModal
        show={showEnemyTokenPicker}
        onHide={handleCloseEnemyTokenPicker}
        campaignId={campaignId || undefined}
        onSelect={handleEnemyTokenSelected}
        filterScope={enemyTokenFilterScope}
        directFolder={enemyTokenDirectFolder || undefined}
        allowClear={Boolean(
          enemyTokenSelection?.figurineImageUrl || enemyTokenSelection?.figurineImagePublicId
        )}
        onClear={() => handleEnemyTokenSelected(null)}
        isDm
      />
      <D20RollerModal
        show={showDiceRoller}
        onHide={() => setShowDiceRoller(false)}
        diceColor={activeDiceColor}
      />

      <Modal
        className="dnd-modal"
        size="sm"
        centered
        show={currencyModalState.show}
        onHide={closeCurrencyModal}
      >
        <Form onSubmit={handleCurrencySubmit}>
          <Modal.Header closeButton>
            <Modal.Title>
              Adjust Currency{currencyModalState.character ? ` - ${currencyModalState.character.characterName}` : ''}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="currencyCopper">
              <Form.Label>Copper</Form.Label>
              <Form.Control
                type="number"
                step="1"
                value={currencyInputs.cp}
                onChange={(event) => updateCurrencyInput('cp', event.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="currencySilver">
              <Form.Label>Silver</Form.Label>
              <Form.Control
                type="number"
                step="1"
                value={currencyInputs.sp}
                onChange={(event) => updateCurrencyInput('sp', event.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="currencyGold">
              <Form.Label>Gold</Form.Label>
              <Form.Control
                type="number"
                step="1"
                value={currencyInputs.gp}
                onChange={(event) => updateCurrencyInput('gp', event.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-0" controlId="currencyPlatinum">
              <Form.Label>Platinum</Form.Label>
              <Form.Control
                type="number"
                step="1"
                value={currencyInputs.pp}
                onChange={(event) => updateCurrencyInput('pp', event.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeCurrencyModal} disabled={currencySubmitting}>
              Cancel
            </Button>
            <Button variant="primary" type="submit" disabled={currencySubmitting}>
              Update Currency
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal className="dnd-modal" centered show={showItemNotes} onHide={closeItemNote}>
        <Card className="dnd-background">
          <Card.Header>
            <Card.Title>Notes</Card.Title>
          </Card.Header>
          <Card.Body>{currentItemNote}</Card.Body>
        </Card>
      </Modal>
    </div>
    </CombatantNamesProvider>
  );
}


